// @ts-nocheck
import { GraphQLClient } from 'graphql-request';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export type AbsenceRequest = {
  __typename?: 'AbsenceRequest';
  approvedBy?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  endsAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isAllDay?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rejectedBy?: Maybe<Scalars['ID']['output']>;
  requestedBy: Scalars['ID']['output'];
  startsAt: Scalars['AWSDateTime']['output'];
  status: AbsenceStatus;
  type?: Maybe<AbsenceType>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export enum AbsenceStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum AbsenceType {
  CareLeave = 'CARE_LEAVE',
  OccasionalLeave = 'OCCASIONAL_LEAVE',
  Other = 'OTHER',
  ParentalLeave = 'PARENTAL_LEAVE',
  SickLeave = 'SICK_LEAVE',
  UnpaidLeave = 'UNPAID_LEAVE',
  Vacation = 'VACATION'
}

export type AddClientDeploy = {
  clientName: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type AdmitResidentInput = {
  accommodatedSince: Scalars['AWSDate']['input'];
  id: Scalars['ID']['input'];
  roomId?: InputMaybe<Scalars['ID']['input']>;
};

export type AllMedicationQueryInput = {
  excludeAfterDate?: InputMaybe<Scalars['AWSDate']['input']>;
  residentId: Scalars['String']['input'];
};

export type ApproveAbsenceRequestInput = {
  id: Scalars['ID']['input'];
  removeConflictingShifts: Scalars['Boolean']['input'];
};

export type ApprovedAt = {
  __typename?: 'ApprovedAt';
  approvedAt: Scalars['AWSDateTime']['output'];
};

export type ApprovedAtInput = {
  approvedAt: Scalars['AWSDateTime']['input'];
};

export type ApprovedConditions = {
  __typename?: 'ApprovedConditions';
  globalPrivacyPolicy?: Maybe<ApprovedAt>;
  globalTermsAndConditions?: Maybe<ApprovedAt>;
  termsAndConditions?: Maybe<ApprovedAt>;
};

export type AuthTokens = {
  __typename?: 'AuthTokens';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type AuthorizedRelativeUser = GenericUser & {
  __typename?: 'AuthorizedRelativeUser';
  approvedConditions?: Maybe<ApprovedConditions>;
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  email: Scalars['String']['output'];
  group: UserGroup;
  id: Scalars['ID']['output'];
  name: PersonName;
  personalNumber: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  residentsId: Array<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userName: Scalars['String']['output'];
};

export type BaseItem = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ChangeQuantityInput = {
  amount: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type ClientWithEntitlements = {
  __typename?: 'ClientWithEntitlements';
  clientName: Scalars['String']['output'];
  entitlements: Array<Entitlement>;
  id: Scalars['ID']['output'];
};

export type CompleteTaskInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type CompleteUntil = {
  __typename?: 'CompleteUntil';
  partOfTheDay?: Maybe<PartOfTheDay>;
  time?: Maybe<Scalars['String']['output']>;
};

export type CompleteUntilInput = {
  partOfTheDay?: InputMaybe<PartOfTheDay>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type CompletedRehabProcedure = {
  __typename?: 'CompletedRehabProcedure';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Config = {
  __typename?: 'Config';
  dataType: DataType;
  description: TranslationFields;
  group: ConfigGroups;
  key: Scalars['String']['output'];
  label: TranslationFields;
  regex: Scalars['String']['output'];
  value: ConfigValue;
};

export enum ConfigGroups {
  CareFacilityDetails = 'CARE_FACILITY_DETAILS',
  General = 'GENERAL'
}

export type ConfigValue = {
  __typename?: 'ConfigValue';
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type ConfigValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: PersonName;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ContactPersonInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: PersonNameInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CoverageShortage = {
  __typename?: 'CoverageShortage';
  assignedCount: Scalars['Int']['output'];
  endsAt: Scalars['AWSDateTime']['output'];
  jobRoleId: Scalars['ID']['output'];
  requiredCount: Scalars['Int']['output'];
  requirementId: Scalars['ID']['output'];
  startsAt: Scalars['AWSDateTime']['output'];
};

export type CreateAbsenceRequestInput = {
  endsAt: Scalars['AWSDateTime']['input'];
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  removeConflictingShifts?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['AWSDateTime']['input'];
  type: AbsenceType;
  userId: Scalars['ID']['input'];
};

export type CreateAuthorizedRelativeUserInput = {
  address?: InputMaybe<AddressInput>;
  email: Scalars['String']['input'];
  name: PersonNameInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['String']['input'];
};

export type CreateBatchTaskInput = {
  assignedToEmployee?: InputMaybe<Scalars['String']['input']>;
  assignedToResident?: InputMaybe<Scalars['String']['input']>;
  completeUntil?: InputMaybe<CompleteUntilInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDate']['input']>;
  parentRecurringTaskId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateEventInput = {
  content: Scalars['String']['input'];
  date: Scalars['AWSDateTime']['input'];
  eventSubType: EventSubType;
  pairingId?: InputMaybe<Scalars['String']['input']>;
  type: EventType;
};

export type CreateIntegrationProviderInput = {
  allowedEndpoints: Array<Scalars['String']['input']>;
  dailyQuota: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  rateLimit: Scalars['Int']['input'];
};

export type CreateJobRoleInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateRecurringTaskInput = {
  assignedToEmployee?: InputMaybe<Scalars['String']['input']>;
  assignedToResident?: InputMaybe<Scalars['String']['input']>;
  completeUntil?: InputMaybe<CompleteUntilInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  interval: DurationInput;
  jobRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  occurrences: Scalars['Int']['input'];
  startTimestamp: Scalars['AWSDateTime']['input'];
  title: Scalars['String']['input'];
};

export type CreateRehabPlanInput = {
  diagnosis: Array<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  prescribedProcedures: Array<PrescribedProcedureInput>;
  residentId: Scalars['ID']['input'];
};

export type CreateRehabSessionInput = {
  completedProcedureIds: Array<Scalars['ID']['input']>;
  extraProcedures: Array<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  performedAt: Scalars['AWSDateTime']['input'];
  planId: Scalars['ID']['input'];
};

export type CreateResidentInput = {
  accommodatedSince?: InputMaybe<Scalars['AWSDate']['input']>;
  accommodatedUntil?: InputMaybe<Scalars['AWSDate']['input']>;
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<Scalars['String']['input']>>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  dateOfBirth: Scalars['AWSDate']['input'];
  disabilityCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  name: PersonNameInput;
  personalNumber: Scalars['String']['input'];
  roomId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateResidentMedicationInput = {
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  form?: InputMaybe<MedicationForm>;
  medicationName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['String']['input'];
  schedule: ScheduleInput;
  showForDistribution: Scalars['Boolean']['input'];
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  treatmentType?: InputMaybe<TreatmentType>;
  warnings?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoomInput = {
  building?: InputMaybe<Scalars['String']['input']>;
  capacity: Scalars['Int']['input'];
  floor?: InputMaybe<Scalars['Int']['input']>;
  roomNumber: Scalars['String']['input'];
};

export type CreateTaskInput = {
  assignedToEmployee?: InputMaybe<Scalars['String']['input']>;
  assignedToResident?: InputMaybe<Scalars['String']['input']>;
  completeUntil?: InputMaybe<CompleteUntilInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDate']['input']>;
  jobRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentRecurringTaskId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateTasksInput = {
  jobRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tasks?: InputMaybe<Array<InputMaybe<CreateBatchTaskInput>>>;
};

export type CreateUserInput = {
  group: UserGroup;
  jobRoleId?: InputMaybe<Scalars['ID']['input']>;
  name: PersonNameInput;
  personalNumber: Scalars['String']['input'];
};

export type CreateWarehouseInput = {
  allowedGroups?: InputMaybe<Array<InputMaybe<UserGroup>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateWarehouseItemInput = {
  name: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type CreateWorkTimeEntryInput = {
  endedAt: Scalars['AWSDateTime']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  startedAt: Scalars['AWSDateTime']['input'];
  userId: Scalars['ID']['input'];
};

export type CreatedTasks = {
  __typename?: 'CreatedTasks';
  isLimitedToJobRoles: Scalars['Boolean']['output'];
  jobRoleIds?: Maybe<Array<Scalars['ID']['output']>>;
  tasks: Array<Task>;
};

export type CurrentMedicationQueryInput = {
  date: Scalars['AWSDate']['input'];
  residentId: Scalars['String']['input'];
};

export enum DataType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  PublicImage = 'PUBLIC_IMAGE',
  String = 'STRING'
}

export type DeleteAllResidentMedia = {
  __typename?: 'DeleteAllResidentMedia';
  removedFilesCount: Scalars['Int']['output'];
  residentId: Scalars['String']['output'];
};

export type DeleteResidentMediaInput = {
  fileName: Scalars['String']['input'];
  residentId: Scalars['String']['input'];
};

export type DeleteResidentTasksArchive = {
  __typename?: 'DeleteResidentTasksArchive';
  removedObjectsCount: Scalars['Int']['output'];
  removedTasksCount: Scalars['Int']['output'];
  residentId: Scalars['ID']['output'];
};

export enum DeviceType {
  Computer = 'COMPUTER',
  Mobile = 'MOBILE'
}

export type Dosage = {
  __typename?: 'Dosage';
  quantity: Scalars['String']['output'];
  unit: UnitType;
};

export type DosageDetails = {
  __typename?: 'DosageDetails';
  customInstructions?: Maybe<Scalars['String']['output']>;
  dosage: Dosage;
  relationToFood?: Maybe<MedicationFoodRelation>;
  time?: Maybe<Scalars['String']['output']>;
  timeOfDay?: Maybe<PartOfTheDay>;
  timeType: TimeType;
};

export type DosageDetailsInput = {
  customInstructions?: InputMaybe<Scalars['String']['input']>;
  dosage: DosageInput;
  relationToFood?: InputMaybe<MedicationFoodRelation>;
  time?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<PartOfTheDay>;
  timeType: TimeType;
};

export type DosageInput = {
  quantity: Scalars['String']['input'];
  unit: UnitType;
};

export type DownloadMediaInput = {
  fileId: Scalars['ID']['input'];
  itemKey: Scalars['String']['input'];
  pairingId: Scalars['String']['input'];
};

export type DownloadMediaResponse = {
  __typename?: 'DownloadMediaResponse';
  url: Scalars['String']['output'];
};

/** Months are `YYYY-MM`, both ends inclusive. */
export type DownloadResidentTaskArchiveInput = {
  endMonth: Scalars['String']['input'];
  language: Scalars['String']['input'];
  residentId: Scalars['ID']['input'];
  startMonth: Scalars['String']['input'];
};

export type Duration = {
  __typename?: 'Duration';
  amount: Scalars['Int']['output'];
  type: DurationType;
};

export type DurationInput = {
  amount: Scalars['Int']['input'];
  type: DurationType;
};

export enum DurationType {
  Day = 'DAY',
  Hour = 'HOUR',
  Week = 'WEEK'
}

export type EmailSubscription = {
  __typename?: 'EmailSubscription';
  email: Scalars['String']['output'];
  language: Scalars['String']['output'];
  lastVerificationEmailSent?: Maybe<Scalars['AWSDateTime']['output']>;
  subscribedAt: Scalars['AWSDateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type Entitlement = {
  __typename?: 'Entitlement';
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export type Event = {
  __typename?: 'Event';
  content: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  date: Scalars['AWSDateTime']['output'];
  eventSubType: EventSubType;
  id: Scalars['ID']['output'];
  isSharedToAuthorizedRelative?: Maybe<Scalars['Boolean']['output']>;
  pairingId?: Maybe<Scalars['String']['output']>;
  type: EventType;
};

export enum EventSubType {
  Hospital = 'HOSPITAL',
  Illness = 'ILLNESS',
  MedicalAbnormality = 'MEDICAL_ABNORMALITY',
  MedicalAppointment = 'MEDICAL_APPOINTMENT',
  None = 'NONE',
  Treatment = 'TREATMENT'
}

export enum EventType {
  Casual = 'CASUAL',
  Medical = 'MEDICAL',
  Rehabilitation = 'REHABILITATION',
  Unverified = 'UNVERIFIED'
}

export type GenerateAuthTokenInput = {
  identityToken: Scalars['String']['input'];
};

export type GenerateTemporaryPasswordResponse = {
  __typename?: 'GenerateTemporaryPasswordResponse';
  tempPassword: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type GeneratedIdentityToken = {
  __typename?: 'GeneratedIdentityToken';
  token: Scalars['String']['output'];
};

export type GenericUser = {
  approvedConditions?: Maybe<ApprovedConditions>;
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  group: UserGroup;
  id: Scalars['ID']['output'];
  name: PersonName;
  personalNumber: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userName: Scalars['String']['output'];
};

export type GetAllResidentMedicationsInRangeInput = {
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  residentId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type GetEventsByPairingIdInput = {
  endDate: Scalars['AWSDate']['input'];
  pairingId: Scalars['String']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type GetEventsWithDateRangeInput = {
  endDate: Scalars['AWSDate']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type GetMyWorkTimeEntriesInput = {
  endDate: Scalars['AWSDate']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type GetTasksWithDateRangeInput = {
  endDate: Scalars['AWSDate']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type GetWorkTimeEntriesInput = {
  endDate: Scalars['AWSDate']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type GlobalApprovalStatus = {
  __typename?: 'GlobalApprovalStatus';
  globalPrivacyPolicy: Scalars['Boolean']['output'];
  globalTermsAndConditions: Scalars['Boolean']['output'];
};

export type HealthLogBatchMeasurementInput = {
  measurements: Array<HealthLogMeasurementInput>;
};

export type HealthLogMeasurement = {
  __typename?: 'HealthLogMeasurement';
  metricId: Scalars['ID']['output'];
  recordedAt: Scalars['AWSDateTime']['output'];
  residentId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  values: Scalars['AWSJSON']['output'];
};

export type HealthLogMeasurementConnection = {
  __typename?: 'HealthLogMeasurementConnection';
  items: Array<HealthLogMeasurement>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type HealthLogMeasurementInput = {
  metricId: Scalars['ID']['input'];
  recordedAt: Scalars['AWSDateTime']['input'];
  residentId: Scalars['ID']['input'];
  values: Scalars['AWSJSON']['input'];
};

export type HealthLogMetricDefinition = {
  __typename?: 'HealthLogMetricDefinition';
  enabled: Scalars['Boolean']['output'];
  fields: Array<HealthLogMetricField>;
  id: Scalars['ID']['output'];
};

export type HealthLogMetricField = {
  __typename?: 'HealthLogMetricField';
  name: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type IntegrationClientCredentials = {
  __typename?: 'IntegrationClientCredentials';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  provider: IntegrationProvider;
};

export type IntegrationProvider = {
  __typename?: 'IntegrationProvider';
  allowedEndpoints: Array<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  dailyQuota: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rateLimit: Scalars['Int']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type IsMediaUploadedInput = {
  fileName: Scalars['String']['input'];
  residentId: Scalars['String']['input'];
};

export type JobRole = {
  __typename?: 'JobRole';
  color: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum Language {
  De = 'DE',
  En = 'EN',
  Pl = 'PL',
  Uk = 'UK'
}

export type LowStockMedicationInput = {
  medicationId: Scalars['ID']['input'];
  medicationName: Scalars['String']['input'];
  personalNumber: Scalars['String']['input'];
  residentId: Scalars['ID']['input'];
  residentName: Scalars['String']['input'];
};

export type MarkResidentAsAbsentInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type Media = {
  __typename?: 'Media';
  extension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  firstDownloadByAuthorizedRelative?: Maybe<MediaDownloadRecord>;
  id: Scalars['ID']['output'];
  isSharedToAuthorizedRelative?: Maybe<Scalars['Boolean']['output']>;
  size: Scalars['Float']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
};

export type MediaDownloadRecord = {
  __typename?: 'MediaDownloadRecord';
  downloadedAt: Scalars['Float']['output'];
  downloadedBy: Scalars['String']['output'];
  fileId: Scalars['String']['output'];
  isAuthorizedRelative: Scalars['Boolean']['output'];
  pairingId: Scalars['String']['output'];
};

export type MedicationDistributionSummaryInput = {
  distributionDate: Scalars['AWSDate']['input'];
  lowStockMedications: Array<LowStockMedicationInput>;
  residentCount: Scalars['Int']['input'];
  totalMedicationsDelivered: Scalars['Int']['input'];
};

export enum MedicationFoodRelation {
  AfterMeal = 'AFTER_MEAL',
  BeforeMeal = 'BEFORE_MEAL',
  EmptyStomach = 'EMPTY_STOMACH',
  Other = 'OTHER',
  WithMeal = 'WITH_MEAL'
}

export enum MedicationForm {
  Aerosol = 'AEROSOL',
  Capsule = 'CAPSULE',
  Drops = 'DROPS',
  Inhalation = 'INHALATION',
  Injection = 'INJECTION',
  Ointment = 'OINTMENT',
  Other = 'OTHER',
  Plaster = 'PLASTER',
  Spray = 'SPRAY',
  Syrup = 'SYRUP',
  Tablet = 'TABLET',
  TransdermalSystem = 'TRANSDERMAL_SYSTEM'
}

export type MedicationName = {
  __typename?: 'MedicationName';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MedicinalProduct = {
  __typename?: 'MedicinalProduct';
  activeSubstance?: Maybe<Scalars['String']['output']>;
  animalUseBan?: Maybe<Scalars['String']['output']>;
  atcCode?: Maybe<Scalars['String']['output']>;
  authorizationNumber?: Maybe<Scalars['String']['output']>;
  authorizationValidity?: Maybe<Scalars['String']['output']>;
  characteristicsUrl?: Maybe<Scalars['String']['output']>;
  commonName: Scalars['String']['output'];
  educationalToolsForHealthcareProfessionals?: Maybe<Scalars['String']['output']>;
  educationalToolsForPatients?: Maybe<Scalars['String']['output']>;
  exportCountry?: Maybe<Scalars['String']['output']>;
  exportCountryAuthorizationHolder?: Maybe<Scalars['String']['output']>;
  importerCountry?: Maybe<Scalars['String']['output']>;
  importerName?: Maybe<Scalars['String']['output']>;
  labelLeaflet?: Maybe<Scalars['String']['output']>;
  leafletUrl?: Maybe<Scalars['String']['output']>;
  legalBasis?: Maybe<Scalars['String']['output']>;
  manufacturerCountry?: Maybe<Scalars['String']['output']>;
  manufacturerName?: Maybe<Scalars['String']['output']>;
  manufacturerOrImporterCountry?: Maybe<Scalars['String']['output']>;
  manufacturerOrImporterName?: Maybe<Scalars['String']['output']>;
  marketingAuthorizationHolder?: Maybe<Scalars['String']['output']>;
  packaging?: Maybe<Scalars['String']['output']>;
  parallelImportLabelLeaflet?: Maybe<Scalars['String']['output']>;
  parallelImportLeaflet?: Maybe<Scalars['String']['output']>;
  parallelImportPackagingMarkings?: Maybe<Scalars['String']['output']>;
  pharmaceuticalForm?: Maybe<Scalars['String']['output']>;
  preparationType?: Maybe<Scalars['String']['output']>;
  previousProductName?: Maybe<Scalars['String']['output']>;
  procedureType?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  routeOfAdministration?: Maybe<Scalars['String']['output']>;
  strength?: Maybe<Scalars['String']['output']>;
};

export type MedicinalProductSearchResult = {
  __typename?: 'MedicinalProductSearchResult';
  commonName?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  strength?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addClientDeploy: Scalars['String']['output'];
  addHealthLogMeasurements: Array<HealthLogMeasurement>;
  addPlannedShifts: WorkScheduleWeek;
  addWarehouseItemQuantity: WarehouseItem;
  admitResident: Resident;
  approveAbsenceRequest: AbsenceRequest;
  approveDevice: PairedDevice;
  approveDeviceIp: PairedDevice;
  approveGlobalPrivacyPolicy?: Maybe<Scalars['Boolean']['output']>;
  approveGlobalTermsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  approveWorkTimeEntry: WorkTimeEntry;
  archiveRehabPlan: RehabPlan;
  completeTask: Task;
  createAbsenceRequest: AbsenceRequest;
  createAuthorizedRelativeUser: AuthorizedRelativeUser;
  createEvent: Event;
  createIntegrationProvider: IntegrationClientCredentials;
  createJobRole: JobRole;
  createMedicationName: MedicationName;
  createRecurringTask: RecurringTask;
  createRehabPlan: RehabPlan;
  createRehabSession: RehabSession;
  createResident: Resident;
  createResidentMedication: ResidentMedication;
  createRoom: Room;
  createTask: Task;
  createTasks: CreatedTasks;
  createUser: User;
  createWarehouse: Warehouse;
  createWarehouseItem: WarehouseItem;
  createWorkTimeEntry: WorkTimeEntry;
  deactivateResident: Resident;
  deleteAbsenceRequest: AbsenceRequest;
  deleteAllResidentMedia: DeleteAllResidentMedia;
  deleteAuthorizedRelativeUser: AuthorizedRelativeUser;
  deleteClientDeploy: Scalars['String']['output'];
  deleteDevice: PairedDevice;
  deleteDeviceIp: PairedDevice;
  deleteEvent: Event;
  deleteHealthLogMeasurement: HealthLogMeasurement;
  deleteIntegrationProvider: Scalars['Boolean']['output'];
  deleteJobRole: JobRole;
  deleteMedicationName: MedicationName;
  deletePlannedShift: PlannedShift;
  deleteRecurringTask: RecurringTask;
  deleteRecurringTasks: Array<Scalars['ID']['output']>;
  deleteResident: Resident;
  deleteResidentAvatar: Resident;
  deleteResidentMedia: Media;
  deleteResidentMedication: ResidentMedication;
  deleteResidentTasksArchive: DeleteResidentTasksArchive;
  deleteRoom: Room;
  deleteTask: Task;
  deleteTasks: Array<Scalars['ID']['output']>;
  deleteUser: User;
  deleteWarehouse: Warehouse;
  deleteWarehouseItem: WarehouseItem;
  deleteWorkScheduleWeek?: Maybe<Scalars['Boolean']['output']>;
  deleteWorkTimeEntry: WorkTimeEntry;
  deployClient: Scalars['String']['output'];
  discardWorkScheduleWeekChanges: WorkScheduleWeek;
  finishMyWorkTimeShift: WorkTimeEntry;
  generateAuthTokens: AuthTokens;
  generateIdentityToken: GeneratedIdentityToken;
  generateTemporaryPassword: GenerateTemporaryPasswordResponse;
  markResidentAsAbsent: Resident;
  notifyMedicationDistributionCompleted: Scalars['Boolean']['output'];
  publishWorkScheduleWeek: WorkScheduleWeek;
  reassignResidentRoom: Resident;
  regenerateIntegrationApiKey: IntegrationClientCredentials;
  rejectAbsenceRequest: AbsenceRequest;
  rejectDevice: PairedDevice;
  rejectDeviceIp: PairedDevice;
  rejectTask: Task;
  rejectWorkTimeEntry: WorkTimeEntry;
  renameDevice: PairedDevice;
  replacePlannedShifts: WorkScheduleWeek;
  requestAbsence: AbsenceRequest;
  resendVerificationEmail: Scalars['String']['output'];
  resetAuthorizedRelativeUserPassword: AuthorizedRelativeUser;
  revokeIdentityToken: Scalars['String']['output'];
  rotateHashSecret?: Maybe<Scalars['Boolean']['output']>;
  saveConfigFile: SaveMediaResponse;
  savePlannedShift: WorkScheduleWeek;
  saveResidentAvatar: SaveMediaResponse;
  saveResidentMedia: SaveMediaResponse;
  saveUserAvatar: SaveMediaResponse;
  shareResidentMediaWithAuthorizedRelative: Media;
  startMyWorkTimeShift: WorkTimeActiveSession;
  subscribeToNotification: EmailSubscription;
  subtractWarehouseItemQuantity: WarehouseItem;
  syncDeletedMediaBucketSize?: Maybe<Scalars['Float']['output']>;
  syncWholeMediaBucketSize?: Maybe<Scalars['Float']['output']>;
  transferWarehouseItem: WarehouseItemTransfer;
  uncompleteTask: Task;
  unmarkResidentAsAbsent: Resident;
  unsubscribeFromNotification: Scalars['String']['output'];
  updateAbsenceRequest: AbsenceRequest;
  updateAuthorizedRelativeUser: AuthorizedRelativeUser;
  updateBoEntitlement: Scalars['Boolean']['output'];
  updateConfig: Config;
  updateConfigs: Array<Config>;
  updateEvent: Event;
  updateHealthLogMeasurement: HealthLogMeasurement;
  updateIntegrationProvider: IntegrationProvider;
  updateJobRole: JobRole;
  updateOwnAbsenceRequest: AbsenceRequest;
  updateRecurringTask: RecurringTask;
  updateRehabPlan: RehabPlan;
  updateResident: Resident;
  updateResidentMedication: ResidentMedication;
  updateRoom: Room;
  updateTask: Task;
  updateUser: User;
  updateWarehouse: Warehouse;
  updateWarehouseItem: WarehouseItem;
  updateWorkTimeEntry: WorkTimeEntry;
  userApproveConditions: User;
};


export type MutationAddClientDeployArgs = {
  input: AddClientDeploy;
};


export type MutationAddHealthLogMeasurementsArgs = {
  input: HealthLogBatchMeasurementInput;
};


export type MutationAddPlannedShiftsArgs = {
  shifts: Array<NewPlannedShiftInput>;
  weekStart: Scalars['AWSDate']['input'];
};


export type MutationAddWarehouseItemQuantityArgs = {
  input: ChangeQuantityInput;
};


export type MutationAdmitResidentArgs = {
  input: AdmitResidentInput;
};


export type MutationApproveAbsenceRequestArgs = {
  input: ApproveAbsenceRequestInput;
};


export type MutationApproveDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveDeviceIpArgs = {
  id: Scalars['ID']['input'];
  ip: Scalars['String']['input'];
};


export type MutationApproveWorkTimeEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveRehabPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteTaskArgs = {
  input: CompleteTaskInput;
};


export type MutationCreateAbsenceRequestArgs = {
  input: CreateAbsenceRequestInput;
};


export type MutationCreateAuthorizedRelativeUserArgs = {
  input: CreateAuthorizedRelativeUserInput;
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateIntegrationProviderArgs = {
  input: CreateIntegrationProviderInput;
};


export type MutationCreateJobRoleArgs = {
  input: CreateJobRoleInput;
};


export type MutationCreateMedicationNameArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateRecurringTaskArgs = {
  input: CreateRecurringTaskInput;
};


export type MutationCreateRehabPlanArgs = {
  input: CreateRehabPlanInput;
};


export type MutationCreateRehabSessionArgs = {
  input: CreateRehabSessionInput;
};


export type MutationCreateResidentArgs = {
  input: CreateResidentInput;
};


export type MutationCreateResidentMedicationArgs = {
  input: CreateResidentMedicationInput;
};


export type MutationCreateRoomArgs = {
  input: CreateRoomInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTasksArgs = {
  input?: InputMaybe<CreateTasksInput>;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateWarehouseArgs = {
  input: CreateWarehouseInput;
};


export type MutationCreateWarehouseItemArgs = {
  input: CreateWarehouseItemInput;
};


export type MutationCreateWorkTimeEntryArgs = {
  input: CreateWorkTimeEntryInput;
};


export type MutationDeactivateResidentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAbsenceRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAllResidentMediaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAuthorizedRelativeUserArgs = {
  userName: Scalars['String']['input'];
};


export type MutationDeleteClientDeployArgs = {
  clientName: Scalars['String']['input'];
};


export type MutationDeleteDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDeviceIpArgs = {
  id: Scalars['ID']['input'];
  ip: Scalars['String']['input'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHealthLogMeasurementArgs = {
  metricId: Scalars['ID']['input'];
  recordedAt: Scalars['AWSDateTime']['input'];
  residentId: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMedicationNameArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlannedShiftArgs = {
  id: Scalars['ID']['input'];
  weekStart: Scalars['AWSDate']['input'];
};


export type MutationDeleteRecurringTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRecurringTasksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteResidentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResidentAvatarArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResidentMediaArgs = {
  input: DeleteResidentMediaInput;
};


export type MutationDeleteResidentMedicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResidentTasksArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoomArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTasksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteUserArgs = {
  userName: Scalars['String']['input'];
};


export type MutationDeleteWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWarehouseItemArgs = {
  id: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type MutationDeleteWorkScheduleWeekArgs = {
  weekStart: Scalars['AWSDate']['input'];
};


export type MutationDeleteWorkTimeEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeployClientArgs = {
  clientName: Scalars['String']['input'];
};


export type MutationDiscardWorkScheduleWeekChangesArgs = {
  weekStart: Scalars['AWSDate']['input'];
};


export type MutationGenerateAuthTokensArgs = {
  input: GenerateAuthTokenInput;
};


export type MutationGenerateIdentityTokenArgs = {
  userName: Scalars['String']['input'];
};


export type MutationGenerateTemporaryPasswordArgs = {
  userName: Scalars['String']['input'];
};


export type MutationMarkResidentAsAbsentArgs = {
  input: MarkResidentAsAbsentInput;
};


export type MutationNotifyMedicationDistributionCompletedArgs = {
  input: MedicationDistributionSummaryInput;
};


export type MutationPublishWorkScheduleWeekArgs = {
  weekStart: Scalars['AWSDate']['input'];
};


export type MutationReassignResidentRoomArgs = {
  input: ReassignResidentRoomInput;
};


export type MutationRegenerateIntegrationApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRejectAbsenceRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRejectDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRejectDeviceIpArgs = {
  id: Scalars['ID']['input'];
  ip: Scalars['String']['input'];
};


export type MutationRejectTaskArgs = {
  input: RejectTaskInput;
};


export type MutationRejectWorkTimeEntryArgs = {
  input: RejectWorkTimeEntryInput;
};


export type MutationRenameDeviceArgs = {
  input?: InputMaybe<RenameDeviceInput>;
};


export type MutationReplacePlannedShiftsArgs = {
  requirements?: InputMaybe<Array<StaffingRequirementInput>>;
  shifts: Array<NewPlannedShiftInput>;
  weekStart: Scalars['AWSDate']['input'];
};


export type MutationRequestAbsenceArgs = {
  input: RequestAbsenceInput;
};


export type MutationResendVerificationEmailArgs = {
  email: Scalars['String']['input'];
  notificationType: NotificationType;
};


export type MutationResetAuthorizedRelativeUserPasswordArgs = {
  userName: Scalars['String']['input'];
};


export type MutationRevokeIdentityTokenArgs = {
  userName: Scalars['String']['input'];
};


export type MutationSaveConfigFileArgs = {
  input: SaveConfigFileInput;
};


export type MutationSavePlannedShiftArgs = {
  input: PlannedShiftInput;
};


export type MutationSaveResidentAvatarArgs = {
  input: SaveAvatarInput;
};


export type MutationSaveResidentMediaArgs = {
  input: SaveResidentMediaInput;
};


export type MutationSaveUserAvatarArgs = {
  input: SaveAvatarInput;
};


export type MutationShareResidentMediaWithAuthorizedRelativeArgs = {
  input: ShareResidentMediaWithAuthorizedRelativeInput;
};


export type MutationSubscribeToNotificationArgs = {
  email: Scalars['String']['input'];
  language: Scalars['String']['input'];
  notificationType: NotificationType;
};


export type MutationSubtractWarehouseItemQuantityArgs = {
  input: ChangeQuantityInput;
};


export type MutationSyncDeletedMediaBucketSizeArgs = {
  input: SyncDeletedMediaBucketSizeInput;
};


export type MutationTransferWarehouseItemArgs = {
  input: TransferWarehouseItemInput;
};


export type MutationUncompleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnmarkResidentAsAbsentArgs = {
  input: MarkResidentAsAbsentInput;
};


export type MutationUnsubscribeFromNotificationArgs = {
  email: Scalars['String']['input'];
  notificationType: NotificationType;
};


export type MutationUpdateAbsenceRequestArgs = {
  input: UpdateAbsenceRequestInput;
};


export type MutationUpdateAuthorizedRelativeUserArgs = {
  input: UpdateAuthorizedRelativeUserInput;
};


export type MutationUpdateBoEntitlementArgs = {
  input: UpdateBoEntitlementInput;
};


export type MutationUpdateConfigArgs = {
  input: UpdateConfigInput;
};


export type MutationUpdateConfigsArgs = {
  input: UpdateConfigsInput;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


export type MutationUpdateHealthLogMeasurementArgs = {
  input: HealthLogMeasurementInput;
};


export type MutationUpdateIntegrationProviderArgs = {
  input: UpdateIntegrationProviderInput;
};


export type MutationUpdateJobRoleArgs = {
  input: UpdateJobRoleInput;
};


export type MutationUpdateOwnAbsenceRequestArgs = {
  input: UpdateOwnAbsenceRequestInput;
};


export type MutationUpdateRecurringTaskArgs = {
  input: UpdateRecurringTaskInput;
};


export type MutationUpdateRehabPlanArgs = {
  input: UpdateRehabPlanInput;
};


export type MutationUpdateResidentArgs = {
  input: UpdateResidentInput;
};


export type MutationUpdateResidentMedicationArgs = {
  input: UpdateResidentMedicationInput;
};


export type MutationUpdateRoomArgs = {
  input: UpdateRoomInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateWarehouseArgs = {
  input: UpdateWarehouseInput;
};


export type MutationUpdateWarehouseItemArgs = {
  input: UpdateWarehouseItemInput;
};


export type MutationUpdateWorkTimeEntryArgs = {
  input: UpdateWorkTimeEntryInput;
};


export type MutationUserApproveConditionsArgs = {
  input?: InputMaybe<UserApproveConditionsInput>;
};

export type MyWorkTimeStatus = {
  __typename?: 'MyWorkTimeStatus';
  activeSession?: Maybe<WorkTimeActiveSession>;
  state: WorkTimeSessionState;
};

export type NewPlannedShiftInput = {
  endsAt: Scalars['AWSDateTime']['input'];
  jobRoleId: Scalars['ID']['input'];
  startsAt: Scalars['AWSDateTime']['input'];
  userId: Scalars['ID']['input'];
};

export type NotificationConfig = {
  __typename?: 'NotificationConfig';
  emails: Array<EmailSubscription>;
  notificationType: NotificationType;
};

export enum NotificationDeliveryStatus {
  Bounced = 'BOUNCED',
  Complained = 'COMPLAINED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Sent = 'SENT'
}

export type NotificationHistory = {
  __typename?: 'NotificationHistory';
  deliveryStatus: NotificationDeliveryStatus;
  eventData?: Maybe<Scalars['AWSJSON']['output']>;
  notificationId: Scalars['String']['output'];
  notificationType: NotificationType;
  recipientEmail: Scalars['String']['output'];
  sentAt: Scalars['AWSDateTime']['output'];
};

export type NotificationHistoryConnection = {
  __typename?: 'NotificationHistoryConnection';
  items: Array<NotificationHistory>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum NotificationType {
  DevicePaired = 'DEVICE_PAIRED',
  DevicePairingRequest = 'DEVICE_PAIRING_REQUEST',
  EventCreated = 'EVENT_CREATED',
  MedicationDistributed = 'MEDICATION_DISTRIBUTED'
}

export type PairedDevice = {
  __typename?: 'PairedDevice';
  approvedIps: Array<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceType: DeviceType;
  deviceUUID: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pendingIps: Array<Scalars['String']['output']>;
  rejectedIps: Array<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userRequested: Scalars['ID']['output'];
};

export type PairedDeviceConnection = {
  __typename?: 'PairedDeviceConnection';
  items: Array<PairedDevice>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum PartOfTheDay {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Morning = 'MORNING',
  Night = 'NIGHT'
}

export type PersonName = {
  __typename?: 'PersonName';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
};

export type PersonNameInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
};

export type PlannedShift = {
  __typename?: 'PlannedShift';
  endsAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  jobRoleColor?: Maybe<Scalars['String']['output']>;
  jobRoleId: Scalars['ID']['output'];
  jobRoleName?: Maybe<Scalars['String']['output']>;
  startsAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type PlannedShiftInput = {
  endsAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobRoleId?: InputMaybe<Scalars['ID']['input']>;
  requirements?: InputMaybe<Array<StaffingRequirementInput>>;
  startsAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  weekStart: Scalars['AWSDate']['input'];
};

export type PrescribedProcedure = {
  __typename?: 'PrescribedProcedure';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scheduledDays?: Maybe<Array<Scalars['Int']['output']>>;
};

export type PrescribedProcedureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  scheduledDays?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Query = {
  __typename?: 'Query';
  countPendingAbsenceRequests: Scalars['Int']['output'];
  downloadMedia: DownloadMediaResponse;
  downloadResidentTaskArchive: ResidentTaskArchiveDownload;
  findMatchingMedicinalProductNames: Array<Maybe<MedicinalProductSearchResult>>;
  findRecurringTaskById?: Maybe<RecurringTask>;
  getAbsenceRequests: Array<AbsenceRequest>;
  getAllClientsDeploy: Array<Scalars['String']['output']>;
  getAllCurrentResidents: Array<Resident>;
  getAllFutureTasksForResident: Array<Task>;
  getAllMediaDownloadsForFile: Array<MediaDownloadRecord>;
  getAllNotificationConfigs: Array<NotificationConfig>;
  getAllOldResidents: Array<Resident>;
  getAllPairedDevices: PairedDeviceConnection;
  getAllPendingResidents: Array<Resident>;
  getAllRecurringTasksForResident: Array<RecurringTask>;
  getAllResidentMedicationsForRange: Array<ResidentMedication>;
  getAllResidents: Array<Resident>;
  getAllUsers: Array<User>;
  getAuthorizedRelativeById: AuthorizedRelativeUser;
  getBoEntitlements: Array<ClientWithEntitlements>;
  getConfigByKey: Config;
  getConfigs: Array<Config>;
  getEntitlements: Array<Entitlement>;
  getEventById: Event;
  getEventsByDateRange: Array<Event>;
  getEventsByPairingId: Array<Event>;
  getEventsByType: Array<Event>;
  getGlobalApprovalStatus?: Maybe<GlobalApprovalStatus>;
  getHealthLogMeasurements: HealthLogMeasurementConnection;
  getIntegrationProvider?: Maybe<IntegrationProvider>;
  getJobRoleById?: Maybe<JobRole>;
  getJobRoles: Array<JobRole>;
  getMedicationNames: Array<MedicationName>;
  getMedicinalProduct: MedicinalProduct;
  getMyUserInfo?: Maybe<User>;
  getMyWorkSchedule: Array<PlannedShift>;
  getMyWorkTimeEntriesByDateRange: Array<WorkTimeEntry>;
  getMyWorkTimeStatus: MyWorkTimeStatus;
  getNotificationConfig?: Maybe<NotificationConfig>;
  getNotificationHistory: NotificationHistoryConnection;
  getPairedDeviceById: PairedDevice;
  getRecurringTask: RecurringTask;
  getRecurringTasks: Array<RecurringTask>;
  getRehabPlanByResidentId?: Maybe<RehabPlan>;
  getRehabSessionsByResidentId: Array<RehabSession>;
  getResidentAllMedications: Array<ResidentMedication>;
  getResidentById: Resident;
  getResidentCurrentMedications: Array<ResidentMedication>;
  getResidentInfoForAmbulance: ResidentInfoForAmbulance;
  getResidentMedicationById: ResidentMedication;
  getResidentsByIds: Array<Resident>;
  getResidentsForAuthorizedRelative: Array<ResidentForAuthorizedRelative>;
  getRoomById: Room;
  getRoomByNumber: Room;
  getRooms: Array<Room>;
  getTask: Task;
  getTasks: Array<Task>;
  getTasksForWorkingDay: Array<Task>;
  getTasksWithDateRange: Array<Task>;
  getUserByUserName: User;
  getUtilisationByKey: UtilisationResponse;
  getUtilisations: Array<UtilisationResponse>;
  getWarehouseById?: Maybe<Warehouse>;
  getWarehouseItemById?: Maybe<WarehouseItem>;
  getWarehouseItems: WarehouseItemConnection;
  getWarehouses: Array<Warehouse>;
  getWorkScheduleMonth: Array<PlannedShift>;
  getWorkScheduleWeek?: Maybe<WorkScheduleWeek>;
  getWorkScheduleWeekAbsences: Array<AbsenceRequest>;
  getWorkTimeEntriesByDateRange: Array<WorkTimeEntry>;
  getWorkTimeEntry: WorkTimeEntry;
  isMediaUploaded: Scalars['Boolean']['output'];
  listHealthLogMetrics: Array<HealthLogMetricDefinition>;
  listIntegrationProviders: Array<IntegrationProvider>;
};


export type QueryDownloadMediaArgs = {
  input: DownloadMediaInput;
};


export type QueryDownloadResidentTaskArchiveArgs = {
  input: DownloadResidentTaskArchiveInput;
};


export type QueryFindMatchingMedicinalProductNamesArgs = {
  name: Scalars['String']['input'];
};


export type QueryFindRecurringTaskByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAbsenceRequestsArgs = {
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
};


export type QueryGetAllFutureTasksForResidentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAllMediaDownloadsForFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAllPairedDevicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllRecurringTasksForResidentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAllResidentMedicationsForRangeArgs = {
  input?: InputMaybe<GetAllResidentMedicationsInRangeInput>;
};


export type QueryGetAuthorizedRelativeByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetConfigByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetEventByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEventsByDateRangeArgs = {
  input?: InputMaybe<GetEventsWithDateRangeInput>;
};


export type QueryGetEventsByPairingIdArgs = {
  input: GetEventsByPairingIdInput;
};


export type QueryGetEventsByTypeArgs = {
  type: EventType;
};


export type QueryGetHealthLogMeasurementsArgs = {
  from?: InputMaybe<Scalars['AWSDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  metricId: Scalars['ID']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['AWSDateTime']['input']>;
};


export type QueryGetIntegrationProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetJobRoleByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMedicinalProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryGetMyWorkScheduleArgs = {
  endDate: Scalars['AWSDate']['input'];
  startDate: Scalars['AWSDate']['input'];
};


export type QueryGetMyWorkTimeEntriesByDateRangeArgs = {
  input?: InputMaybe<GetMyWorkTimeEntriesInput>;
};


export type QueryGetNotificationConfigArgs = {
  notificationType: NotificationType;
};


export type QueryGetNotificationHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  notificationType?: InputMaybe<NotificationType>;
};


export type QueryGetPairedDeviceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRecurringTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRehabPlanByResidentIdArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryGetRehabSessionsByResidentIdArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryGetResidentAllMedicationsArgs = {
  input?: InputMaybe<AllMedicationQueryInput>;
};


export type QueryGetResidentByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetResidentCurrentMedicationsArgs = {
  input?: InputMaybe<CurrentMedicationQueryInput>;
};


export type QueryGetResidentInfoForAmbulanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetResidentMedicationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetResidentsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryGetRoomByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRoomByNumberArgs = {
  roomNumber: Scalars['String']['input'];
};


export type QueryGetTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTasksWithDateRangeArgs = {
  input?: InputMaybe<GetTasksWithDateRangeInput>;
};


export type QueryGetUserByUserNameArgs = {
  userName: Scalars['String']['input'];
};


export type QueryGetUtilisationByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetWarehouseByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWarehouseItemByIdArgs = {
  id: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};


export type QueryGetWarehouseItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};


export type QueryGetWorkScheduleMonthArgs = {
  monthStart: Scalars['AWSDate']['input'];
};


export type QueryGetWorkScheduleWeekArgs = {
  weekStart: Scalars['AWSDate']['input'];
};


export type QueryGetWorkScheduleWeekAbsencesArgs = {
  weekStart: Scalars['AWSDate']['input'];
};


export type QueryGetWorkTimeEntriesByDateRangeArgs = {
  input?: InputMaybe<GetWorkTimeEntriesInput>;
};


export type QueryGetWorkTimeEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsMediaUploadedArgs = {
  input: IsMediaUploadedInput;
};

export type ReassignResidentRoomInput = {
  id: Scalars['ID']['input'];
  roomId: Scalars['ID']['input'];
};

export type RecurringTask = BaseItem & {
  __typename?: 'RecurringTask';
  assignedToEmployee?: Maybe<Scalars['String']['output']>;
  assignedToResident?: Maybe<Scalars['String']['output']>;
  completeUntil?: Maybe<CompleteUntil>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  currentOccurrence: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interval: Duration;
  jobRoleIds?: Maybe<Array<Scalars['ID']['output']>>;
  lastOccurrenceTimestamp?: Maybe<Scalars['Float']['output']>;
  occurrences: Scalars['Int']['output'];
  startTimestamp: Scalars['AWSDateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RehabPlan = {
  __typename?: 'RehabPlan';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  diagnosis: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  prescribedProcedures: Array<PrescribedProcedure>;
  residentId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RehabSession = {
  __typename?: 'RehabSession';
  completedProcedures: Array<CompletedRehabProcedure>;
  createdAt: Scalars['AWSDateTime']['output'];
  extraProcedures: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  performedAt: Scalars['AWSDateTime']['output'];
  performedBy: Scalars['String']['output'];
  planId: Scalars['ID']['output'];
  residentId: Scalars['ID']['output'];
};

export type RejectTaskInput = {
  id: Scalars['ID']['input'];
  rejectionNote: Scalars['String']['input'];
};

export type RejectWorkTimeEntryInput = {
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

export type RenameDeviceInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type RequestAbsenceInput = {
  endsAt: Scalars['AWSDateTime']['input'];
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['AWSDateTime']['input'];
  type: AbsenceType;
};

export type Resident = BaseItem & {
  __typename?: 'Resident';
  accommodatedSince?: Maybe<Scalars['AWSDate']['output']>;
  accommodatedUntil?: Maybe<Scalars['AWSDate']['output']>;
  additionalInformation?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Array<Scalars['String']['output']>>;
  contactPersons: Array<ContactPerson>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  dateOfBirth: Scalars['AWSDate']['output'];
  disabilityCertificate?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<Array<Media>>;
  name: PersonName;
  personalNumber: Scalars['String']['output'];
  roomId?: Maybe<Scalars['ID']['output']>;
  status: ResidentStatus;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ResidentForAuthorizedRelative = {
  __typename?: 'ResidentForAuthorizedRelative';
  events: Array<Event>;
  id: Scalars['ID']['output'];
  media?: Maybe<Array<Media>>;
  name: PersonName;
  residentMedications: Array<ResidentMedication>;
};

export type ResidentInfoForAmbulance = {
  __typename?: 'ResidentInfoForAmbulance';
  careFacilityPhoneNumber?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Array<Scalars['String']['output']>>;
  contactPersonName?: Maybe<PersonName>;
  contactPersonPhoneNumber?: Maybe<Scalars['String']['output']>;
  dateOfBirth: Scalars['AWSDate']['output'];
  events: Array<Event>;
  healthLogMeasurements: Array<HealthLogMeasurement>;
  id: Scalars['ID']['output'];
  name: PersonName;
  personalNumber: Scalars['String']['output'];
  reportCreatedAt: Scalars['AWSDateTime']['output'];
  residentMedications: Array<ResidentMedication>;
};

export type ResidentMedication = {
  __typename?: 'ResidentMedication';
  endDate?: Maybe<Scalars['AWSDate']['output']>;
  form?: Maybe<MedicationForm>;
  id: Scalars['ID']['output'];
  medicationName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['String']['output'];
  schedule: Schedule;
  showForDistribution: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['AWSDate']['output']>;
  treatmentType?: Maybe<TreatmentType>;
  warnings?: Maybe<Scalars['String']['output']>;
};

export enum ResidentStatus {
  Absent = 'ABSENT',
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Pending = 'PENDING'
}

export type ResidentTaskArchiveDownload = {
  __typename?: 'ResidentTaskArchiveDownload';
  fileName: Scalars['String']['output'];
  numberOfMonths: Scalars['Int']['output'];
  url: Scalars['AWSURL']['output'];
};

export type Room = BaseItem & {
  __typename?: 'Room';
  building?: Maybe<Scalars['String']['output']>;
  capacity: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  floor?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  residents: Array<Maybe<Scalars['String']['output']>>;
  roomNumber: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SaveAvatarInput = {
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type SaveConfigFileInput = {
  configKey: Scalars['String']['input'];
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type SaveMediaResponse = {
  __typename?: 'SaveMediaResponse';
  url: Scalars['String']['output'];
};

export type SaveResidentMediaInput = {
  extension: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  residentId: Scalars['String']['input'];
  size: Scalars['Float']['input'];
};

export type Schedule = {
  __typename?: 'Schedule';
  daysOfWeek?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  dosageDetails: Array<Maybe<DosageDetails>>;
};

export type ScheduleInput = {
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dosageDetails?: InputMaybe<Array<InputMaybe<DosageDetailsInput>>>;
};

export type ShareResidentMediaWithAuthorizedRelativeInput = {
  fileName: Scalars['String']['input'];
  isSharedToAuthorizedRelative: Scalars['Boolean']['input'];
  residentId: Scalars['String']['input'];
};

export type StaffingRequirement = {
  __typename?: 'StaffingRequirement';
  dates: Array<StaffingRequirementDate>;
  id: Scalars['ID']['output'];
  jobRoleColor: Scalars['String']['output'];
  jobRoleId: Scalars['ID']['output'];
  jobRoleName: Scalars['String']['output'];
  minimumHeadcount: Scalars['Int']['output'];
};

export type StaffingRequirementDate = {
  __typename?: 'StaffingRequirementDate';
  endsAt: Scalars['AWSDateTime']['output'];
  startsAt: Scalars['AWSDateTime']['output'];
};

export type StaffingRequirementDateInput = {
  endsAt: Scalars['AWSDateTime']['input'];
  startsAt: Scalars['AWSDateTime']['input'];
};

export type StaffingRequirementInput = {
  dates: Array<StaffingRequirementDateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobRoleId: Scalars['ID']['input'];
  minimumHeadcount: Scalars['Int']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onCompleteTask?: Maybe<Task>;
  onCreateEvent?: Maybe<Event>;
  onCreateRecurringTask?: Maybe<RecurringTask>;
  onCreateTask?: Maybe<Task>;
  onCreateTasks?: Maybe<CreatedTasks>;
  onDeleteEvent?: Maybe<Event>;
  onDeleteRecurringTask?: Maybe<RecurringTask>;
  onDeleteRecurringTasks?: Maybe<Array<Maybe<RecurringTask>>>;
  onDeleteTask?: Maybe<Task>;
  onRejectTask?: Maybe<Task>;
  onUncompleteTask?: Maybe<Task>;
  onUpdateEvent?: Maybe<Event>;
  onUpdateRecurringTask?: Maybe<RecurringTask>;
  onUpdateTask?: Maybe<Task>;
};

export type SyncDeletedMediaBucketSizeInput = {
  fileName: Scalars['String']['input'];
  size: Scalars['Float']['input'];
};

export type Task = BaseItem & {
  __typename?: 'Task';
  assignedToEmployee?: Maybe<Scalars['String']['output']>;
  assignedToResident?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  completeUntil?: Maybe<CompleteUntil>;
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  date?: Maybe<Scalars['AWSDate']['output']>;
  id: Scalars['ID']['output'];
  isLimitedToJobRoles: Scalars['Boolean']['output'];
  jobRoleIds?: Maybe<Array<Scalars['ID']['output']>>;
  parentRecurringTaskId?: Maybe<Scalars['String']['output']>;
  rejectionNote?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum TimeType {
  PartOfDay = 'PART_OF_DAY',
  Specific = 'SPECIFIC'
}

export type TransferWarehouseItemInput = {
  amount: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  targetWarehouseId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type TranslationFields = {
  __typename?: 'TranslationFields';
  de: Scalars['String']['output'];
  en: Scalars['String']['output'];
  pl: Scalars['String']['output'];
  uk: Scalars['String']['output'];
};

export enum TreatmentType {
  AsNeeded = 'AS_NEEDED',
  Continuous = 'CONTINUOUS',
  Temporary = 'TEMPORARY'
}

export enum UnitType {
  Ampoule = 'AMPOULE',
  Application = 'APPLICATION',
  Capsule = 'CAPSULE',
  Drop = 'DROP',
  G = 'G',
  Injection = 'INJECTION',
  L = 'L',
  Mcg = 'MCG',
  Mg = 'MG',
  Ml = 'ML',
  Patch = 'PATCH',
  Percent = 'PERCENT',
  Puff = 'PUFF',
  Sachet = 'SACHET',
  Spray = 'SPRAY',
  Suppository = 'SUPPOSITORY',
  Tablet = 'TABLET',
  Unit = 'UNIT'
}

export type UpdateAbsenceRequestInput = {
  endsAt: Scalars['AWSDateTime']['input'];
  id: Scalars['ID']['input'];
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  removeConflictingShifts?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['AWSDateTime']['input'];
  type: AbsenceType;
};

export type UpdateAuthorizedRelativeUserInput = {
  address?: InputMaybe<AddressInput>;
  name: PersonNameInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  residentsId: Array<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
};

export type UpdateBoEntitlementInput = {
  enabled: Scalars['Boolean']['input'];
  entitlementName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateConfigInput = {
  key: Scalars['String']['input'];
  value: ConfigValueInput;
};

export type UpdateConfigsInput = {
  configs?: InputMaybe<Array<UpdateConfigInput>>;
};

export type UpdateEventInput = {
  content: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  date: Scalars['AWSDateTime']['input'];
  eventSubType: EventSubType;
  id: Scalars['ID']['input'];
  isSharedToAuthorizedRelative: Scalars['Boolean']['input'];
  pairingId?: InputMaybe<Scalars['String']['input']>;
  type: EventType;
};

export type UpdateIntegrationProviderInput = {
  allowedEndpoints?: InputMaybe<Array<Scalars['String']['input']>>;
  dailyQuota?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rateLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateJobRoleInput = {
  color: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateOwnAbsenceRequestInput = {
  endsAt: Scalars['AWSDateTime']['input'];
  id: Scalars['ID']['input'];
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['AWSDateTime']['input'];
  type: AbsenceType;
};

export type UpdateRecurringTaskInput = {
  assignedToEmployee?: InputMaybe<Scalars['String']['input']>;
  assignedToResident?: InputMaybe<Scalars['String']['input']>;
  completeUntil?: InputMaybe<CompleteUntilInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  interval: DurationInput;
  jobRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  occurrences: Scalars['Int']['input'];
  startTimestamp: Scalars['AWSDateTime']['input'];
  title: Scalars['String']['input'];
};

export type UpdateRehabPlanInput = {
  diagnosis: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  prescribedProcedures: Array<PrescribedProcedureInput>;
};

export type UpdateResidentInput = {
  accommodatedSince?: InputMaybe<Scalars['AWSDate']['input']>;
  accommodatedUntil?: InputMaybe<Scalars['AWSDate']['input']>;
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<Scalars['String']['input']>>;
  contactPersons: Array<ContactPersonInput>;
  dateOfBirth: Scalars['AWSDate']['input'];
  disabilityCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name: PersonNameInput;
  personalNumber: Scalars['String']['input'];
  roomId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateResidentMedicationInput = {
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  form?: InputMaybe<MedicationForm>;
  id: Scalars['ID']['input'];
  medicationName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  schedule: ScheduleInput;
  showForDistribution: Scalars['Boolean']['input'];
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  treatmentType?: InputMaybe<TreatmentType>;
  warnings?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoomInput = {
  building?: InputMaybe<Scalars['String']['input']>;
  capacity: Scalars['Int']['input'];
  floor?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  residents: Array<InputMaybe<Scalars['String']['input']>>;
  roomNumber: Scalars['String']['input'];
};

export type UpdateTaskInput = {
  assignedToEmployee?: InputMaybe<Scalars['String']['input']>;
  assignedToResident?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completeUntil?: InputMaybe<CompleteUntilInput>;
  completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  completedBy?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['AWSDate']['input']>;
  id: Scalars['ID']['input'];
  jobRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rejectionNote?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateUserInput = {
  group: UserGroup;
  jobRoleId?: InputMaybe<Scalars['ID']['input']>;
  name: PersonNameInput;
  userName: Scalars['String']['input'];
};

export type UpdateWarehouseInput = {
  allowedGroups?: InputMaybe<Array<InputMaybe<UserGroup>>>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWarehouseItemInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type UpdateWorkTimeEntryInput = {
  endedAt: Scalars['AWSDateTime']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  startedAt: Scalars['AWSDateTime']['input'];
};

export type User = GenericUser & {
  __typename?: 'User';
  approvedConditions?: Maybe<ApprovedConditions>;
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  group: UserGroup;
  id: Scalars['ID']['output'];
  jobRoleId?: Maybe<Scalars['ID']['output']>;
  name: PersonName;
  personalNumber: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userName: Scalars['String']['output'];
};

export type UserApproveConditionsInput = {
  termsAndConditions?: InputMaybe<ApprovedAtInput>;
};

export enum UserGroup {
  Admins = 'admins',
  AuthorizedRelatives = 'authorized_relatives',
  Employees = 'employees',
  EmployeesInventory = 'employees_inventory',
  EmployeesRehabilitation = 'employees_rehabilitation',
  Moderators = 'moderators',
  Owners = 'owners',
  Superusers = 'superusers'
}

export type UtilisationResponse = {
  __typename?: 'UtilisationResponse';
  key: Scalars['ID']['output'];
  resourceName: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type Warehouse = BaseItem & {
  __typename?: 'Warehouse';
  allowedGroups?: Maybe<Array<Maybe<UserGroup>>>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type WarehouseItem = BaseItem & {
  __typename?: 'WarehouseItem';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  warehouseId: Scalars['ID']['output'];
};

export type WarehouseItemConnection = {
  __typename?: 'WarehouseItemConnection';
  items: Array<WarehouseItem>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type WarehouseItemTransfer = {
  __typename?: 'WarehouseItemTransfer';
  sourceItem: WarehouseItem;
  targetItem: WarehouseItem;
};

export enum WorkScheduleStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type WorkScheduleWeek = {
  __typename?: 'WorkScheduleWeek';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  requirements: Array<StaffingRequirement>;
  shifts: Array<PlannedShift>;
  shortages: Array<CoverageShortage>;
  status: WorkScheduleStatus;
  updatedAt: Scalars['AWSDateTime']['output'];
  updatedBy: Scalars['String']['output'];
  weekStart: Scalars['AWSDate']['output'];
};

export type WorkTimeActiveSession = {
  __typename?: 'WorkTimeActiveSession';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  startedAt: Scalars['AWSDateTime']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type WorkTimeEntry = {
  __typename?: 'WorkTimeEntry';
  createdAt: Scalars['AWSDateTime']['output'];
  endedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['AWSDateTime']['output'];
  status?: Maybe<WorkTimeEntryStatus>;
  totalMinutes?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export enum WorkTimeEntryStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum WorkTimeSessionState {
  NotWorking = 'NOT_WORKING',
  Working = 'WORKING'
}

export type AbsenceRequestFragmentFragment = { __typename?: 'AbsenceRequest', id: string, userId: string, type?: AbsenceType | null, status: AbsenceStatus, startsAt: string, endsAt: string, requestedBy: string, createdAt: string, updatedAt: string, approvedBy?: string | null, rejectedBy?: string | null, notes?: string | null, isAllDay?: boolean | null };

export type GetAbsenceRequestsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
}>;


export type GetAbsenceRequestsQuery = { __typename?: 'Query', getAbsenceRequests: Array<{ __typename?: 'AbsenceRequest', id: string, userId: string, type?: AbsenceType | null, status: AbsenceStatus, startsAt: string, endsAt: string, requestedBy: string, createdAt: string, updatedAt: string, approvedBy?: string | null, rejectedBy?: string | null, notes?: string | null, isAllDay?: boolean | null }> };

export type CountPendingAbsenceRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountPendingAbsenceRequestsQuery = { __typename?: 'Query', countPendingAbsenceRequests: number };

export type RequestAbsenceMutationVariables = Exact<{
  input: RequestAbsenceInput;
}>;


export type RequestAbsenceMutation = { __typename?: 'Mutation', requestAbsence: { __typename?: 'AbsenceRequest', id: string, userId: string, type?: AbsenceType | null, status: AbsenceStatus, startsAt: string, endsAt: string, requestedBy: string, createdAt: string, updatedAt: string, approvedBy?: string | null, rejectedBy?: string | null, notes?: string | null, isAllDay?: boolean | null } };

export type CreateAbsenceRequestMutationVariables = Exact<{
  input: CreateAbsenceRequestInput;
}>;


export type CreateAbsenceRequestMutation = { __typename?: 'Mutation', createAbsenceRequest: { __typename?: 'AbsenceRequest', id: string, userId: string, type?: AbsenceType | null, status: AbsenceStatus, startsAt: string, endsAt: string, requestedBy: string, createdAt: string, updatedAt: string, approvedBy?: string | null, rejectedBy?: string | null, notes?: string | null, isAllDay?: boolean | null } };

export type ApproveAbsenceRequestMutationVariables = Exact<{
  input: ApproveAbsenceRequestInput;
}>;


export type ApproveAbsenceRequestMutation = { __typename?: 'Mutation', approveAbsenceRequest: { __typename?: 'AbsenceRequest', id: string, userId: string, type?: AbsenceType | null, status: AbsenceStatus, startsAt: string, endsAt: string, requestedBy: string, createdAt: string, updatedAt: string, approvedBy?: string | null, rejectedBy?: string | null, notes?: string | null, isAllDay?: boolean | null } };

export type RejectAbsenceRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RejectAbsenceRequestMutation = { __typename?: 'Mutation', rejectAbsenceRequest: { __typename?: 'AbsenceRequest', id: string, userId: string, type?: AbsenceType | null, status: AbsenceStatus, startsAt: string, endsAt: string, requestedBy: string, createdAt: string, updatedAt: string, approvedBy?: string | null, rejectedBy?: string | null, notes?: string | null, isAllDay?: boolean | null } };

export type DeleteAbsenceRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAbsenceRequestMutation = { __typename?: 'Mutation', deleteAbsenceRequest: { __typename?: 'AbsenceRequest', id: string, userId: string, type?: AbsenceType | null, status: AbsenceStatus, startsAt: string, endsAt: string, requestedBy: string, createdAt: string, updatedAt: string, approvedBy?: string | null, rejectedBy?: string | null, notes?: string | null, isAllDay?: boolean | null } };

export type UpdateAbsenceRequestMutationVariables = Exact<{
  input: UpdateAbsenceRequestInput;
}>;


export type UpdateAbsenceRequestMutation = { __typename?: 'Mutation', updateAbsenceRequest: { __typename?: 'AbsenceRequest', id: string, userId: string, type?: AbsenceType | null, status: AbsenceStatus, startsAt: string, endsAt: string, requestedBy: string, createdAt: string, updatedAt: string, approvedBy?: string | null, rejectedBy?: string | null, notes?: string | null, isAllDay?: boolean | null } };

export type UpdateOwnAbsenceRequestMutationVariables = Exact<{
  input: UpdateOwnAbsenceRequestInput;
}>;


export type UpdateOwnAbsenceRequestMutation = { __typename?: 'Mutation', updateOwnAbsenceRequest: { __typename?: 'AbsenceRequest', id: string, userId: string, type?: AbsenceType | null, status: AbsenceStatus, startsAt: string, endsAt: string, requestedBy: string, createdAt: string, updatedAt: string, approvedBy?: string | null, rejectedBy?: string | null, notes?: string | null, isAllDay?: boolean | null } };

export type GetWorkScheduleWeekAbsencesQueryVariables = Exact<{
  weekStart: Scalars['AWSDate']['input'];
}>;


export type GetWorkScheduleWeekAbsencesQuery = { __typename?: 'Query', getWorkScheduleWeekAbsences: Array<{ __typename?: 'AbsenceRequest', id: string, userId: string, type?: AbsenceType | null, status: AbsenceStatus, startsAt: string, endsAt: string, requestedBy: string, createdAt: string, updatedAt: string, approvedBy?: string | null, rejectedBy?: string | null, notes?: string | null, isAllDay?: boolean | null }> };

export type GetResidentsForAuthorizedRelativeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResidentsForAuthorizedRelativeQuery = { __typename?: 'Query', getResidentsForAuthorizedRelative: Array<{ __typename?: 'ResidentForAuthorizedRelative', id: string, name: { __typename?: 'PersonName', firstName: string, lastName: string, middleName?: string | null }, events: Array<{ __typename?: 'Event', id: string, date: string, eventSubType: EventSubType, content: string, pairingId?: string | null, type: EventType, createdBy: string }>, media?: Array<{ __typename?: 'Media', id: string, extension: string, fileName: string, size: number }> | null, residentMedications: Array<{ __typename?: 'ResidentMedication', id: string, residentId: string, medicationName: string, startDate?: string | null, endDate?: string | null, notes?: string | null, schedule: { __typename?: 'Schedule', daysOfWeek?: Array<number | null> | null, dosageDetails: Array<{ __typename?: 'DosageDetails', timeType: TimeType, time?: string | null, timeOfDay?: PartOfTheDay | null, customInstructions?: string | null, relationToFood?: MedicationFoodRelation | null, dosage: { __typename?: 'Dosage', unit: UnitType, quantity: string } } | null> } }> }> };

export type GetAuthorizedRelativeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAuthorizedRelativeByIdQuery = { __typename?: 'Query', getAuthorizedRelativeById: { __typename?: 'AuthorizedRelativeUser', userName: string, residentsId: Array<string> } };

export type CreateAuthorizedRelativeUserMutationVariables = Exact<{
  input: CreateAuthorizedRelativeUserInput;
}>;


export type CreateAuthorizedRelativeUserMutation = { __typename?: 'Mutation', createAuthorizedRelativeUser: { __typename?: 'AuthorizedRelativeUser', id: string, userName: string } };

export type UpdateAuthorizedRelativeUserMutationVariables = Exact<{
  input: UpdateAuthorizedRelativeUserInput;
}>;


export type UpdateAuthorizedRelativeUserMutation = { __typename?: 'Mutation', updateAuthorizedRelativeUser: { __typename?: 'AuthorizedRelativeUser', id: string, userName: string } };

export type ResetAuthorizedRelativeUserPasswordMutationVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type ResetAuthorizedRelativeUserPasswordMutation = { __typename?: 'Mutation', resetAuthorizedRelativeUserPassword: { __typename?: 'AuthorizedRelativeUser', id: string, userName: string } };

export type DeleteAuthorizedRelativeUserMutationVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type DeleteAuthorizedRelativeUserMutation = { __typename?: 'Mutation', deleteAuthorizedRelativeUser: { __typename?: 'AuthorizedRelativeUser', id: string, userName: string } };

export type GetAllClientsDeployQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientsDeployQuery = { __typename?: 'Query', getAllClientsDeploy: Array<string> };

export type AddClientDeployMutationVariables = Exact<{
  input: AddClientDeploy;
}>;


export type AddClientDeployMutation = { __typename?: 'Mutation', addClientDeploy: string };

export type DeployClientMutationVariables = Exact<{
  clientName: Scalars['String']['input'];
}>;


export type DeployClientMutation = { __typename?: 'Mutation', deployClient: string };

export type DeleteClientDeployMutationVariables = Exact<{
  clientName: Scalars['String']['input'];
}>;


export type DeleteClientDeployMutation = { __typename?: 'Mutation', deleteClientDeploy: string };

export type GetConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigsQuery = { __typename?: 'Query', getConfigs: Array<{ __typename?: 'Config', key: string, group: ConfigGroups, dataType: DataType, regex: string, label: { __typename?: 'TranslationFields', de: string, en: string, pl: string, uk: string }, description: { __typename?: 'TranslationFields', de: string, en: string, pl: string, uk: string }, value: { __typename?: 'ConfigValue', stringValue?: string | null, numberValue?: number | null, boolValue?: boolean | null } }> };

export type UpdateConfigsMutationVariables = Exact<{
  input: UpdateConfigsInput;
}>;


export type UpdateConfigsMutation = { __typename?: 'Mutation', updateConfigs: Array<{ __typename?: 'Config', key: string, group: ConfigGroups, dataType: DataType, label: { __typename?: 'TranslationFields', de: string, en: string, pl: string, uk: string }, description: { __typename?: 'TranslationFields', de: string, en: string, pl: string, uk: string }, value: { __typename?: 'ConfigValue', stringValue?: string | null, numberValue?: number | null, boolValue?: boolean | null } }> };

export type UpdateConfigMutationVariables = Exact<{
  input: UpdateConfigInput;
}>;


export type UpdateConfigMutation = { __typename?: 'Mutation', updateConfig: { __typename?: 'Config', key: string, group: ConfigGroups, dataType: DataType, label: { __typename?: 'TranslationFields', de: string, en: string, pl: string, uk: string }, description: { __typename?: 'TranslationFields', de: string, en: string, pl: string, uk: string }, value: { __typename?: 'ConfigValue', stringValue?: string | null, numberValue?: number | null, boolValue?: boolean | null } } };

export type SaveConfigFileMutationVariables = Exact<{
  input: SaveConfigFileInput;
}>;


export type SaveConfigFileMutation = { __typename?: 'Mutation', saveConfigFile: { __typename?: 'SaveMediaResponse', url: string } };

export type GetConfigByKeyQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type GetConfigByKeyQuery = { __typename?: 'Query', getConfigByKey: { __typename?: 'Config', key: string, group: ConfigGroups, dataType: DataType, value: { __typename?: 'ConfigValue', numberValue?: number | null, boolValue?: boolean | null, stringValue?: string | null }, label: { __typename?: 'TranslationFields', de: string, en: string, pl: string, uk: string }, description: { __typename?: 'TranslationFields', de: string, en: string, pl: string, uk: string } } };

export type GetMediaBucketUtilisationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMediaBucketUtilisationQuery = { __typename?: 'Query', getUtilisationByKey: { __typename?: 'UtilisationResponse', resourceName: string, updatedAt: number, value: number } };

export type GetEntitlementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEntitlementsQuery = { __typename?: 'Query', getEntitlements: Array<{ __typename?: 'Entitlement', key: string, enabled: boolean }> };

export type GetBoEntitlementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBoEntitlementsQuery = { __typename?: 'Query', getBoEntitlements: Array<{ __typename?: 'ClientWithEntitlements', id: string, clientName: string, entitlements: Array<{ __typename?: 'Entitlement', enabled: boolean, key: string }> }> };

export type UpdateBoEntitlementMutationVariables = Exact<{
  input: UpdateBoEntitlementInput;
}>;


export type UpdateBoEntitlementMutation = { __typename?: 'Mutation', updateBoEntitlement: boolean };

export type GetEventsByPairingIdQueryVariables = Exact<{
  input: GetEventsByPairingIdInput;
}>;


export type GetEventsByPairingIdQuery = { __typename?: 'Query', getEventsByPairingId: Array<{ __typename?: 'Event', id: string, date: string, eventSubType: EventSubType, content: string, pairingId?: string | null, type: EventType, createdBy: string, isSharedToAuthorizedRelative?: boolean | null }> };

export type GetEventByIdQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type GetEventByIdQuery = { __typename?: 'Query', getEventById: { __typename?: 'Event', id: string, date: string, eventSubType: EventSubType, content: string, pairingId?: string | null, type: EventType, createdBy: string, isSharedToAuthorizedRelative?: boolean | null } };

export type GetEventsByDateRangeQueryVariables = Exact<{
  input: GetEventsWithDateRangeInput;
}>;


export type GetEventsByDateRangeQuery = { __typename?: 'Query', getEventsByDateRange: Array<{ __typename?: 'Event', id: string, date: string, eventSubType: EventSubType, content: string, pairingId?: string | null, type: EventType, createdBy: string, isSharedToAuthorizedRelative?: boolean | null }> };

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'Event', pairingId?: string | null, id: string, date: string } };

export type UpdateEventMutationVariables = Exact<{
  input: UpdateEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'Event', pairingId?: string | null, id: string } };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent: { __typename?: 'Event', pairingId?: string | null, id: string } };

export type HealthLogMetricDefinitionFragmentFragment = { __typename?: 'HealthLogMetricDefinition', id: string, enabled: boolean, fields: Array<{ __typename?: 'HealthLogMetricField', name: string, unit: string }> };

export type HealthLogMeasurementFragmentFragment = { __typename?: 'HealthLogMeasurement', residentId: string, metricId: string, recordedAt: string, values: string, updatedAt: string };

export type HealthLogMeasurementConnectionFragmentFragment = { __typename?: 'HealthLogMeasurementConnection', nextToken?: string | null, items: Array<{ __typename?: 'HealthLogMeasurement', residentId: string, metricId: string, recordedAt: string, values: string, updatedAt: string }> };

export type ListHealthLogMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHealthLogMetricsQuery = { __typename?: 'Query', listHealthLogMetrics: Array<{ __typename?: 'HealthLogMetricDefinition', id: string, enabled: boolean, fields: Array<{ __typename?: 'HealthLogMetricField', name: string, unit: string }> }> };

export type GetHealthLogMeasurementsQueryVariables = Exact<{
  residentId: Scalars['ID']['input'];
  metricId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['AWSDateTime']['input']>;
  to?: InputMaybe<Scalars['AWSDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHealthLogMeasurementsQuery = { __typename?: 'Query', getHealthLogMeasurements: { __typename?: 'HealthLogMeasurementConnection', nextToken?: string | null, items: Array<{ __typename?: 'HealthLogMeasurement', residentId: string, metricId: string, recordedAt: string, values: string, updatedAt: string }> } };

export type AddHealthLogMeasurementsMutationVariables = Exact<{
  input: HealthLogBatchMeasurementInput;
}>;


export type AddHealthLogMeasurementsMutation = { __typename?: 'Mutation', addHealthLogMeasurements: Array<{ __typename?: 'HealthLogMeasurement', residentId: string, metricId: string, recordedAt: string, values: string, updatedAt: string }> };

export type UpdateHealthLogMeasurementMutationVariables = Exact<{
  input: HealthLogMeasurementInput;
}>;


export type UpdateHealthLogMeasurementMutation = { __typename?: 'Mutation', updateHealthLogMeasurement: { __typename?: 'HealthLogMeasurement', residentId: string, metricId: string, recordedAt: string, values: string, updatedAt: string } };

export type DeleteHealthLogMeasurementMutationVariables = Exact<{
  residentId: Scalars['ID']['input'];
  metricId: Scalars['ID']['input'];
  recordedAt: Scalars['AWSDateTime']['input'];
}>;


export type DeleteHealthLogMeasurementMutation = { __typename?: 'Mutation', deleteHealthLogMeasurement: { __typename?: 'HealthLogMeasurement', residentId: string, metricId: string, recordedAt: string, values: string, updatedAt: string } };

export type ListIntegrationProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListIntegrationProvidersQuery = { __typename?: 'Query', listIntegrationProviders: Array<{ __typename?: 'IntegrationProvider', id: string, name: string, enabled: boolean, rateLimit: number, dailyQuota: number, allowedEndpoints: Array<string>, createdAt: string, updatedAt: string, createdBy: string }> };

export type GetIntegrationProviderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetIntegrationProviderQuery = { __typename?: 'Query', getIntegrationProvider?: { __typename?: 'IntegrationProvider', id: string, name: string, enabled: boolean, rateLimit: number, dailyQuota: number, allowedEndpoints: Array<string>, createdAt: string, updatedAt: string, createdBy: string } | null };

export type CreateIntegrationProviderMutationVariables = Exact<{
  input: CreateIntegrationProviderInput;
}>;


export type CreateIntegrationProviderMutation = { __typename?: 'Mutation', createIntegrationProvider: { __typename?: 'IntegrationClientCredentials', clientId: string, clientSecret: string, provider: { __typename?: 'IntegrationProvider', id: string, name: string, enabled: boolean, rateLimit: number, dailyQuota: number, allowedEndpoints: Array<string>, createdAt: string, updatedAt: string, createdBy: string } } };

export type UpdateIntegrationProviderMutationVariables = Exact<{
  input: UpdateIntegrationProviderInput;
}>;


export type UpdateIntegrationProviderMutation = { __typename?: 'Mutation', updateIntegrationProvider: { __typename?: 'IntegrationProvider', id: string, name: string, enabled: boolean, rateLimit: number, dailyQuota: number, allowedEndpoints: Array<string>, updatedAt: string } };

export type DeleteIntegrationProviderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteIntegrationProviderMutation = { __typename?: 'Mutation', deleteIntegrationProvider: boolean };

export type RegenerateIntegrationApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RegenerateIntegrationApiKeyMutation = { __typename?: 'Mutation', regenerateIntegrationApiKey: { __typename?: 'IntegrationClientCredentials', clientId: string, clientSecret: string, provider: { __typename?: 'IntegrationProvider', id: string, name: string, updatedAt: string } } };

export type GetWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWarehousesQuery = { __typename?: 'Query', getWarehouses: Array<{ __typename?: 'Warehouse', allowedGroups?: Array<UserGroup | null> | null, name: string, location?: string | null, id: string }> };

export type GetWarehouseByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWarehouseByIdQuery = { __typename?: 'Query', getWarehouseById?: { __typename?: 'Warehouse', allowedGroups?: Array<UserGroup | null> | null, name: string, location?: string | null, id: string } | null };

export type GetWarehouseItemsQueryVariables = Exact<{
  warehouseId: Scalars['ID']['input'];
}>;


export type GetWarehouseItemsQuery = { __typename?: 'Query', getWarehouseItems: { __typename?: 'WarehouseItemConnection', items: Array<{ __typename?: 'WarehouseItem', id: string, name: string, quantity: number, updatedAt: string, warehouseId: string }> } };

export type GetWarehouseItemByIdQueryVariables = Exact<{
  warehouseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GetWarehouseItemByIdQuery = { __typename?: 'Query', getWarehouseItemById?: { __typename?: 'WarehouseItem', id: string, name: string, quantity: number, updatedAt: string, warehouseId: string } | null };

export type CreateWarehouseMutationVariables = Exact<{
  input: CreateWarehouseInput;
}>;


export type CreateWarehouseMutation = { __typename?: 'Mutation', createWarehouse: { __typename?: 'Warehouse', id: string, name: string, location?: string | null, allowedGroups?: Array<UserGroup | null> | null } };

export type UpdateWarehouseMutationVariables = Exact<{
  input: UpdateWarehouseInput;
}>;


export type UpdateWarehouseMutation = { __typename?: 'Mutation', updateWarehouse: { __typename?: 'Warehouse', id: string, name: string, location?: string | null, allowedGroups?: Array<UserGroup | null> | null } };

export type DeleteWarehouseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWarehouseMutation = { __typename?: 'Mutation', deleteWarehouse: { __typename?: 'Warehouse', id: string, name: string, location?: string | null, allowedGroups?: Array<UserGroup | null> | null } };

export type CreateWarehouseItemMutationVariables = Exact<{
  input: CreateWarehouseItemInput;
}>;


export type CreateWarehouseItemMutation = { __typename?: 'Mutation', createWarehouseItem: { __typename?: 'WarehouseItem', id: string, name: string, quantity: number, warehouseId: string } };

export type UpdateWarehouseItemMutationVariables = Exact<{
  input: UpdateWarehouseItemInput;
}>;


export type UpdateWarehouseItemMutation = { __typename?: 'Mutation', updateWarehouseItem: { __typename?: 'WarehouseItem', id: string, name: string, quantity: number, warehouseId: string } };

export type DeleteWarehouseItemMutationVariables = Exact<{
  warehouseId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteWarehouseItemMutation = { __typename?: 'Mutation', deleteWarehouseItem: { __typename?: 'WarehouseItem', id: string, name: string, quantity: number, warehouseId: string } };

export type AddWarehouseItemQuantityMutationVariables = Exact<{
  input: ChangeQuantityInput;
}>;


export type AddWarehouseItemQuantityMutation = { __typename?: 'Mutation', addWarehouseItemQuantity: { __typename?: 'WarehouseItem', id: string, name: string, quantity: number, warehouseId: string } };

export type SubtractWarehouseItemQuantityMutationVariables = Exact<{
  input: ChangeQuantityInput;
}>;


export type SubtractWarehouseItemQuantityMutation = { __typename?: 'Mutation', subtractWarehouseItemQuantity: { __typename?: 'WarehouseItem', id: string, name: string, quantity: number, warehouseId: string } };

export type TransferWarehouseItemMutationVariables = Exact<{
  input: TransferWarehouseItemInput;
}>;


export type TransferWarehouseItemMutation = { __typename?: 'Mutation', transferWarehouseItem: { __typename?: 'WarehouseItemTransfer', sourceItem: { __typename?: 'WarehouseItem', id: string, name: string, quantity: number, warehouseId: string }, targetItem: { __typename?: 'WarehouseItem', id: string, name: string, quantity: number, warehouseId: string } } };

export type ResidentMedicationFragmentFragment = { __typename?: 'ResidentMedication', id: string, residentId: string, medicationName: string, startDate?: string | null, endDate?: string | null, productId?: string | null, treatmentType?: TreatmentType | null, form?: MedicationForm | null, warnings?: string | null, showForDistribution: boolean, notes?: string | null, schedule: { __typename?: 'Schedule', daysOfWeek?: Array<number | null> | null, dosageDetails: Array<{ __typename?: 'DosageDetails', timeType: TimeType, time?: string | null, timeOfDay?: PartOfTheDay | null, customInstructions?: string | null, relationToFood?: MedicationFoodRelation | null, dosage: { __typename?: 'Dosage', unit: UnitType, quantity: string } } | null> } };

export type GetMedicationNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMedicationNamesQuery = { __typename?: 'Query', getMedicationNames: Array<{ __typename?: 'MedicationName', id: string, name: string }> };

export type FindMedicinalProductsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type FindMedicinalProductsQuery = { __typename?: 'Query', findMatchingMedicinalProductNames: Array<{ __typename?: 'MedicinalProductSearchResult', productId: string, productName: string, commonName?: string | null, strength?: string | null } | null> };

export type GetMedicinalProductQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetMedicinalProductQuery = { __typename?: 'Query', getMedicinalProduct: { __typename?: 'MedicinalProduct', productId: string, productName: string, commonName: string, preparationType?: string | null, animalUseBan?: string | null, previousProductName?: string | null, routeOfAdministration?: string | null, strength?: string | null, pharmaceuticalForm?: string | null, procedureType?: string | null, authorizationNumber?: string | null, authorizationValidity?: string | null, atcCode?: string | null, marketingAuthorizationHolder?: string | null, packaging?: string | null, activeSubstance?: string | null, manufacturerName?: string | null, manufacturerCountry?: string | null, importerName?: string | null, importerCountry?: string | null, manufacturerOrImporterName?: string | null, manufacturerOrImporterCountry?: string | null, exportCountryAuthorizationHolder?: string | null, exportCountry?: string | null, legalBasis?: string | null, leafletUrl?: string | null, characteristicsUrl?: string | null, labelLeaflet?: string | null, parallelImportLeaflet?: string | null, parallelImportLabelLeaflet?: string | null, parallelImportPackagingMarkings?: string | null, educationalToolsForHealthcareProfessionals?: string | null, educationalToolsForPatients?: string | null } };

export type GetResidentMedicationByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResidentMedicationByIdQuery = { __typename?: 'Query', getResidentMedicationById: { __typename?: 'ResidentMedication', id: string, residentId: string, medicationName: string, startDate?: string | null, endDate?: string | null, productId?: string | null, treatmentType?: TreatmentType | null, form?: MedicationForm | null, warnings?: string | null, showForDistribution: boolean, notes?: string | null, schedule: { __typename?: 'Schedule', daysOfWeek?: Array<number | null> | null, dosageDetails: Array<{ __typename?: 'DosageDetails', timeType: TimeType, time?: string | null, timeOfDay?: PartOfTheDay | null, customInstructions?: string | null, relationToFood?: MedicationFoodRelation | null, dosage: { __typename?: 'Dosage', unit: UnitType, quantity: string } } | null> } } };

export type GetResidentCurrentMedicationsQueryVariables = Exact<{
  input?: InputMaybe<CurrentMedicationQueryInput>;
}>;


export type GetResidentCurrentMedicationsQuery = { __typename?: 'Query', getResidentCurrentMedications: Array<{ __typename?: 'ResidentMedication', id: string, residentId: string, medicationName: string, startDate?: string | null, endDate?: string | null, productId?: string | null, treatmentType?: TreatmentType | null, form?: MedicationForm | null, warnings?: string | null, showForDistribution: boolean, notes?: string | null, schedule: { __typename?: 'Schedule', daysOfWeek?: Array<number | null> | null, dosageDetails: Array<{ __typename?: 'DosageDetails', timeType: TimeType, time?: string | null, timeOfDay?: PartOfTheDay | null, customInstructions?: string | null, relationToFood?: MedicationFoodRelation | null, dosage: { __typename?: 'Dosage', unit: UnitType, quantity: string } } | null> } }> };

export type GetResidentAllMedicationsQueryVariables = Exact<{
  input?: InputMaybe<AllMedicationQueryInput>;
}>;


export type GetResidentAllMedicationsQuery = { __typename?: 'Query', getResidentAllMedications: Array<{ __typename?: 'ResidentMedication', id: string, residentId: string, medicationName: string, startDate?: string | null, endDate?: string | null, productId?: string | null, treatmentType?: TreatmentType | null, form?: MedicationForm | null, warnings?: string | null, showForDistribution: boolean, notes?: string | null, schedule: { __typename?: 'Schedule', daysOfWeek?: Array<number | null> | null, dosageDetails: Array<{ __typename?: 'DosageDetails', timeType: TimeType, time?: string | null, timeOfDay?: PartOfTheDay | null, customInstructions?: string | null, relationToFood?: MedicationFoodRelation | null, dosage: { __typename?: 'Dosage', unit: UnitType, quantity: string } } | null> } }> };

export type GetAllResidentMedicationsForRangeQueryVariables = Exact<{
  input: GetAllResidentMedicationsInRangeInput;
}>;


export type GetAllResidentMedicationsForRangeQuery = { __typename?: 'Query', getAllResidentMedicationsForRange: Array<{ __typename?: 'ResidentMedication', id: string, residentId: string, medicationName: string, startDate?: string | null, endDate?: string | null, productId?: string | null, treatmentType?: TreatmentType | null, form?: MedicationForm | null, warnings?: string | null, showForDistribution: boolean, notes?: string | null, schedule: { __typename?: 'Schedule', daysOfWeek?: Array<number | null> | null, dosageDetails: Array<{ __typename?: 'DosageDetails', timeType: TimeType, time?: string | null, timeOfDay?: PartOfTheDay | null, customInstructions?: string | null, relationToFood?: MedicationFoodRelation | null, dosage: { __typename?: 'Dosage', unit: UnitType, quantity: string } } | null> } }> };

export type CreateMedicationNameMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateMedicationNameMutation = { __typename?: 'Mutation', createMedicationName: { __typename?: 'MedicationName', id: string, name: string } };

export type DeleteMedicationNameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMedicationNameMutation = { __typename?: 'Mutation', deleteMedicationName: { __typename?: 'MedicationName', id: string } };

export type CreateResidentMedicationMutationVariables = Exact<{
  input: CreateResidentMedicationInput;
}>;


export type CreateResidentMedicationMutation = { __typename?: 'Mutation', createResidentMedication: { __typename?: 'ResidentMedication', id: string, residentId: string, medicationName: string, startDate?: string | null, endDate?: string | null, productId?: string | null, treatmentType?: TreatmentType | null, form?: MedicationForm | null, warnings?: string | null, showForDistribution: boolean, notes?: string | null, schedule: { __typename?: 'Schedule', daysOfWeek?: Array<number | null> | null, dosageDetails: Array<{ __typename?: 'DosageDetails', timeType: TimeType, time?: string | null, timeOfDay?: PartOfTheDay | null, customInstructions?: string | null, relationToFood?: MedicationFoodRelation | null, dosage: { __typename?: 'Dosage', unit: UnitType, quantity: string } } | null> } } };

export type UpdateResidentMedicationMutationVariables = Exact<{
  input: UpdateResidentMedicationInput;
}>;


export type UpdateResidentMedicationMutation = { __typename?: 'Mutation', updateResidentMedication: { __typename?: 'ResidentMedication', id: string, residentId: string, medicationName: string, startDate?: string | null, endDate?: string | null, productId?: string | null, treatmentType?: TreatmentType | null, form?: MedicationForm | null, warnings?: string | null, showForDistribution: boolean, notes?: string | null, schedule: { __typename?: 'Schedule', daysOfWeek?: Array<number | null> | null, dosageDetails: Array<{ __typename?: 'DosageDetails', timeType: TimeType, time?: string | null, timeOfDay?: PartOfTheDay | null, customInstructions?: string | null, relationToFood?: MedicationFoodRelation | null, dosage: { __typename?: 'Dosage', unit: UnitType, quantity: string } } | null> } } };

export type DeleteResidentMedicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteResidentMedicationMutation = { __typename?: 'Mutation', deleteResidentMedication: { __typename?: 'ResidentMedication', id: string, residentId: string, medicationName: string, startDate?: string | null, endDate?: string | null, productId?: string | null, treatmentType?: TreatmentType | null, form?: MedicationForm | null, warnings?: string | null, showForDistribution: boolean, notes?: string | null, schedule: { __typename?: 'Schedule', daysOfWeek?: Array<number | null> | null, dosageDetails: Array<{ __typename?: 'DosageDetails', timeType: TimeType, time?: string | null, timeOfDay?: PartOfTheDay | null, customInstructions?: string | null, relationToFood?: MedicationFoodRelation | null, dosage: { __typename?: 'Dosage', unit: UnitType, quantity: string } } | null> } } };

export type GetAllNotificationConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllNotificationConfigsQuery = { __typename?: 'Query', getAllNotificationConfigs: Array<{ __typename?: 'NotificationConfig', notificationType: NotificationType, emails: Array<{ __typename?: 'EmailSubscription', email: string, verified: boolean, subscribedAt: string, lastVerificationEmailSent?: string | null, language: string }> }> };

export type SubscribeToNotificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  notificationType: NotificationType;
  language: Scalars['String']['input'];
}>;


export type SubscribeToNotificationMutation = { __typename?: 'Mutation', subscribeToNotification: { __typename?: 'EmailSubscription', email: string, verified: boolean, subscribedAt: string, lastVerificationEmailSent?: string | null } };

export type UnsubscribeFromNotificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  notificationType: NotificationType;
}>;


export type UnsubscribeFromNotificationMutation = { __typename?: 'Mutation', unsubscribeFromNotification: string };

export type ResendVerificationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  notificationType: NotificationType;
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail: string };

export type NotifyMedicationDistributionCompletedMutationVariables = Exact<{
  input: MedicationDistributionSummaryInput;
}>;


export type NotifyMedicationDistributionCompletedMutation = { __typename?: 'Mutation', notifyMedicationDistributionCompleted: boolean };

export type GetAllPairedDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPairedDevicesQuery = { __typename?: 'Query', getAllPairedDevices: { __typename?: 'PairedDeviceConnection', items: Array<{ __typename?: 'PairedDevice', id: string, deviceName?: string | null, deviceUUID: string, userRequested: string, deviceType: DeviceType, createdAt: string, updatedAt: string, reviewedBy?: string | null, approvedIps: Array<string>, rejectedIps: Array<string>, pendingIps: Array<string> }> } };

export type GetPairedDeviceByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPairedDeviceByIdQuery = { __typename?: 'Query', getPairedDeviceById: { __typename?: 'PairedDevice', id: string, deviceName?: string | null, deviceUUID: string, userRequested: string, deviceType: DeviceType, createdAt: string, updatedAt: string, reviewedBy?: string | null, approvedIps: Array<string>, rejectedIps: Array<string>, pendingIps: Array<string> } };

export type ApprovePairedDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApprovePairedDeviceMutation = { __typename?: 'Mutation', approveDevice: { __typename?: 'PairedDevice', id: string, deviceName?: string | null, deviceUUID: string, userRequested: string, deviceType: DeviceType, createdAt: string, updatedAt: string, reviewedBy?: string | null, approvedIps: Array<string>, rejectedIps: Array<string>, pendingIps: Array<string> } };

export type RejectPairedDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RejectPairedDeviceMutation = { __typename?: 'Mutation', rejectDevice: { __typename?: 'PairedDevice', id: string, deviceName?: string | null, deviceUUID: string, userRequested: string, deviceType: DeviceType, createdAt: string, updatedAt: string, reviewedBy?: string | null, approvedIps: Array<string>, rejectedIps: Array<string>, pendingIps: Array<string> } };

export type ApproveDeviceIpMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  ip: Scalars['String']['input'];
}>;


export type ApproveDeviceIpMutation = { __typename?: 'Mutation', approveDeviceIp: { __typename?: 'PairedDevice', id: string, deviceUUID: string, reviewedBy?: string | null, updatedAt: string, approvedIps: Array<string>, rejectedIps: Array<string>, pendingIps: Array<string> } };

export type RejectDeviceIpMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  ip: Scalars['String']['input'];
}>;


export type RejectDeviceIpMutation = { __typename?: 'Mutation', rejectDeviceIp: { __typename?: 'PairedDevice', id: string, deviceUUID: string, reviewedBy?: string | null, updatedAt: string, approvedIps: Array<string>, rejectedIps: Array<string>, pendingIps: Array<string> } };

export type DeleteDeviceIpMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  ip: Scalars['String']['input'];
}>;


export type DeleteDeviceIpMutation = { __typename?: 'Mutation', deleteDeviceIp: { __typename?: 'PairedDevice', id: string, deviceUUID: string, updatedAt: string, approvedIps: Array<string>, rejectedIps: Array<string>, pendingIps: Array<string> } };

export type RenamePairedDeviceMutationVariables = Exact<{
  input: RenameDeviceInput;
}>;


export type RenamePairedDeviceMutation = { __typename?: 'Mutation', renameDevice: { __typename?: 'PairedDevice', id: string, deviceName?: string | null, deviceUUID: string, userRequested: string, deviceType: DeviceType, createdAt: string, updatedAt: string, reviewedBy?: string | null, approvedIps: Array<string>, rejectedIps: Array<string>, pendingIps: Array<string> } };

export type DeletePairedDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePairedDeviceMutation = { __typename?: 'Mutation', deleteDevice: { __typename?: 'PairedDevice', id: string } };

export type GetRecurringTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRecurringTaskQuery = { __typename?: 'Query', getRecurringTask: { __typename?: 'RecurringTask', id: string, title: string, content?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, occurrences: number, currentOccurrence: number, startTimestamp: string, lastOccurrenceTimestamp?: number | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null, interval: { __typename?: 'Duration', type: DurationType, amount: number } } };

export type FindRecurringTaskByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FindRecurringTaskByIdQuery = { __typename?: 'Query', findRecurringTaskById?: { __typename?: 'RecurringTask', id: string, title: string, content?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, occurrences: number, currentOccurrence: number, startTimestamp: string, lastOccurrenceTimestamp?: number | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null, interval: { __typename?: 'Duration', type: DurationType, amount: number } } | null };

export type GetRecurringTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecurringTasksQuery = { __typename?: 'Query', getRecurringTasks: Array<{ __typename?: 'RecurringTask', id: string, title: string, content?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, occurrences: number, currentOccurrence: number, startTimestamp: string, lastOccurrenceTimestamp?: number | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null, interval: { __typename?: 'Duration', type: DurationType, amount: number } }> };

export type CreateRecurringTaskMutationVariables = Exact<{
  input: CreateRecurringTaskInput;
}>;


export type CreateRecurringTaskMutation = { __typename?: 'Mutation', createRecurringTask: { __typename?: 'RecurringTask', id: string, title: string, content?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, occurrences: number, currentOccurrence: number, startTimestamp: string, lastOccurrenceTimestamp?: number | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null, interval: { __typename?: 'Duration', type: DurationType, amount: number } } };

export type UpdateRecurringTaskMutationVariables = Exact<{
  input: UpdateRecurringTaskInput;
}>;


export type UpdateRecurringTaskMutation = { __typename?: 'Mutation', updateRecurringTask: { __typename?: 'RecurringTask', id: string, title: string, content?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, occurrences: number, currentOccurrence: number, startTimestamp: string, lastOccurrenceTimestamp?: number | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null, interval: { __typename?: 'Duration', type: DurationType, amount: number } } };

export type DeleteRecurringTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRecurringTaskMutation = { __typename?: 'Mutation', deleteRecurringTask: { __typename?: 'RecurringTask', id: string, title: string, content?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, occurrences: number, currentOccurrence: number, startTimestamp: string, lastOccurrenceTimestamp?: number | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null, interval: { __typename?: 'Duration', type: DurationType, amount: number } } };

export type OnCreateRecurringTaskSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnCreateRecurringTaskSubscription = { __typename?: 'Subscription', onCreateRecurringTask?: { __typename?: 'RecurringTask', id: string, title: string, content?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, occurrences: number, currentOccurrence: number, startTimestamp: string, lastOccurrenceTimestamp?: number | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null, interval: { __typename?: 'Duration', type: DurationType, amount: number } } | null };

export type OnUpdateRecurringTaskSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnUpdateRecurringTaskSubscription = { __typename?: 'Subscription', onUpdateRecurringTask?: { __typename?: 'RecurringTask', id: string, title: string, content?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, occurrences: number, currentOccurrence: number, startTimestamp: string, lastOccurrenceTimestamp?: number | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null, interval: { __typename?: 'Duration', type: DurationType, amount: number } } | null };

export type OnDeleteRecurringTaskSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteRecurringTaskSubscription = { __typename?: 'Subscription', onDeleteRecurringTask?: { __typename?: 'RecurringTask', id: string } | null };

export type RehabPlanFragmentFragment = { __typename?: 'RehabPlan', id: string, residentId: string, diagnosis: Array<string>, location?: string | null, notes?: string | null, isActive: boolean, createdBy: string, createdAt: string, updatedAt: string, prescribedProcedures: Array<{ __typename?: 'PrescribedProcedure', id: string, name: string, description?: string | null, scheduledDays?: Array<number> | null }> };

export type RehabSessionFragmentFragment = { __typename?: 'RehabSession', id: string, residentId: string, planId: string, performedAt: string, performedBy: string, extraProcedures: Array<string>, location?: string | null, notes?: string | null, createdAt: string, completedProcedures: Array<{ __typename?: 'CompletedRehabProcedure', id: string, name: string }> };

export type GetRehabPlanByResidentIdQueryVariables = Exact<{
  residentId: Scalars['ID']['input'];
}>;


export type GetRehabPlanByResidentIdQuery = { __typename?: 'Query', getRehabPlanByResidentId?: { __typename?: 'RehabPlan', id: string, residentId: string, diagnosis: Array<string>, location?: string | null, notes?: string | null, isActive: boolean, createdBy: string, createdAt: string, updatedAt: string, prescribedProcedures: Array<{ __typename?: 'PrescribedProcedure', id: string, name: string, description?: string | null, scheduledDays?: Array<number> | null }> } | null };

export type GetRehabSessionsByResidentIdQueryVariables = Exact<{
  residentId: Scalars['ID']['input'];
}>;


export type GetRehabSessionsByResidentIdQuery = { __typename?: 'Query', getRehabSessionsByResidentId: Array<{ __typename?: 'RehabSession', id: string, residentId: string, planId: string, performedAt: string, performedBy: string, extraProcedures: Array<string>, location?: string | null, notes?: string | null, createdAt: string, completedProcedures: Array<{ __typename?: 'CompletedRehabProcedure', id: string, name: string }> }> };

export type CreateRehabPlanMutationVariables = Exact<{
  input: CreateRehabPlanInput;
}>;


export type CreateRehabPlanMutation = { __typename?: 'Mutation', createRehabPlan: { __typename?: 'RehabPlan', id: string, residentId: string, diagnosis: Array<string>, location?: string | null, notes?: string | null, isActive: boolean, createdBy: string, createdAt: string, updatedAt: string, prescribedProcedures: Array<{ __typename?: 'PrescribedProcedure', id: string, name: string, description?: string | null, scheduledDays?: Array<number> | null }> } };

export type UpdateRehabPlanMutationVariables = Exact<{
  input: UpdateRehabPlanInput;
}>;


export type UpdateRehabPlanMutation = { __typename?: 'Mutation', updateRehabPlan: { __typename?: 'RehabPlan', id: string, residentId: string, diagnosis: Array<string>, location?: string | null, notes?: string | null, isActive: boolean, createdBy: string, createdAt: string, updatedAt: string, prescribedProcedures: Array<{ __typename?: 'PrescribedProcedure', id: string, name: string, description?: string | null, scheduledDays?: Array<number> | null }> } };

export type ArchiveRehabPlanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveRehabPlanMutation = { __typename?: 'Mutation', archiveRehabPlan: { __typename?: 'RehabPlan', id: string, residentId: string, diagnosis: Array<string>, location?: string | null, notes?: string | null, isActive: boolean, createdBy: string, createdAt: string, updatedAt: string, prescribedProcedures: Array<{ __typename?: 'PrescribedProcedure', id: string, name: string, description?: string | null, scheduledDays?: Array<number> | null }> } };

export type CreateRehabSessionMutationVariables = Exact<{
  input: CreateRehabSessionInput;
}>;


export type CreateRehabSessionMutation = { __typename?: 'Mutation', createRehabSession: { __typename?: 'RehabSession', id: string, residentId: string, planId: string, performedAt: string, performedBy: string, extraProcedures: Array<string>, location?: string | null, notes?: string | null, createdAt: string, completedProcedures: Array<{ __typename?: 'CompletedRehabProcedure', id: string, name: string }> } };

export type ResidentBaseFragmentFragment = { __typename?: 'Resident', id: string, personalNumber: string, roomId?: string | null, avatar?: string | null, status: ResidentStatus, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string } };

export type ResidentFragmentFragment = { __typename?: 'Resident', dateOfBirth: string, accommodatedSince?: string | null, accommodatedUntil?: string | null, disabilityCertificate?: boolean | null, additionalInformation?: string | null, id: string, personalNumber: string, roomId?: string | null, avatar?: string | null, status: ResidentStatus, contactPersons: Array<{ __typename?: 'ContactPerson', id?: string | null, phoneNumber?: string | null, email?: string | null, address?: { __typename?: 'Address', city: string, country: string, street: string, zipCode: string } | null, name: { __typename?: 'PersonName', middleName?: string | null, lastName: string, firstName: string } }>, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string } };

export type GetAllCurrentResidentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCurrentResidentsQuery = { __typename?: 'Query', getAllCurrentResidents: Array<{ __typename?: 'Resident', dateOfBirth: string, accommodatedSince?: string | null, accommodatedUntil?: string | null, disabilityCertificate?: boolean | null, additionalInformation?: string | null, id: string, personalNumber: string, roomId?: string | null, avatar?: string | null, status: ResidentStatus, contactPersons: Array<{ __typename?: 'ContactPerson', id?: string | null, phoneNumber?: string | null, email?: string | null, address?: { __typename?: 'Address', city: string, country: string, street: string, zipCode: string } | null, name: { __typename?: 'PersonName', middleName?: string | null, lastName: string, firstName: string } }>, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string } }> };

export type GetAllPendingResidentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPendingResidentsQuery = { __typename?: 'Query', getAllPendingResidents: Array<{ __typename?: 'Resident', dateOfBirth: string, accommodatedSince?: string | null, accommodatedUntil?: string | null, disabilityCertificate?: boolean | null, additionalInformation?: string | null, id: string, personalNumber: string, roomId?: string | null, avatar?: string | null, status: ResidentStatus, contactPersons: Array<{ __typename?: 'ContactPerson', id?: string | null, phoneNumber?: string | null, email?: string | null, address?: { __typename?: 'Address', city: string, country: string, street: string, zipCode: string } | null, name: { __typename?: 'PersonName', middleName?: string | null, lastName: string, firstName: string } }>, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string } }> };

export type GetAllOldResidentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOldResidentsQuery = { __typename?: 'Query', getAllOldResidents: Array<{ __typename?: 'Resident', dateOfBirth: string, accommodatedSince?: string | null, accommodatedUntil?: string | null, disabilityCertificate?: boolean | null, additionalInformation?: string | null, id: string, personalNumber: string, roomId?: string | null, avatar?: string | null, status: ResidentStatus, contactPersons: Array<{ __typename?: 'ContactPerson', id?: string | null, phoneNumber?: string | null, email?: string | null, address?: { __typename?: 'Address', city: string, country: string, street: string, zipCode: string } | null, name: { __typename?: 'PersonName', middleName?: string | null, lastName: string, firstName: string } }>, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string } }> };

export type GetAllCurrentResidentsForInputQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCurrentResidentsForInputQuery = { __typename?: 'Query', getAllCurrentResidents: Array<{ __typename?: 'Resident', id: string, personalNumber: string, roomId?: string | null, avatar?: string | null, status: ResidentStatus, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string } }> };

export type GetAllResidentsForInputQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllResidentsForInputQuery = { __typename?: 'Query', getAllResidents: Array<{ __typename?: 'Resident', id: string, personalNumber: string, roomId?: string | null, avatar?: string | null, status: ResidentStatus, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string } }> };

export type GetResidentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResidentQuery = { __typename?: 'Query', getResidentById: { __typename?: 'Resident', id: string, personalNumber: string, createdBy: string, createdAt: string, updatedAt: string, accommodatedSince?: string | null, accommodatedUntil?: string | null, dateOfBirth: string, conditions?: Array<string> | null, disabilityCertificate?: boolean | null, additionalInformation?: string | null, roomId?: string | null, avatar?: string | null, status: ResidentStatus, media?: Array<{ __typename?: 'Media', id: string, extension: string, fileName: string, size: number, isSharedToAuthorizedRelative?: boolean | null, uploadedBy?: string | null, firstDownloadByAuthorizedRelative?: { __typename?: 'MediaDownloadRecord', downloadedBy: string, downloadedAt: number, fileId: string } | null }> | null, contactPersons: Array<{ __typename?: 'ContactPerson', id?: string | null, phoneNumber?: string | null, email?: string | null, address?: { __typename?: 'Address', city: string, country: string, street: string, zipCode: string } | null, name: { __typename?: 'PersonName', middleName?: string | null, lastName: string, firstName: string } }>, name: { __typename?: 'PersonName', firstName: string, lastName: string, middleName?: string | null } } };

export type DownloadResidentMediaQueryVariables = Exact<{
  input: DownloadMediaInput;
}>;


export type DownloadResidentMediaQuery = { __typename?: 'Query', downloadMedia: { __typename?: 'DownloadMediaResponse', url: string } };

export type GetResidentInfoForAmbulanceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResidentInfoForAmbulanceQuery = { __typename?: 'Query', getResidentInfoForAmbulance: { __typename?: 'ResidentInfoForAmbulance', id: string, personalNumber: string, dateOfBirth: string, conditions?: Array<string> | null, contactPersonPhoneNumber?: string | null, careFacilityPhoneNumber?: string | null, reportCreatedAt: string, name: { __typename?: 'PersonName', firstName: string, lastName: string, middleName?: string | null }, contactPersonName?: { __typename?: 'PersonName', firstName: string, lastName: string, middleName?: string | null } | null, residentMedications: Array<{ __typename?: 'ResidentMedication', id: string, medicationName: string, startDate?: string | null, endDate?: string | null, notes?: string | null, treatmentType?: TreatmentType | null, warnings?: string | null, schedule: { __typename?: 'Schedule', daysOfWeek?: Array<number | null> | null, dosageDetails: Array<{ __typename?: 'DosageDetails', timeType: TimeType, time?: string | null, timeOfDay?: PartOfTheDay | null, customInstructions?: string | null, relationToFood?: MedicationFoodRelation | null, dosage: { __typename?: 'Dosage', unit: UnitType, quantity: string } } | null> } }>, healthLogMeasurements: Array<{ __typename?: 'HealthLogMeasurement', residentId: string, updatedAt: string, metricId: string, values: string, recordedAt: string }>, events: Array<{ __typename?: 'Event', id: string, date: string, type: EventType, eventSubType: EventSubType, content: string }> } };

export type GetAllMediaDownloadsForFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAllMediaDownloadsForFileQuery = { __typename?: 'Query', getAllMediaDownloadsForFile: Array<{ __typename?: 'MediaDownloadRecord', downloadedAt: number, fileId: string, downloadedBy: string, isAuthorizedRelative: boolean, pairingId: string }> };

export type UpdateResidentMutationVariables = Exact<{
  input: UpdateResidentInput;
}>;


export type UpdateResidentMutation = { __typename?: 'Mutation', updateResident: { __typename?: 'Resident', id: string } };

export type DeleteResidentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteResidentMutation = { __typename?: 'Mutation', deleteResident: { __typename?: 'Resident', id: string } };

export type DeactivateResidentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivateResidentMutation = { __typename?: 'Mutation', deactivateResident: { __typename?: 'Resident', id: string } };

export type AdmitResidentMutationVariables = Exact<{
  input: AdmitResidentInput;
}>;


export type AdmitResidentMutation = { __typename?: 'Mutation', admitResident: { __typename?: 'Resident', id: string } };

export type ReassignResidentRoomMutationVariables = Exact<{
  input: ReassignResidentRoomInput;
}>;


export type ReassignResidentRoomMutation = { __typename?: 'Mutation', reassignResidentRoom: { __typename?: 'Resident', id: string } };

export type SaveResidentAvatarMutationVariables = Exact<{
  input: SaveAvatarInput;
}>;


export type SaveResidentAvatarMutation = { __typename?: 'Mutation', saveResidentAvatar: { __typename?: 'SaveMediaResponse', url: string } };

export type DeleteResidentAvatarMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteResidentAvatarMutation = { __typename?: 'Mutation', deleteResidentAvatar: { __typename?: 'Resident', id: string } };

export type CreateResidentMutationVariables = Exact<{
  input: CreateResidentInput;
}>;


export type CreateResidentMutation = { __typename?: 'Mutation', createResident: { __typename?: 'Resident', id: string } };

export type MarkResidentAsAbsentMutationVariables = Exact<{
  input: MarkResidentAsAbsentInput;
}>;


export type MarkResidentAsAbsentMutation = { __typename?: 'Mutation', markResidentAsAbsent: { __typename?: 'Resident', id: string } };

export type UnmarkResidentAsAbsentMutationVariables = Exact<{
  input: MarkResidentAsAbsentInput;
}>;


export type UnmarkResidentAsAbsentMutation = { __typename?: 'Mutation', unmarkResidentAsAbsent: { __typename?: 'Resident', id: string } };

export type SaveResidentMediaMutationVariables = Exact<{
  input: SaveResidentMediaInput;
}>;


export type SaveResidentMediaMutation = { __typename?: 'Mutation', saveResidentMedia: { __typename?: 'SaveMediaResponse', url: string } };

export type DeleteResidentMediaMutationVariables = Exact<{
  input: DeleteResidentMediaInput;
}>;


export type DeleteResidentMediaMutation = { __typename?: 'Mutation', deleteResidentMedia: { __typename?: 'Media', size: number, fileName: string, extension: string, id: string, isSharedToAuthorizedRelative?: boolean | null } };

export type ShareResidentMediaWithAuthorizedRelativeMutationVariables = Exact<{
  input: ShareResidentMediaWithAuthorizedRelativeInput;
}>;


export type ShareResidentMediaWithAuthorizedRelativeMutation = { __typename?: 'Mutation', shareResidentMediaWithAuthorizedRelative: { __typename?: 'Media', id: string, fileName: string, extension: string, size: number, uploadedBy?: string | null, isSharedToAuthorizedRelative?: boolean | null } };

export type GetRoomsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoomsQuery = { __typename?: 'Query', getRooms: Array<{ __typename?: 'Room', id: string, roomNumber: string, residents: Array<string | null>, floor?: number | null, capacity: number, building?: string | null, createdBy: string }> };

export type GetRoomByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRoomByIdQuery = { __typename?: 'Query', getRoomById: { __typename?: 'Room', id: string, roomNumber: string, building?: string | null, capacity: number, floor?: number | null, residents: Array<string | null> } };

export type CreateRoomMutationVariables = Exact<{
  input: CreateRoomInput;
}>;


export type CreateRoomMutation = { __typename?: 'Mutation', createRoom: { __typename?: 'Room', roomNumber: string, id: string } };

export type UpdateRoomMutationVariables = Exact<{
  input: UpdateRoomInput;
}>;


export type UpdateRoomMutation = { __typename?: 'Mutation', updateRoom: { __typename?: 'Room', roomNumber: string, id: string } };

export type DeleteRoomMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRoomMutation = { __typename?: 'Mutation', deleteRoom: { __typename?: 'Room', roomNumber: string, id: string } };

export type GetTasksWithDateRangeQueryVariables = Exact<{
  input?: InputMaybe<GetTasksWithDateRangeInput>;
}>;


export type GetTasksWithDateRangeQuery = { __typename?: 'Query', getTasksWithDateRange: Array<{ __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null }> };

export type GetTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaskQuery = { __typename?: 'Query', getTask: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } };

export type GetTasksForWorkingDayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTasksForWorkingDayQuery = { __typename?: 'Query', getTasksForWorkingDay: Array<{ __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null }> };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, isLimitedToJobRoles: boolean, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, isLimitedToJobRoles: boolean, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } };

export type CompleteTaskMutationVariables = Exact<{
  input: CompleteTaskInput;
}>;


export type CompleteTaskMutation = { __typename?: 'Mutation', completeTask: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, isLimitedToJobRoles: boolean, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } };

export type UncompleteTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UncompleteTaskMutation = { __typename?: 'Mutation', uncompleteTask: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, isLimitedToJobRoles: boolean, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } };

export type RejectTaskMutationVariables = Exact<{
  input: RejectTaskInput;
}>;


export type RejectTaskMutation = { __typename?: 'Mutation', rejectTask: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, isLimitedToJobRoles: boolean, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } };

export type DeleteTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'Task', id: string, jobRoleIds?: Array<string> | null, isLimitedToJobRoles: boolean } };

export type DownloadResidentTaskArchiveQueryVariables = Exact<{
  input: DownloadResidentTaskArchiveInput;
}>;


export type DownloadResidentTaskArchiveQuery = { __typename?: 'Query', downloadResidentTaskArchive: { __typename?: 'ResidentTaskArchiveDownload', url: string, fileName: string, numberOfMonths: number } };

export type OnCreateTaskSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnCreateTaskSubscription = { __typename?: 'Subscription', onCreateTask?: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } | null };

export type OnCreateTasksSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnCreateTasksSubscription = { __typename?: 'Subscription', onCreateTasks?: { __typename?: 'CreatedTasks', jobRoleIds?: Array<string> | null, tasks: Array<{ __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null }> } | null };

export type OnUpdateTaskSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnUpdateTaskSubscription = { __typename?: 'Subscription', onUpdateTask?: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } | null };

export type OnCompleteTaskSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnCompleteTaskSubscription = { __typename?: 'Subscription', onCompleteTask?: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } | null };

export type OnUnCompleteTaskSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnUnCompleteTaskSubscription = { __typename?: 'Subscription', onUncompleteTask?: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } | null };

export type OnRejectTaskSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnRejectTaskSubscription = { __typename?: 'Subscription', onRejectTask?: { __typename?: 'Task', id: string, title: string, content?: string | null, date?: string | null, createdAt: string, completedAt?: string | null, completedBy?: string | null, assignedToEmployee?: string | null, assignedToResident?: string | null, parentRecurringTaskId?: string | null, rejectionNote?: string | null, comment?: string | null, jobRoleIds?: Array<string> | null, completeUntil?: { __typename?: 'CompleteUntil', time?: string | null, partOfTheDay?: PartOfTheDay | null } | null } | null };

export type OnDeleteTaskSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDeleteTaskSubscription = { __typename?: 'Subscription', onDeleteTask?: { __typename?: 'Task', id: string, jobRoleIds?: Array<string> | null } | null };

export type GetMyUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyUserInfoQuery = { __typename?: 'Query', getMyUserInfo?: { __typename?: 'User', id: string, userName: string, personalNumber: string, group: UserGroup, avatar?: string | null, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string }, approvedConditions?: { __typename?: 'ApprovedConditions', termsAndConditions?: { __typename?: 'ApprovedAt', approvedAt: string } | null, globalTermsAndConditions?: { __typename?: 'ApprovedAt', approvedAt: string } | null, globalPrivacyPolicy?: { __typename?: 'ApprovedAt', approvedAt: string } | null } | null } | null };

export type GetAllUsersForInputQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersForInputQuery = { __typename?: 'Query', getAllUsers: Array<{ __typename?: 'User', id: string, userName: string, personalNumber: string, group: UserGroup, avatar?: string | null, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string } }> };

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersQuery = { __typename?: 'Query', getAllUsers: Array<{ __typename?: 'User', id: string, userName: string, personalNumber: string, group: UserGroup, avatar?: string | null, jobRoleId?: string | null, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string } }> };

export type GetUserByUserNameQueryVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type GetUserByUserNameQuery = { __typename?: 'Query', getUserByUserName: { __typename?: 'User', id: string, userName: string, personalNumber: string, group: UserGroup, avatar?: string | null, jobRoleId?: string | null, name: { __typename?: 'PersonName', firstName: string, middleName?: string | null, lastName: string } } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, userName: string } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, userName: string } };

export type UserApproveConditionsMutationVariables = Exact<{
  input?: InputMaybe<UserApproveConditionsInput>;
}>;


export type UserApproveConditionsMutation = { __typename?: 'Mutation', userApproveConditions: { __typename?: 'User', id: string, userName: string, approvedConditions?: { __typename?: 'ApprovedConditions', termsAndConditions?: { __typename?: 'ApprovedAt', approvedAt: string } | null, globalTermsAndConditions?: { __typename?: 'ApprovedAt', approvedAt: string } | null, globalPrivacyPolicy?: { __typename?: 'ApprovedAt', approvedAt: string } | null } | null } };

export type ApproveGlobalPrivacyPolicyMutationVariables = Exact<{ [key: string]: never; }>;


export type ApproveGlobalPrivacyPolicyMutation = { __typename?: 'Mutation', approveGlobalPrivacyPolicy?: boolean | null };

export type ApproveGlobalTermsAndConditionsMutationVariables = Exact<{ [key: string]: never; }>;


export type ApproveGlobalTermsAndConditionsMutation = { __typename?: 'Mutation', approveGlobalTermsAndConditions?: boolean | null };

export type GetGlobalApprovalStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalApprovalStatusQuery = { __typename?: 'Query', getGlobalApprovalStatus?: { __typename?: 'GlobalApprovalStatus', globalTermsAndConditions: boolean, globalPrivacyPolicy: boolean } | null };

export type GenerateIdentityTokenMutationVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type GenerateIdentityTokenMutation = { __typename?: 'Mutation', generateIdentityToken: { __typename?: 'GeneratedIdentityToken', token: string } };

export type GenerateTemporaryPasswordMutationVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type GenerateTemporaryPasswordMutation = { __typename?: 'Mutation', generateTemporaryPassword: { __typename?: 'GenerateTemporaryPasswordResponse', tempPassword: string } };

export type DeleteUserMutationVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string, userName: string } };

export type SaveUserAvatarMutationVariables = Exact<{
  input: SaveAvatarInput;
}>;


export type SaveUserAvatarMutation = { __typename?: 'Mutation', saveUserAvatar: { __typename?: 'SaveMediaResponse', url: string } };

export type GetJobRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobRolesQuery = { __typename?: 'Query', getJobRoles: Array<{ __typename?: 'JobRole', id: string, name: string, color: string, createdAt: string, updatedAt: string }> };

export type GetJobRoleByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetJobRoleByIdQuery = { __typename?: 'Query', getJobRoleById?: { __typename?: 'JobRole', id: string, name: string, color: string, createdAt: string, updatedAt: string } | null };

export type CreateJobRoleMutationVariables = Exact<{
  input: CreateJobRoleInput;
}>;


export type CreateJobRoleMutation = { __typename?: 'Mutation', createJobRole: { __typename?: 'JobRole', id: string, name: string, color: string, createdAt: string, updatedAt: string } };

export type UpdateJobRoleMutationVariables = Exact<{
  input: UpdateJobRoleInput;
}>;


export type UpdateJobRoleMutation = { __typename?: 'Mutation', updateJobRole: { __typename?: 'JobRole', id: string, name: string, color: string, createdAt: string, updatedAt: string } };

export type DeleteJobRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteJobRoleMutation = { __typename?: 'Mutation', deleteJobRole: { __typename?: 'JobRole', id: string } };

export type PlannedShiftFragmentFragment = { __typename?: 'PlannedShift', id: string, userId: string, jobRoleId: string, jobRoleName?: string | null, jobRoleColor?: string | null, startsAt: string, endsAt: string };

export type WorkScheduleWeekFragmentFragment = { __typename?: 'WorkScheduleWeek', weekStart: string, status: WorkScheduleStatus, publishedAt?: string | null, updatedAt: string, shifts: Array<{ __typename?: 'PlannedShift', id: string, userId: string, jobRoleId: string, jobRoleName?: string | null, jobRoleColor?: string | null, startsAt: string, endsAt: string }>, requirements: Array<{ __typename?: 'StaffingRequirement', id: string, jobRoleId: string, jobRoleName: string, jobRoleColor: string, minimumHeadcount: number, dates: Array<{ __typename?: 'StaffingRequirementDate', startsAt: string, endsAt: string }> }>, shortages: Array<{ __typename?: 'CoverageShortage', requirementId: string, jobRoleId: string, startsAt: string, endsAt: string, requiredCount: number, assignedCount: number }> };

export type GetWorkScheduleWeekQueryVariables = Exact<{
  weekStart: Scalars['AWSDate']['input'];
}>;


export type GetWorkScheduleWeekQuery = { __typename?: 'Query', getWorkScheduleWeek?: { __typename?: 'WorkScheduleWeek', weekStart: string, status: WorkScheduleStatus, publishedAt?: string | null, updatedAt: string, shifts: Array<{ __typename?: 'PlannedShift', id: string, userId: string, jobRoleId: string, jobRoleName?: string | null, jobRoleColor?: string | null, startsAt: string, endsAt: string }>, requirements: Array<{ __typename?: 'StaffingRequirement', id: string, jobRoleId: string, jobRoleName: string, jobRoleColor: string, minimumHeadcount: number, dates: Array<{ __typename?: 'StaffingRequirementDate', startsAt: string, endsAt: string }> }>, shortages: Array<{ __typename?: 'CoverageShortage', requirementId: string, jobRoleId: string, startsAt: string, endsAt: string, requiredCount: number, assignedCount: number }> } | null };

export type GetWorkScheduleMonthQueryVariables = Exact<{
  monthStart: Scalars['AWSDate']['input'];
}>;


export type GetWorkScheduleMonthQuery = { __typename?: 'Query', getWorkScheduleMonth: Array<{ __typename?: 'PlannedShift', id: string, userId: string, jobRoleId: string, jobRoleName?: string | null, jobRoleColor?: string | null, startsAt: string, endsAt: string }> };

export type SavePlannedShiftMutationVariables = Exact<{
  input: PlannedShiftInput;
}>;


export type SavePlannedShiftMutation = { __typename?: 'Mutation', savePlannedShift: { __typename?: 'WorkScheduleWeek', weekStart: string, status: WorkScheduleStatus, publishedAt?: string | null, updatedAt: string, shifts: Array<{ __typename?: 'PlannedShift', id: string, userId: string, jobRoleId: string, jobRoleName?: string | null, jobRoleColor?: string | null, startsAt: string, endsAt: string }>, requirements: Array<{ __typename?: 'StaffingRequirement', id: string, jobRoleId: string, jobRoleName: string, jobRoleColor: string, minimumHeadcount: number, dates: Array<{ __typename?: 'StaffingRequirementDate', startsAt: string, endsAt: string }> }>, shortages: Array<{ __typename?: 'CoverageShortage', requirementId: string, jobRoleId: string, startsAt: string, endsAt: string, requiredCount: number, assignedCount: number }> } };

export type DeletePlannedShiftMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  weekStart: Scalars['AWSDate']['input'];
}>;


export type DeletePlannedShiftMutation = { __typename?: 'Mutation', deletePlannedShift: { __typename?: 'PlannedShift', id: string } };

export type PublishWorkScheduleWeekMutationVariables = Exact<{
  weekStart: Scalars['AWSDate']['input'];
}>;


export type PublishWorkScheduleWeekMutation = { __typename?: 'Mutation', publishWorkScheduleWeek: { __typename?: 'WorkScheduleWeek', weekStart: string, status: WorkScheduleStatus, publishedAt?: string | null, updatedAt: string, shifts: Array<{ __typename?: 'PlannedShift', id: string, userId: string, jobRoleId: string, jobRoleName?: string | null, jobRoleColor?: string | null, startsAt: string, endsAt: string }>, requirements: Array<{ __typename?: 'StaffingRequirement', id: string, jobRoleId: string, jobRoleName: string, jobRoleColor: string, minimumHeadcount: number, dates: Array<{ __typename?: 'StaffingRequirementDate', startsAt: string, endsAt: string }> }>, shortages: Array<{ __typename?: 'CoverageShortage', requirementId: string, jobRoleId: string, startsAt: string, endsAt: string, requiredCount: number, assignedCount: number }> } };

export type DiscardWorkScheduleWeekChangesMutationVariables = Exact<{
  weekStart: Scalars['AWSDate']['input'];
}>;


export type DiscardWorkScheduleWeekChangesMutation = { __typename?: 'Mutation', discardWorkScheduleWeekChanges: { __typename?: 'WorkScheduleWeek', weekStart: string, status: WorkScheduleStatus, publishedAt?: string | null, updatedAt: string, shifts: Array<{ __typename?: 'PlannedShift', id: string, userId: string, jobRoleId: string, jobRoleName?: string | null, jobRoleColor?: string | null, startsAt: string, endsAt: string }>, requirements: Array<{ __typename?: 'StaffingRequirement', id: string, jobRoleId: string, jobRoleName: string, jobRoleColor: string, minimumHeadcount: number, dates: Array<{ __typename?: 'StaffingRequirementDate', startsAt: string, endsAt: string }> }>, shortages: Array<{ __typename?: 'CoverageShortage', requirementId: string, jobRoleId: string, startsAt: string, endsAt: string, requiredCount: number, assignedCount: number }> } };

export type AddPlannedShiftsMutationVariables = Exact<{
  weekStart: Scalars['AWSDate']['input'];
  shifts: Array<NewPlannedShiftInput> | NewPlannedShiftInput;
}>;


export type AddPlannedShiftsMutation = { __typename?: 'Mutation', addPlannedShifts: { __typename?: 'WorkScheduleWeek', weekStart: string, status: WorkScheduleStatus, publishedAt?: string | null, updatedAt: string, shifts: Array<{ __typename?: 'PlannedShift', id: string, userId: string, jobRoleId: string, jobRoleName?: string | null, jobRoleColor?: string | null, startsAt: string, endsAt: string }>, requirements: Array<{ __typename?: 'StaffingRequirement', id: string, jobRoleId: string, jobRoleName: string, jobRoleColor: string, minimumHeadcount: number, dates: Array<{ __typename?: 'StaffingRequirementDate', startsAt: string, endsAt: string }> }>, shortages: Array<{ __typename?: 'CoverageShortage', requirementId: string, jobRoleId: string, startsAt: string, endsAt: string, requiredCount: number, assignedCount: number }> } };

export type ReplacePlannedShiftsMutationVariables = Exact<{
  weekStart: Scalars['AWSDate']['input'];
  shifts: Array<NewPlannedShiftInput> | NewPlannedShiftInput;
  requirements?: InputMaybe<Array<StaffingRequirementInput> | StaffingRequirementInput>;
}>;


export type ReplacePlannedShiftsMutation = { __typename?: 'Mutation', replacePlannedShifts: { __typename?: 'WorkScheduleWeek', weekStart: string, status: WorkScheduleStatus, publishedAt?: string | null, updatedAt: string, shifts: Array<{ __typename?: 'PlannedShift', id: string, userId: string, jobRoleId: string, jobRoleName?: string | null, jobRoleColor?: string | null, startsAt: string, endsAt: string }>, requirements: Array<{ __typename?: 'StaffingRequirement', id: string, jobRoleId: string, jobRoleName: string, jobRoleColor: string, minimumHeadcount: number, dates: Array<{ __typename?: 'StaffingRequirementDate', startsAt: string, endsAt: string }> }>, shortages: Array<{ __typename?: 'CoverageShortage', requirementId: string, jobRoleId: string, startsAt: string, endsAt: string, requiredCount: number, assignedCount: number }> } };

export type GetMyWorkTimeStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyWorkTimeStatusQuery = { __typename?: 'Query', getMyWorkTimeStatus: { __typename?: 'MyWorkTimeStatus', state: WorkTimeSessionState, activeSession?: { __typename?: 'WorkTimeActiveSession', id: string, startedAt: string } | null } };

export type StartMyWorkTimeShiftMutationVariables = Exact<{ [key: string]: never; }>;


export type StartMyWorkTimeShiftMutation = { __typename?: 'Mutation', startMyWorkTimeShift: { __typename?: 'WorkTimeActiveSession', id: string, userId: string, startedAt: string } };

export type FinishMyWorkTimeShiftMutationVariables = Exact<{ [key: string]: never; }>;


export type FinishMyWorkTimeShiftMutation = { __typename?: 'Mutation', finishMyWorkTimeShift: { __typename?: 'WorkTimeEntry', id: string, userId: string, startedAt: string, endedAt?: string | null, totalMinutes?: number | null } };

export type GetMyWorkTimeEntriesByDateRangeQueryVariables = Exact<{
  input?: InputMaybe<GetMyWorkTimeEntriesInput>;
}>;


export type GetMyWorkTimeEntriesByDateRangeQuery = { __typename?: 'Query', getMyWorkTimeEntriesByDateRange: Array<{ __typename?: 'WorkTimeEntry', id: string, userId: string, startedAt: string, endedAt?: string | null, totalMinutes?: number | null, status?: WorkTimeEntryStatus | null, note?: string | null, createdAt: string, updatedAt: string }> };

export type GetWorkTimeEntriesByDateRangeQueryVariables = Exact<{
  input?: InputMaybe<GetWorkTimeEntriesInput>;
}>;


export type GetWorkTimeEntriesByDateRangeQuery = { __typename?: 'Query', getWorkTimeEntriesByDateRange: Array<{ __typename?: 'WorkTimeEntry', id: string, userId: string, startedAt: string, endedAt?: string | null, totalMinutes?: number | null, status?: WorkTimeEntryStatus | null, note?: string | null, createdAt: string, updatedAt: string }> };

export type GetWorkTimeEntryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkTimeEntryQuery = { __typename?: 'Query', getWorkTimeEntry: { __typename?: 'WorkTimeEntry', id: string, userId: string, startedAt: string, endedAt?: string | null, totalMinutes?: number | null, status?: WorkTimeEntryStatus | null, note?: string | null, createdAt: string, updatedAt: string } };

export type ApproveWorkTimeEntryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApproveWorkTimeEntryMutation = { __typename?: 'Mutation', approveWorkTimeEntry: { __typename?: 'WorkTimeEntry', id: string, userId: string, startedAt: string, endedAt?: string | null, totalMinutes?: number | null, status?: WorkTimeEntryStatus | null, note?: string | null, createdAt: string, updatedAt: string } };

export type RejectWorkTimeEntryMutationVariables = Exact<{
  input: RejectWorkTimeEntryInput;
}>;


export type RejectWorkTimeEntryMutation = { __typename?: 'Mutation', rejectWorkTimeEntry: { __typename?: 'WorkTimeEntry', id: string, userId: string, startedAt: string, endedAt?: string | null, totalMinutes?: number | null, status?: WorkTimeEntryStatus | null, note?: string | null, createdAt: string, updatedAt: string } };

export type CreateWorkTimeEntryMutationVariables = Exact<{
  input: CreateWorkTimeEntryInput;
}>;


export type CreateWorkTimeEntryMutation = { __typename?: 'Mutation', createWorkTimeEntry: { __typename?: 'WorkTimeEntry', id: string, userId: string, startedAt: string, endedAt?: string | null, totalMinutes?: number | null, status?: WorkTimeEntryStatus | null, note?: string | null, createdAt: string, updatedAt: string } };

export type UpdateWorkTimeEntryMutationVariables = Exact<{
  input: UpdateWorkTimeEntryInput;
}>;


export type UpdateWorkTimeEntryMutation = { __typename?: 'Mutation', updateWorkTimeEntry: { __typename?: 'WorkTimeEntry', id: string, userId: string, startedAt: string, endedAt?: string | null, totalMinutes?: number | null, status?: WorkTimeEntryStatus | null, note?: string | null, createdAt: string, updatedAt: string } };

export type DeleteWorkTimeEntryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWorkTimeEntryMutation = { __typename?: 'Mutation', deleteWorkTimeEntry: { __typename?: 'WorkTimeEntry', id: string } };


export const AbsenceRequestFragmentFragmentDoc = `
    fragment AbsenceRequestFragment on AbsenceRequest {
  id
  userId
  type
  status
  startsAt
  endsAt
  requestedBy
  createdAt
  updatedAt
  approvedBy
  rejectedBy
  notes
  isAllDay
}
    `;
export const HealthLogMetricDefinitionFragmentFragmentDoc = `
    fragment HealthLogMetricDefinitionFragment on HealthLogMetricDefinition {
  id
  enabled
  fields {
    name
    unit
  }
}
    `;
export const HealthLogMeasurementFragmentFragmentDoc = `
    fragment HealthLogMeasurementFragment on HealthLogMeasurement {
  residentId
  metricId
  recordedAt
  values
  updatedAt
}
    `;
export const HealthLogMeasurementConnectionFragmentFragmentDoc = `
    fragment HealthLogMeasurementConnectionFragment on HealthLogMeasurementConnection {
  items {
    ...HealthLogMeasurementFragment
  }
  nextToken
}
    ${HealthLogMeasurementFragmentFragmentDoc}`;
export const ResidentMedicationFragmentFragmentDoc = `
    fragment ResidentMedicationFragment on ResidentMedication {
  id
  residentId
  medicationName
  startDate
  endDate
  productId
  treatmentType
  form
  warnings
  showForDistribution
  schedule {
    daysOfWeek
    dosageDetails {
      timeType
      time
      timeOfDay
      dosage {
        unit
        quantity
      }
      customInstructions
      relationToFood
    }
  }
  notes
}
    `;
export const RehabPlanFragmentFragmentDoc = `
    fragment RehabPlanFragment on RehabPlan {
  id
  residentId
  diagnosis
  prescribedProcedures {
    id
    name
    description
    scheduledDays
  }
  location
  notes
  isActive
  createdBy
  createdAt
  updatedAt
}
    `;
export const RehabSessionFragmentFragmentDoc = `
    fragment RehabSessionFragment on RehabSession {
  id
  residentId
  planId
  performedAt
  performedBy
  completedProcedures {
    id
    name
  }
  extraProcedures
  location
  notes
  createdAt
}
    `;
export const ResidentBaseFragmentFragmentDoc = `
    fragment ResidentBaseFragment on Resident {
  id
  personalNumber
  roomId
  avatar
  name {
    firstName
    middleName
    lastName
  }
  status
}
    `;
export const ResidentFragmentFragmentDoc = `
    fragment ResidentFragment on Resident {
  ...ResidentBaseFragment
  dateOfBirth
  accommodatedSince
  accommodatedUntil
  disabilityCertificate
  additionalInformation
  contactPersons {
    id
    address {
      city
      country
      street
      zipCode
    }
    name {
      middleName
      lastName
      firstName
    }
    phoneNumber
    email
  }
}
    ${ResidentBaseFragmentFragmentDoc}`;
export const PlannedShiftFragmentFragmentDoc = `
    fragment PlannedShiftFragment on PlannedShift {
  id
  userId
  jobRoleId
  jobRoleName
  jobRoleColor
  startsAt
  endsAt
}
    `;
export const WorkScheduleWeekFragmentFragmentDoc = `
    fragment WorkScheduleWeekFragment on WorkScheduleWeek {
  weekStart
  status
  publishedAt
  updatedAt
  shifts {
    ...PlannedShiftFragment
  }
  requirements {
    id
    dates {
      startsAt
      endsAt
    }
    jobRoleId
    jobRoleName
    jobRoleColor
    minimumHeadcount
  }
  shortages {
    requirementId
    jobRoleId
    startsAt
    endsAt
    requiredCount
    assignedCount
  }
}
    ${PlannedShiftFragmentFragmentDoc}`;
export const GetAbsenceRequestsDocument = `
    query GetAbsenceRequests($startDate: AWSDate, $endDate: AWSDate) {
  getAbsenceRequests(startDate: $startDate, endDate: $endDate) {
    ...AbsenceRequestFragment
  }
}
    ${AbsenceRequestFragmentFragmentDoc}`;

export const useGetAbsenceRequestsQuery = <
      TData = GetAbsenceRequestsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAbsenceRequestsQueryVariables,
      options?: Omit<UseQueryOptions<GetAbsenceRequestsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAbsenceRequestsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAbsenceRequestsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAbsenceRequests'] : ['GetAbsenceRequests', variables],
    queryFn: fetcher<GetAbsenceRequestsQuery, GetAbsenceRequestsQueryVariables>(client, GetAbsenceRequestsDocument, variables, headers),
    ...options
  }
    )};

useGetAbsenceRequestsQuery.document = GetAbsenceRequestsDocument;

useGetAbsenceRequestsQuery.getKey = (variables?: GetAbsenceRequestsQueryVariables) => variables === undefined ? ['GetAbsenceRequests'] : ['GetAbsenceRequests', variables];


useGetAbsenceRequestsQuery.fetcher = (client: GraphQLClient, variables?: GetAbsenceRequestsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAbsenceRequestsQuery, GetAbsenceRequestsQueryVariables>(client, GetAbsenceRequestsDocument, variables, headers);

export const CountPendingAbsenceRequestsDocument = `
    query CountPendingAbsenceRequests {
  countPendingAbsenceRequests
}
    `;

export const useCountPendingAbsenceRequestsQuery = <
      TData = CountPendingAbsenceRequestsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CountPendingAbsenceRequestsQueryVariables,
      options?: Omit<UseQueryOptions<CountPendingAbsenceRequestsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CountPendingAbsenceRequestsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<CountPendingAbsenceRequestsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CountPendingAbsenceRequests'] : ['CountPendingAbsenceRequests', variables],
    queryFn: fetcher<CountPendingAbsenceRequestsQuery, CountPendingAbsenceRequestsQueryVariables>(client, CountPendingAbsenceRequestsDocument, variables, headers),
    ...options
  }
    )};

useCountPendingAbsenceRequestsQuery.document = CountPendingAbsenceRequestsDocument;

useCountPendingAbsenceRequestsQuery.getKey = (variables?: CountPendingAbsenceRequestsQueryVariables) => variables === undefined ? ['CountPendingAbsenceRequests'] : ['CountPendingAbsenceRequests', variables];


useCountPendingAbsenceRequestsQuery.fetcher = (client: GraphQLClient, variables?: CountPendingAbsenceRequestsQueryVariables, headers?: RequestInit['headers']) => fetcher<CountPendingAbsenceRequestsQuery, CountPendingAbsenceRequestsQueryVariables>(client, CountPendingAbsenceRequestsDocument, variables, headers);

export const RequestAbsenceDocument = `
    mutation RequestAbsence($input: RequestAbsenceInput!) {
  requestAbsence(input: $input) {
    ...AbsenceRequestFragment
  }
}
    ${AbsenceRequestFragmentFragmentDoc}`;

export const useRequestAbsenceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestAbsenceMutation, TError, RequestAbsenceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<RequestAbsenceMutation, TError, RequestAbsenceMutationVariables, TContext>(
      {
    mutationKey: ['RequestAbsence'],
    mutationFn: (variables?: RequestAbsenceMutationVariables) => fetcher<RequestAbsenceMutation, RequestAbsenceMutationVariables>(client, RequestAbsenceDocument, variables, headers)(),
    ...options
  }
    )};

useRequestAbsenceMutation.getKey = () => ['RequestAbsence'];


useRequestAbsenceMutation.fetcher = (client: GraphQLClient, variables: RequestAbsenceMutationVariables, headers?: RequestInit['headers']) => fetcher<RequestAbsenceMutation, RequestAbsenceMutationVariables>(client, RequestAbsenceDocument, variables, headers);

export const CreateAbsenceRequestDocument = `
    mutation CreateAbsenceRequest($input: CreateAbsenceRequestInput!) {
  createAbsenceRequest(input: $input) {
    ...AbsenceRequestFragment
  }
}
    ${AbsenceRequestFragmentFragmentDoc}`;

export const useCreateAbsenceRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAbsenceRequestMutation, TError, CreateAbsenceRequestMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateAbsenceRequestMutation, TError, CreateAbsenceRequestMutationVariables, TContext>(
      {
    mutationKey: ['CreateAbsenceRequest'],
    mutationFn: (variables?: CreateAbsenceRequestMutationVariables) => fetcher<CreateAbsenceRequestMutation, CreateAbsenceRequestMutationVariables>(client, CreateAbsenceRequestDocument, variables, headers)(),
    ...options
  }
    )};

useCreateAbsenceRequestMutation.getKey = () => ['CreateAbsenceRequest'];


useCreateAbsenceRequestMutation.fetcher = (client: GraphQLClient, variables: CreateAbsenceRequestMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateAbsenceRequestMutation, CreateAbsenceRequestMutationVariables>(client, CreateAbsenceRequestDocument, variables, headers);

export const ApproveAbsenceRequestDocument = `
    mutation ApproveAbsenceRequest($input: ApproveAbsenceRequestInput!) {
  approveAbsenceRequest(input: $input) {
    ...AbsenceRequestFragment
  }
}
    ${AbsenceRequestFragmentFragmentDoc}`;

export const useApproveAbsenceRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApproveAbsenceRequestMutation, TError, ApproveAbsenceRequestMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ApproveAbsenceRequestMutation, TError, ApproveAbsenceRequestMutationVariables, TContext>(
      {
    mutationKey: ['ApproveAbsenceRequest'],
    mutationFn: (variables?: ApproveAbsenceRequestMutationVariables) => fetcher<ApproveAbsenceRequestMutation, ApproveAbsenceRequestMutationVariables>(client, ApproveAbsenceRequestDocument, variables, headers)(),
    ...options
  }
    )};

useApproveAbsenceRequestMutation.getKey = () => ['ApproveAbsenceRequest'];


useApproveAbsenceRequestMutation.fetcher = (client: GraphQLClient, variables: ApproveAbsenceRequestMutationVariables, headers?: RequestInit['headers']) => fetcher<ApproveAbsenceRequestMutation, ApproveAbsenceRequestMutationVariables>(client, ApproveAbsenceRequestDocument, variables, headers);

export const RejectAbsenceRequestDocument = `
    mutation RejectAbsenceRequest($id: ID!) {
  rejectAbsenceRequest(id: $id) {
    ...AbsenceRequestFragment
  }
}
    ${AbsenceRequestFragmentFragmentDoc}`;

export const useRejectAbsenceRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RejectAbsenceRequestMutation, TError, RejectAbsenceRequestMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<RejectAbsenceRequestMutation, TError, RejectAbsenceRequestMutationVariables, TContext>(
      {
    mutationKey: ['RejectAbsenceRequest'],
    mutationFn: (variables?: RejectAbsenceRequestMutationVariables) => fetcher<RejectAbsenceRequestMutation, RejectAbsenceRequestMutationVariables>(client, RejectAbsenceRequestDocument, variables, headers)(),
    ...options
  }
    )};

useRejectAbsenceRequestMutation.getKey = () => ['RejectAbsenceRequest'];


useRejectAbsenceRequestMutation.fetcher = (client: GraphQLClient, variables: RejectAbsenceRequestMutationVariables, headers?: RequestInit['headers']) => fetcher<RejectAbsenceRequestMutation, RejectAbsenceRequestMutationVariables>(client, RejectAbsenceRequestDocument, variables, headers);

export const DeleteAbsenceRequestDocument = `
    mutation DeleteAbsenceRequest($id: ID!) {
  deleteAbsenceRequest(id: $id) {
    ...AbsenceRequestFragment
  }
}
    ${AbsenceRequestFragmentFragmentDoc}`;

export const useDeleteAbsenceRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteAbsenceRequestMutation, TError, DeleteAbsenceRequestMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteAbsenceRequestMutation, TError, DeleteAbsenceRequestMutationVariables, TContext>(
      {
    mutationKey: ['DeleteAbsenceRequest'],
    mutationFn: (variables?: DeleteAbsenceRequestMutationVariables) => fetcher<DeleteAbsenceRequestMutation, DeleteAbsenceRequestMutationVariables>(client, DeleteAbsenceRequestDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteAbsenceRequestMutation.getKey = () => ['DeleteAbsenceRequest'];


useDeleteAbsenceRequestMutation.fetcher = (client: GraphQLClient, variables: DeleteAbsenceRequestMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteAbsenceRequestMutation, DeleteAbsenceRequestMutationVariables>(client, DeleteAbsenceRequestDocument, variables, headers);

export const UpdateAbsenceRequestDocument = `
    mutation UpdateAbsenceRequest($input: UpdateAbsenceRequestInput!) {
  updateAbsenceRequest(input: $input) {
    ...AbsenceRequestFragment
  }
}
    ${AbsenceRequestFragmentFragmentDoc}`;

export const useUpdateAbsenceRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAbsenceRequestMutation, TError, UpdateAbsenceRequestMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateAbsenceRequestMutation, TError, UpdateAbsenceRequestMutationVariables, TContext>(
      {
    mutationKey: ['UpdateAbsenceRequest'],
    mutationFn: (variables?: UpdateAbsenceRequestMutationVariables) => fetcher<UpdateAbsenceRequestMutation, UpdateAbsenceRequestMutationVariables>(client, UpdateAbsenceRequestDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateAbsenceRequestMutation.getKey = () => ['UpdateAbsenceRequest'];


useUpdateAbsenceRequestMutation.fetcher = (client: GraphQLClient, variables: UpdateAbsenceRequestMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateAbsenceRequestMutation, UpdateAbsenceRequestMutationVariables>(client, UpdateAbsenceRequestDocument, variables, headers);

export const UpdateOwnAbsenceRequestDocument = `
    mutation UpdateOwnAbsenceRequest($input: UpdateOwnAbsenceRequestInput!) {
  updateOwnAbsenceRequest(input: $input) {
    ...AbsenceRequestFragment
  }
}
    ${AbsenceRequestFragmentFragmentDoc}`;

export const useUpdateOwnAbsenceRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOwnAbsenceRequestMutation, TError, UpdateOwnAbsenceRequestMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateOwnAbsenceRequestMutation, TError, UpdateOwnAbsenceRequestMutationVariables, TContext>(
      {
    mutationKey: ['UpdateOwnAbsenceRequest'],
    mutationFn: (variables?: UpdateOwnAbsenceRequestMutationVariables) => fetcher<UpdateOwnAbsenceRequestMutation, UpdateOwnAbsenceRequestMutationVariables>(client, UpdateOwnAbsenceRequestDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateOwnAbsenceRequestMutation.getKey = () => ['UpdateOwnAbsenceRequest'];


useUpdateOwnAbsenceRequestMutation.fetcher = (client: GraphQLClient, variables: UpdateOwnAbsenceRequestMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateOwnAbsenceRequestMutation, UpdateOwnAbsenceRequestMutationVariables>(client, UpdateOwnAbsenceRequestDocument, variables, headers);

export const GetWorkScheduleWeekAbsencesDocument = `
    query GetWorkScheduleWeekAbsences($weekStart: AWSDate!) {
  getWorkScheduleWeekAbsences(weekStart: $weekStart) {
    ...AbsenceRequestFragment
  }
}
    ${AbsenceRequestFragmentFragmentDoc}`;

export const useGetWorkScheduleWeekAbsencesQuery = <
      TData = GetWorkScheduleWeekAbsencesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetWorkScheduleWeekAbsencesQueryVariables,
      options?: Omit<UseQueryOptions<GetWorkScheduleWeekAbsencesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetWorkScheduleWeekAbsencesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetWorkScheduleWeekAbsencesQuery, TError, TData>(
      {
    queryKey: ['GetWorkScheduleWeekAbsences', variables],
    queryFn: fetcher<GetWorkScheduleWeekAbsencesQuery, GetWorkScheduleWeekAbsencesQueryVariables>(client, GetWorkScheduleWeekAbsencesDocument, variables, headers),
    ...options
  }
    )};

useGetWorkScheduleWeekAbsencesQuery.document = GetWorkScheduleWeekAbsencesDocument;

useGetWorkScheduleWeekAbsencesQuery.getKey = (variables: GetWorkScheduleWeekAbsencesQueryVariables) => ['GetWorkScheduleWeekAbsences', variables];


useGetWorkScheduleWeekAbsencesQuery.fetcher = (client: GraphQLClient, variables: GetWorkScheduleWeekAbsencesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetWorkScheduleWeekAbsencesQuery, GetWorkScheduleWeekAbsencesQueryVariables>(client, GetWorkScheduleWeekAbsencesDocument, variables, headers);

export const GetResidentsForAuthorizedRelativeDocument = `
    query GetResidentsForAuthorizedRelative {
  getResidentsForAuthorizedRelative {
    id
    name {
      firstName
      lastName
      middleName
    }
    events {
      id
      date
      eventSubType
      content
      pairingId
      type
      createdBy
    }
    media {
      id
      extension
      fileName
      size
    }
    residentMedications {
      id
      residentId
      medicationName
      startDate
      endDate
      schedule {
        daysOfWeek
        dosageDetails {
          timeType
          time
          timeOfDay
          dosage {
            unit
            quantity
          }
          customInstructions
          relationToFood
        }
      }
      notes
    }
  }
}
    `;

export const useGetResidentsForAuthorizedRelativeQuery = <
      TData = GetResidentsForAuthorizedRelativeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetResidentsForAuthorizedRelativeQueryVariables,
      options?: Omit<UseQueryOptions<GetResidentsForAuthorizedRelativeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetResidentsForAuthorizedRelativeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetResidentsForAuthorizedRelativeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetResidentsForAuthorizedRelative'] : ['GetResidentsForAuthorizedRelative', variables],
    queryFn: fetcher<GetResidentsForAuthorizedRelativeQuery, GetResidentsForAuthorizedRelativeQueryVariables>(client, GetResidentsForAuthorizedRelativeDocument, variables, headers),
    ...options
  }
    )};

useGetResidentsForAuthorizedRelativeQuery.document = GetResidentsForAuthorizedRelativeDocument;

useGetResidentsForAuthorizedRelativeQuery.getKey = (variables?: GetResidentsForAuthorizedRelativeQueryVariables) => variables === undefined ? ['GetResidentsForAuthorizedRelative'] : ['GetResidentsForAuthorizedRelative', variables];


useGetResidentsForAuthorizedRelativeQuery.fetcher = (client: GraphQLClient, variables?: GetResidentsForAuthorizedRelativeQueryVariables, headers?: RequestInit['headers']) => fetcher<GetResidentsForAuthorizedRelativeQuery, GetResidentsForAuthorizedRelativeQueryVariables>(client, GetResidentsForAuthorizedRelativeDocument, variables, headers);

export const GetAuthorizedRelativeByIdDocument = `
    query GetAuthorizedRelativeById($id: ID!) {
  getAuthorizedRelativeById(id: $id) {
    userName
    residentsId
  }
}
    `;

export const useGetAuthorizedRelativeByIdQuery = <
      TData = GetAuthorizedRelativeByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAuthorizedRelativeByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetAuthorizedRelativeByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAuthorizedRelativeByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAuthorizedRelativeByIdQuery, TError, TData>(
      {
    queryKey: ['GetAuthorizedRelativeById', variables],
    queryFn: fetcher<GetAuthorizedRelativeByIdQuery, GetAuthorizedRelativeByIdQueryVariables>(client, GetAuthorizedRelativeByIdDocument, variables, headers),
    ...options
  }
    )};

useGetAuthorizedRelativeByIdQuery.document = GetAuthorizedRelativeByIdDocument;

useGetAuthorizedRelativeByIdQuery.getKey = (variables: GetAuthorizedRelativeByIdQueryVariables) => ['GetAuthorizedRelativeById', variables];


useGetAuthorizedRelativeByIdQuery.fetcher = (client: GraphQLClient, variables: GetAuthorizedRelativeByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAuthorizedRelativeByIdQuery, GetAuthorizedRelativeByIdQueryVariables>(client, GetAuthorizedRelativeByIdDocument, variables, headers);

export const CreateAuthorizedRelativeUserDocument = `
    mutation createAuthorizedRelativeUser($input: CreateAuthorizedRelativeUserInput!) {
  createAuthorizedRelativeUser(input: $input) {
    id
    userName
  }
}
    `;

export const useCreateAuthorizedRelativeUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAuthorizedRelativeUserMutation, TError, CreateAuthorizedRelativeUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateAuthorizedRelativeUserMutation, TError, CreateAuthorizedRelativeUserMutationVariables, TContext>(
      {
    mutationKey: ['createAuthorizedRelativeUser'],
    mutationFn: (variables?: CreateAuthorizedRelativeUserMutationVariables) => fetcher<CreateAuthorizedRelativeUserMutation, CreateAuthorizedRelativeUserMutationVariables>(client, CreateAuthorizedRelativeUserDocument, variables, headers)(),
    ...options
  }
    )};

useCreateAuthorizedRelativeUserMutation.getKey = () => ['createAuthorizedRelativeUser'];


useCreateAuthorizedRelativeUserMutation.fetcher = (client: GraphQLClient, variables: CreateAuthorizedRelativeUserMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateAuthorizedRelativeUserMutation, CreateAuthorizedRelativeUserMutationVariables>(client, CreateAuthorizedRelativeUserDocument, variables, headers);

export const UpdateAuthorizedRelativeUserDocument = `
    mutation UpdateAuthorizedRelativeUser($input: UpdateAuthorizedRelativeUserInput!) {
  updateAuthorizedRelativeUser(input: $input) {
    id
    userName
  }
}
    `;

export const useUpdateAuthorizedRelativeUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAuthorizedRelativeUserMutation, TError, UpdateAuthorizedRelativeUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateAuthorizedRelativeUserMutation, TError, UpdateAuthorizedRelativeUserMutationVariables, TContext>(
      {
    mutationKey: ['UpdateAuthorizedRelativeUser'],
    mutationFn: (variables?: UpdateAuthorizedRelativeUserMutationVariables) => fetcher<UpdateAuthorizedRelativeUserMutation, UpdateAuthorizedRelativeUserMutationVariables>(client, UpdateAuthorizedRelativeUserDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateAuthorizedRelativeUserMutation.getKey = () => ['UpdateAuthorizedRelativeUser'];


useUpdateAuthorizedRelativeUserMutation.fetcher = (client: GraphQLClient, variables: UpdateAuthorizedRelativeUserMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateAuthorizedRelativeUserMutation, UpdateAuthorizedRelativeUserMutationVariables>(client, UpdateAuthorizedRelativeUserDocument, variables, headers);

export const ResetAuthorizedRelativeUserPasswordDocument = `
    mutation ResetAuthorizedRelativeUserPassword($userName: String!) {
  resetAuthorizedRelativeUserPassword(userName: $userName) {
    id
    userName
  }
}
    `;

export const useResetAuthorizedRelativeUserPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResetAuthorizedRelativeUserPasswordMutation, TError, ResetAuthorizedRelativeUserPasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ResetAuthorizedRelativeUserPasswordMutation, TError, ResetAuthorizedRelativeUserPasswordMutationVariables, TContext>(
      {
    mutationKey: ['ResetAuthorizedRelativeUserPassword'],
    mutationFn: (variables?: ResetAuthorizedRelativeUserPasswordMutationVariables) => fetcher<ResetAuthorizedRelativeUserPasswordMutation, ResetAuthorizedRelativeUserPasswordMutationVariables>(client, ResetAuthorizedRelativeUserPasswordDocument, variables, headers)(),
    ...options
  }
    )};

useResetAuthorizedRelativeUserPasswordMutation.getKey = () => ['ResetAuthorizedRelativeUserPassword'];


useResetAuthorizedRelativeUserPasswordMutation.fetcher = (client: GraphQLClient, variables: ResetAuthorizedRelativeUserPasswordMutationVariables, headers?: RequestInit['headers']) => fetcher<ResetAuthorizedRelativeUserPasswordMutation, ResetAuthorizedRelativeUserPasswordMutationVariables>(client, ResetAuthorizedRelativeUserPasswordDocument, variables, headers);

export const DeleteAuthorizedRelativeUserDocument = `
    mutation DeleteAuthorizedRelativeUser($userName: String!) {
  deleteAuthorizedRelativeUser(userName: $userName) {
    id
    userName
  }
}
    `;

export const useDeleteAuthorizedRelativeUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteAuthorizedRelativeUserMutation, TError, DeleteAuthorizedRelativeUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteAuthorizedRelativeUserMutation, TError, DeleteAuthorizedRelativeUserMutationVariables, TContext>(
      {
    mutationKey: ['DeleteAuthorizedRelativeUser'],
    mutationFn: (variables?: DeleteAuthorizedRelativeUserMutationVariables) => fetcher<DeleteAuthorizedRelativeUserMutation, DeleteAuthorizedRelativeUserMutationVariables>(client, DeleteAuthorizedRelativeUserDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteAuthorizedRelativeUserMutation.getKey = () => ['DeleteAuthorizedRelativeUser'];


useDeleteAuthorizedRelativeUserMutation.fetcher = (client: GraphQLClient, variables: DeleteAuthorizedRelativeUserMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteAuthorizedRelativeUserMutation, DeleteAuthorizedRelativeUserMutationVariables>(client, DeleteAuthorizedRelativeUserDocument, variables, headers);

export const GetAllClientsDeployDocument = `
    query GetAllClientsDeploy {
  getAllClientsDeploy
}
    `;

export const useGetAllClientsDeployQuery = <
      TData = GetAllClientsDeployQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllClientsDeployQueryVariables,
      options?: Omit<UseQueryOptions<GetAllClientsDeployQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllClientsDeployQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllClientsDeployQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllClientsDeploy'] : ['GetAllClientsDeploy', variables],
    queryFn: fetcher<GetAllClientsDeployQuery, GetAllClientsDeployQueryVariables>(client, GetAllClientsDeployDocument, variables, headers),
    ...options
  }
    )};

useGetAllClientsDeployQuery.document = GetAllClientsDeployDocument;

useGetAllClientsDeployQuery.getKey = (variables?: GetAllClientsDeployQueryVariables) => variables === undefined ? ['GetAllClientsDeploy'] : ['GetAllClientsDeploy', variables];


useGetAllClientsDeployQuery.fetcher = (client: GraphQLClient, variables?: GetAllClientsDeployQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllClientsDeployQuery, GetAllClientsDeployQueryVariables>(client, GetAllClientsDeployDocument, variables, headers);

export const AddClientDeployDocument = `
    mutation AddClientDeploy($input: AddClientDeploy!) {
  addClientDeploy(input: $input)
}
    `;

export const useAddClientDeployMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddClientDeployMutation, TError, AddClientDeployMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<AddClientDeployMutation, TError, AddClientDeployMutationVariables, TContext>(
      {
    mutationKey: ['AddClientDeploy'],
    mutationFn: (variables?: AddClientDeployMutationVariables) => fetcher<AddClientDeployMutation, AddClientDeployMutationVariables>(client, AddClientDeployDocument, variables, headers)(),
    ...options
  }
    )};

useAddClientDeployMutation.getKey = () => ['AddClientDeploy'];


useAddClientDeployMutation.fetcher = (client: GraphQLClient, variables: AddClientDeployMutationVariables, headers?: RequestInit['headers']) => fetcher<AddClientDeployMutation, AddClientDeployMutationVariables>(client, AddClientDeployDocument, variables, headers);

export const DeployClientDocument = `
    mutation DeployClient($clientName: String!) {
  deployClient(clientName: $clientName)
}
    `;

export const useDeployClientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeployClientMutation, TError, DeployClientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeployClientMutation, TError, DeployClientMutationVariables, TContext>(
      {
    mutationKey: ['DeployClient'],
    mutationFn: (variables?: DeployClientMutationVariables) => fetcher<DeployClientMutation, DeployClientMutationVariables>(client, DeployClientDocument, variables, headers)(),
    ...options
  }
    )};

useDeployClientMutation.getKey = () => ['DeployClient'];


useDeployClientMutation.fetcher = (client: GraphQLClient, variables: DeployClientMutationVariables, headers?: RequestInit['headers']) => fetcher<DeployClientMutation, DeployClientMutationVariables>(client, DeployClientDocument, variables, headers);

export const DeleteClientDeployDocument = `
    mutation DeleteClientDeploy($clientName: String!) {
  deleteClientDeploy(clientName: $clientName)
}
    `;

export const useDeleteClientDeployMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteClientDeployMutation, TError, DeleteClientDeployMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteClientDeployMutation, TError, DeleteClientDeployMutationVariables, TContext>(
      {
    mutationKey: ['DeleteClientDeploy'],
    mutationFn: (variables?: DeleteClientDeployMutationVariables) => fetcher<DeleteClientDeployMutation, DeleteClientDeployMutationVariables>(client, DeleteClientDeployDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteClientDeployMutation.getKey = () => ['DeleteClientDeploy'];


useDeleteClientDeployMutation.fetcher = (client: GraphQLClient, variables: DeleteClientDeployMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteClientDeployMutation, DeleteClientDeployMutationVariables>(client, DeleteClientDeployDocument, variables, headers);

export const GetConfigsDocument = `
    query GetConfigs {
  getConfigs {
    key
    group
    label {
      de
      en
      pl
      uk
    }
    description {
      de
      en
      pl
      uk
    }
    value {
      stringValue
      numberValue
      boolValue
    }
    dataType
    regex
  }
}
    `;

export const useGetConfigsQuery = <
      TData = GetConfigsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetConfigsQueryVariables,
      options?: Omit<UseQueryOptions<GetConfigsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetConfigsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetConfigsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetConfigs'] : ['GetConfigs', variables],
    queryFn: fetcher<GetConfigsQuery, GetConfigsQueryVariables>(client, GetConfigsDocument, variables, headers),
    ...options
  }
    )};

useGetConfigsQuery.document = GetConfigsDocument;

useGetConfigsQuery.getKey = (variables?: GetConfigsQueryVariables) => variables === undefined ? ['GetConfigs'] : ['GetConfigs', variables];


useGetConfigsQuery.fetcher = (client: GraphQLClient, variables?: GetConfigsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetConfigsQuery, GetConfigsQueryVariables>(client, GetConfigsDocument, variables, headers);

export const UpdateConfigsDocument = `
    mutation UpdateConfigs($input: UpdateConfigsInput!) {
  updateConfigs(input: $input) {
    key
    group
    label {
      de
      en
      pl
      uk
    }
    description {
      de
      en
      pl
      uk
    }
    value {
      stringValue
      numberValue
      boolValue
    }
    dataType
  }
}
    `;

export const useUpdateConfigsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateConfigsMutation, TError, UpdateConfigsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateConfigsMutation, TError, UpdateConfigsMutationVariables, TContext>(
      {
    mutationKey: ['UpdateConfigs'],
    mutationFn: (variables?: UpdateConfigsMutationVariables) => fetcher<UpdateConfigsMutation, UpdateConfigsMutationVariables>(client, UpdateConfigsDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateConfigsMutation.getKey = () => ['UpdateConfigs'];


useUpdateConfigsMutation.fetcher = (client: GraphQLClient, variables: UpdateConfigsMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateConfigsMutation, UpdateConfigsMutationVariables>(client, UpdateConfigsDocument, variables, headers);

export const UpdateConfigDocument = `
    mutation UpdateConfig($input: UpdateConfigInput!) {
  updateConfig(input: $input) {
    key
    group
    label {
      de
      en
      pl
      uk
    }
    description {
      de
      en
      pl
      uk
    }
    value {
      stringValue
      numberValue
      boolValue
    }
    dataType
  }
}
    `;

export const useUpdateConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateConfigMutation, TError, UpdateConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateConfigMutation, TError, UpdateConfigMutationVariables, TContext>(
      {
    mutationKey: ['UpdateConfig'],
    mutationFn: (variables?: UpdateConfigMutationVariables) => fetcher<UpdateConfigMutation, UpdateConfigMutationVariables>(client, UpdateConfigDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateConfigMutation.getKey = () => ['UpdateConfig'];


useUpdateConfigMutation.fetcher = (client: GraphQLClient, variables: UpdateConfigMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateConfigMutation, UpdateConfigMutationVariables>(client, UpdateConfigDocument, variables, headers);

export const SaveConfigFileDocument = `
    mutation SaveConfigFile($input: SaveConfigFileInput!) {
  saveConfigFile(input: $input) {
    url
  }
}
    `;

export const useSaveConfigFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SaveConfigFileMutation, TError, SaveConfigFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SaveConfigFileMutation, TError, SaveConfigFileMutationVariables, TContext>(
      {
    mutationKey: ['SaveConfigFile'],
    mutationFn: (variables?: SaveConfigFileMutationVariables) => fetcher<SaveConfigFileMutation, SaveConfigFileMutationVariables>(client, SaveConfigFileDocument, variables, headers)(),
    ...options
  }
    )};

useSaveConfigFileMutation.getKey = () => ['SaveConfigFile'];


useSaveConfigFileMutation.fetcher = (client: GraphQLClient, variables: SaveConfigFileMutationVariables, headers?: RequestInit['headers']) => fetcher<SaveConfigFileMutation, SaveConfigFileMutationVariables>(client, SaveConfigFileDocument, variables, headers);

export const GetConfigByKeyDocument = `
    query GetConfigByKey($key: String!) {
  getConfigByKey(key: $key) {
    key
    group
    value {
      numberValue
      boolValue
      stringValue
    }
    label {
      de
      en
      pl
      uk
    }
    description {
      de
      en
      pl
      uk
    }
    dataType
  }
}
    `;

export const useGetConfigByKeyQuery = <
      TData = GetConfigByKeyQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetConfigByKeyQueryVariables,
      options?: Omit<UseQueryOptions<GetConfigByKeyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetConfigByKeyQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetConfigByKeyQuery, TError, TData>(
      {
    queryKey: ['GetConfigByKey', variables],
    queryFn: fetcher<GetConfigByKeyQuery, GetConfigByKeyQueryVariables>(client, GetConfigByKeyDocument, variables, headers),
    ...options
  }
    )};

useGetConfigByKeyQuery.document = GetConfigByKeyDocument;

useGetConfigByKeyQuery.getKey = (variables: GetConfigByKeyQueryVariables) => ['GetConfigByKey', variables];


useGetConfigByKeyQuery.fetcher = (client: GraphQLClient, variables: GetConfigByKeyQueryVariables, headers?: RequestInit['headers']) => fetcher<GetConfigByKeyQuery, GetConfigByKeyQueryVariables>(client, GetConfigByKeyDocument, variables, headers);

export const GetMediaBucketUtilisationDocument = `
    query GetMediaBucketUtilisation {
  getUtilisationByKey(key: "mediaBucket") {
    resourceName
    updatedAt
    value
  }
}
    `;

export const useGetMediaBucketUtilisationQuery = <
      TData = GetMediaBucketUtilisationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMediaBucketUtilisationQueryVariables,
      options?: Omit<UseQueryOptions<GetMediaBucketUtilisationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMediaBucketUtilisationQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMediaBucketUtilisationQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetMediaBucketUtilisation'] : ['GetMediaBucketUtilisation', variables],
    queryFn: fetcher<GetMediaBucketUtilisationQuery, GetMediaBucketUtilisationQueryVariables>(client, GetMediaBucketUtilisationDocument, variables, headers),
    ...options
  }
    )};

useGetMediaBucketUtilisationQuery.document = GetMediaBucketUtilisationDocument;

useGetMediaBucketUtilisationQuery.getKey = (variables?: GetMediaBucketUtilisationQueryVariables) => variables === undefined ? ['GetMediaBucketUtilisation'] : ['GetMediaBucketUtilisation', variables];


useGetMediaBucketUtilisationQuery.fetcher = (client: GraphQLClient, variables?: GetMediaBucketUtilisationQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMediaBucketUtilisationQuery, GetMediaBucketUtilisationQueryVariables>(client, GetMediaBucketUtilisationDocument, variables, headers);

export const GetEntitlementsDocument = `
    query GetEntitlements {
  getEntitlements {
    key
    enabled
  }
}
    `;

export const useGetEntitlementsQuery = <
      TData = GetEntitlementsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetEntitlementsQueryVariables,
      options?: Omit<UseQueryOptions<GetEntitlementsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetEntitlementsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetEntitlementsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetEntitlements'] : ['GetEntitlements', variables],
    queryFn: fetcher<GetEntitlementsQuery, GetEntitlementsQueryVariables>(client, GetEntitlementsDocument, variables, headers),
    ...options
  }
    )};

useGetEntitlementsQuery.document = GetEntitlementsDocument;

useGetEntitlementsQuery.getKey = (variables?: GetEntitlementsQueryVariables) => variables === undefined ? ['GetEntitlements'] : ['GetEntitlements', variables];


useGetEntitlementsQuery.fetcher = (client: GraphQLClient, variables?: GetEntitlementsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetEntitlementsQuery, GetEntitlementsQueryVariables>(client, GetEntitlementsDocument, variables, headers);

export const GetBoEntitlementsDocument = `
    query GetBoEntitlements {
  getBoEntitlements {
    id
    clientName
    entitlements {
      enabled
      key
    }
  }
}
    `;

export const useGetBoEntitlementsQuery = <
      TData = GetBoEntitlementsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetBoEntitlementsQueryVariables,
      options?: Omit<UseQueryOptions<GetBoEntitlementsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBoEntitlementsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetBoEntitlementsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetBoEntitlements'] : ['GetBoEntitlements', variables],
    queryFn: fetcher<GetBoEntitlementsQuery, GetBoEntitlementsQueryVariables>(client, GetBoEntitlementsDocument, variables, headers),
    ...options
  }
    )};

useGetBoEntitlementsQuery.document = GetBoEntitlementsDocument;

useGetBoEntitlementsQuery.getKey = (variables?: GetBoEntitlementsQueryVariables) => variables === undefined ? ['GetBoEntitlements'] : ['GetBoEntitlements', variables];


useGetBoEntitlementsQuery.fetcher = (client: GraphQLClient, variables?: GetBoEntitlementsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetBoEntitlementsQuery, GetBoEntitlementsQueryVariables>(client, GetBoEntitlementsDocument, variables, headers);

export const UpdateBoEntitlementDocument = `
    mutation UpdateBoEntitlement($input: UpdateBoEntitlementInput!) {
  updateBoEntitlement(input: $input)
}
    `;

export const useUpdateBoEntitlementMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateBoEntitlementMutation, TError, UpdateBoEntitlementMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateBoEntitlementMutation, TError, UpdateBoEntitlementMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBoEntitlement'],
    mutationFn: (variables?: UpdateBoEntitlementMutationVariables) => fetcher<UpdateBoEntitlementMutation, UpdateBoEntitlementMutationVariables>(client, UpdateBoEntitlementDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateBoEntitlementMutation.getKey = () => ['UpdateBoEntitlement'];


useUpdateBoEntitlementMutation.fetcher = (client: GraphQLClient, variables: UpdateBoEntitlementMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateBoEntitlementMutation, UpdateBoEntitlementMutationVariables>(client, UpdateBoEntitlementDocument, variables, headers);

export const GetEventsByPairingIdDocument = `
    query GetEventsByPairingId($input: GetEventsByPairingIdInput!) {
  getEventsByPairingId(input: $input) {
    id
    date
    eventSubType
    content
    pairingId
    type
    createdBy
    isSharedToAuthorizedRelative
  }
}
    `;

export const useGetEventsByPairingIdQuery = <
      TData = GetEventsByPairingIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEventsByPairingIdQueryVariables,
      options?: Omit<UseQueryOptions<GetEventsByPairingIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetEventsByPairingIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetEventsByPairingIdQuery, TError, TData>(
      {
    queryKey: ['GetEventsByPairingId', variables],
    queryFn: fetcher<GetEventsByPairingIdQuery, GetEventsByPairingIdQueryVariables>(client, GetEventsByPairingIdDocument, variables, headers),
    ...options
  }
    )};

useGetEventsByPairingIdQuery.document = GetEventsByPairingIdDocument;

useGetEventsByPairingIdQuery.getKey = (variables: GetEventsByPairingIdQueryVariables) => ['GetEventsByPairingId', variables];


useGetEventsByPairingIdQuery.fetcher = (client: GraphQLClient, variables: GetEventsByPairingIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetEventsByPairingIdQuery, GetEventsByPairingIdQueryVariables>(client, GetEventsByPairingIdDocument, variables, headers);

export const GetEventByIdDocument = `
    query GetEventById($eventId: ID!) {
  getEventById(id: $eventId) {
    id
    date
    eventSubType
    content
    pairingId
    type
    createdBy
    isSharedToAuthorizedRelative
  }
}
    `;

export const useGetEventByIdQuery = <
      TData = GetEventByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEventByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetEventByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetEventByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetEventByIdQuery, TError, TData>(
      {
    queryKey: ['GetEventById', variables],
    queryFn: fetcher<GetEventByIdQuery, GetEventByIdQueryVariables>(client, GetEventByIdDocument, variables, headers),
    ...options
  }
    )};

useGetEventByIdQuery.document = GetEventByIdDocument;

useGetEventByIdQuery.getKey = (variables: GetEventByIdQueryVariables) => ['GetEventById', variables];


useGetEventByIdQuery.fetcher = (client: GraphQLClient, variables: GetEventByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetEventByIdQuery, GetEventByIdQueryVariables>(client, GetEventByIdDocument, variables, headers);

export const GetEventsByDateRangeDocument = `
    query GetEventsByDateRange($input: GetEventsWithDateRangeInput!) {
  getEventsByDateRange(input: $input) {
    id
    date
    eventSubType
    content
    pairingId
    type
    createdBy
    isSharedToAuthorizedRelative
  }
}
    `;

export const useGetEventsByDateRangeQuery = <
      TData = GetEventsByDateRangeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEventsByDateRangeQueryVariables,
      options?: Omit<UseQueryOptions<GetEventsByDateRangeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetEventsByDateRangeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetEventsByDateRangeQuery, TError, TData>(
      {
    queryKey: ['GetEventsByDateRange', variables],
    queryFn: fetcher<GetEventsByDateRangeQuery, GetEventsByDateRangeQueryVariables>(client, GetEventsByDateRangeDocument, variables, headers),
    ...options
  }
    )};

useGetEventsByDateRangeQuery.document = GetEventsByDateRangeDocument;

useGetEventsByDateRangeQuery.getKey = (variables: GetEventsByDateRangeQueryVariables) => ['GetEventsByDateRange', variables];


useGetEventsByDateRangeQuery.fetcher = (client: GraphQLClient, variables: GetEventsByDateRangeQueryVariables, headers?: RequestInit['headers']) => fetcher<GetEventsByDateRangeQuery, GetEventsByDateRangeQueryVariables>(client, GetEventsByDateRangeDocument, variables, headers);

export const CreateEventDocument = `
    mutation CreateEvent($input: CreateEventInput!) {
  createEvent(input: $input) {
    pairingId
    id
    date
  }
}
    `;

export const useCreateEventMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateEventMutation, TError, CreateEventMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateEventMutation, TError, CreateEventMutationVariables, TContext>(
      {
    mutationKey: ['CreateEvent'],
    mutationFn: (variables?: CreateEventMutationVariables) => fetcher<CreateEventMutation, CreateEventMutationVariables>(client, CreateEventDocument, variables, headers)(),
    ...options
  }
    )};

useCreateEventMutation.getKey = () => ['CreateEvent'];


useCreateEventMutation.fetcher = (client: GraphQLClient, variables: CreateEventMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateEventMutation, CreateEventMutationVariables>(client, CreateEventDocument, variables, headers);

export const UpdateEventDocument = `
    mutation UpdateEvent($input: UpdateEventInput!) {
  updateEvent(input: $input) {
    pairingId
    id
  }
}
    `;

export const useUpdateEventMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateEventMutation, TError, UpdateEventMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateEventMutation, TError, UpdateEventMutationVariables, TContext>(
      {
    mutationKey: ['UpdateEvent'],
    mutationFn: (variables?: UpdateEventMutationVariables) => fetcher<UpdateEventMutation, UpdateEventMutationVariables>(client, UpdateEventDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateEventMutation.getKey = () => ['UpdateEvent'];


useUpdateEventMutation.fetcher = (client: GraphQLClient, variables: UpdateEventMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateEventMutation, UpdateEventMutationVariables>(client, UpdateEventDocument, variables, headers);

export const DeleteEventDocument = `
    mutation DeleteEvent($id: ID!) {
  deleteEvent(id: $id) {
    pairingId
    id
  }
}
    `;

export const useDeleteEventMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteEventMutation, TError, DeleteEventMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteEventMutation, TError, DeleteEventMutationVariables, TContext>(
      {
    mutationKey: ['DeleteEvent'],
    mutationFn: (variables?: DeleteEventMutationVariables) => fetcher<DeleteEventMutation, DeleteEventMutationVariables>(client, DeleteEventDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteEventMutation.getKey = () => ['DeleteEvent'];


useDeleteEventMutation.fetcher = (client: GraphQLClient, variables: DeleteEventMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteEventMutation, DeleteEventMutationVariables>(client, DeleteEventDocument, variables, headers);

export const ListHealthLogMetricsDocument = `
    query ListHealthLogMetrics {
  listHealthLogMetrics {
    ...HealthLogMetricDefinitionFragment
  }
}
    ${HealthLogMetricDefinitionFragmentFragmentDoc}`;

export const useListHealthLogMetricsQuery = <
      TData = ListHealthLogMetricsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListHealthLogMetricsQueryVariables,
      options?: Omit<UseQueryOptions<ListHealthLogMetricsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListHealthLogMetricsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<ListHealthLogMetricsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ListHealthLogMetrics'] : ['ListHealthLogMetrics', variables],
    queryFn: fetcher<ListHealthLogMetricsQuery, ListHealthLogMetricsQueryVariables>(client, ListHealthLogMetricsDocument, variables, headers),
    ...options
  }
    )};

useListHealthLogMetricsQuery.document = ListHealthLogMetricsDocument;

useListHealthLogMetricsQuery.getKey = (variables?: ListHealthLogMetricsQueryVariables) => variables === undefined ? ['ListHealthLogMetrics'] : ['ListHealthLogMetrics', variables];


useListHealthLogMetricsQuery.fetcher = (client: GraphQLClient, variables?: ListHealthLogMetricsQueryVariables, headers?: RequestInit['headers']) => fetcher<ListHealthLogMetricsQuery, ListHealthLogMetricsQueryVariables>(client, ListHealthLogMetricsDocument, variables, headers);

export const GetHealthLogMeasurementsDocument = `
    query GetHealthLogMeasurements($residentId: ID!, $metricId: ID!, $from: AWSDateTime, $to: AWSDateTime, $limit: Int, $nextToken: String) {
  getHealthLogMeasurements(
    residentId: $residentId
    metricId: $metricId
    from: $from
    to: $to
    limit: $limit
    nextToken: $nextToken
  ) {
    ...HealthLogMeasurementConnectionFragment
  }
}
    ${HealthLogMeasurementConnectionFragmentFragmentDoc}`;

export const useGetHealthLogMeasurementsQuery = <
      TData = GetHealthLogMeasurementsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetHealthLogMeasurementsQueryVariables,
      options?: Omit<UseQueryOptions<GetHealthLogMeasurementsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetHealthLogMeasurementsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetHealthLogMeasurementsQuery, TError, TData>(
      {
    queryKey: ['GetHealthLogMeasurements', variables],
    queryFn: fetcher<GetHealthLogMeasurementsQuery, GetHealthLogMeasurementsQueryVariables>(client, GetHealthLogMeasurementsDocument, variables, headers),
    ...options
  }
    )};

useGetHealthLogMeasurementsQuery.document = GetHealthLogMeasurementsDocument;

useGetHealthLogMeasurementsQuery.getKey = (variables: GetHealthLogMeasurementsQueryVariables) => ['GetHealthLogMeasurements', variables];


useGetHealthLogMeasurementsQuery.fetcher = (client: GraphQLClient, variables: GetHealthLogMeasurementsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetHealthLogMeasurementsQuery, GetHealthLogMeasurementsQueryVariables>(client, GetHealthLogMeasurementsDocument, variables, headers);

export const AddHealthLogMeasurementsDocument = `
    mutation AddHealthLogMeasurements($input: HealthLogBatchMeasurementInput!) {
  addHealthLogMeasurements(input: $input) {
    ...HealthLogMeasurementFragment
  }
}
    ${HealthLogMeasurementFragmentFragmentDoc}`;

export const useAddHealthLogMeasurementsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddHealthLogMeasurementsMutation, TError, AddHealthLogMeasurementsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<AddHealthLogMeasurementsMutation, TError, AddHealthLogMeasurementsMutationVariables, TContext>(
      {
    mutationKey: ['AddHealthLogMeasurements'],
    mutationFn: (variables?: AddHealthLogMeasurementsMutationVariables) => fetcher<AddHealthLogMeasurementsMutation, AddHealthLogMeasurementsMutationVariables>(client, AddHealthLogMeasurementsDocument, variables, headers)(),
    ...options
  }
    )};

useAddHealthLogMeasurementsMutation.getKey = () => ['AddHealthLogMeasurements'];


useAddHealthLogMeasurementsMutation.fetcher = (client: GraphQLClient, variables: AddHealthLogMeasurementsMutationVariables, headers?: RequestInit['headers']) => fetcher<AddHealthLogMeasurementsMutation, AddHealthLogMeasurementsMutationVariables>(client, AddHealthLogMeasurementsDocument, variables, headers);

export const UpdateHealthLogMeasurementDocument = `
    mutation UpdateHealthLogMeasurement($input: HealthLogMeasurementInput!) {
  updateHealthLogMeasurement(input: $input) {
    ...HealthLogMeasurementFragment
  }
}
    ${HealthLogMeasurementFragmentFragmentDoc}`;

export const useUpdateHealthLogMeasurementMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateHealthLogMeasurementMutation, TError, UpdateHealthLogMeasurementMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateHealthLogMeasurementMutation, TError, UpdateHealthLogMeasurementMutationVariables, TContext>(
      {
    mutationKey: ['UpdateHealthLogMeasurement'],
    mutationFn: (variables?: UpdateHealthLogMeasurementMutationVariables) => fetcher<UpdateHealthLogMeasurementMutation, UpdateHealthLogMeasurementMutationVariables>(client, UpdateHealthLogMeasurementDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateHealthLogMeasurementMutation.getKey = () => ['UpdateHealthLogMeasurement'];


useUpdateHealthLogMeasurementMutation.fetcher = (client: GraphQLClient, variables: UpdateHealthLogMeasurementMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateHealthLogMeasurementMutation, UpdateHealthLogMeasurementMutationVariables>(client, UpdateHealthLogMeasurementDocument, variables, headers);

export const DeleteHealthLogMeasurementDocument = `
    mutation DeleteHealthLogMeasurement($residentId: ID!, $metricId: ID!, $recordedAt: AWSDateTime!) {
  deleteHealthLogMeasurement(
    residentId: $residentId
    metricId: $metricId
    recordedAt: $recordedAt
  ) {
    ...HealthLogMeasurementFragment
  }
}
    ${HealthLogMeasurementFragmentFragmentDoc}`;

export const useDeleteHealthLogMeasurementMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteHealthLogMeasurementMutation, TError, DeleteHealthLogMeasurementMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteHealthLogMeasurementMutation, TError, DeleteHealthLogMeasurementMutationVariables, TContext>(
      {
    mutationKey: ['DeleteHealthLogMeasurement'],
    mutationFn: (variables?: DeleteHealthLogMeasurementMutationVariables) => fetcher<DeleteHealthLogMeasurementMutation, DeleteHealthLogMeasurementMutationVariables>(client, DeleteHealthLogMeasurementDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteHealthLogMeasurementMutation.getKey = () => ['DeleteHealthLogMeasurement'];


useDeleteHealthLogMeasurementMutation.fetcher = (client: GraphQLClient, variables: DeleteHealthLogMeasurementMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteHealthLogMeasurementMutation, DeleteHealthLogMeasurementMutationVariables>(client, DeleteHealthLogMeasurementDocument, variables, headers);

export const ListIntegrationProvidersDocument = `
    query ListIntegrationProviders {
  listIntegrationProviders {
    id
    name
    enabled
    rateLimit
    dailyQuota
    allowedEndpoints
    createdAt
    updatedAt
    createdBy
  }
}
    `;

export const useListIntegrationProvidersQuery = <
      TData = ListIntegrationProvidersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListIntegrationProvidersQueryVariables,
      options?: Omit<UseQueryOptions<ListIntegrationProvidersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListIntegrationProvidersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<ListIntegrationProvidersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ListIntegrationProviders'] : ['ListIntegrationProviders', variables],
    queryFn: fetcher<ListIntegrationProvidersQuery, ListIntegrationProvidersQueryVariables>(client, ListIntegrationProvidersDocument, variables, headers),
    ...options
  }
    )};

useListIntegrationProvidersQuery.document = ListIntegrationProvidersDocument;

useListIntegrationProvidersQuery.getKey = (variables?: ListIntegrationProvidersQueryVariables) => variables === undefined ? ['ListIntegrationProviders'] : ['ListIntegrationProviders', variables];


useListIntegrationProvidersQuery.fetcher = (client: GraphQLClient, variables?: ListIntegrationProvidersQueryVariables, headers?: RequestInit['headers']) => fetcher<ListIntegrationProvidersQuery, ListIntegrationProvidersQueryVariables>(client, ListIntegrationProvidersDocument, variables, headers);

export const GetIntegrationProviderDocument = `
    query GetIntegrationProvider($id: ID!) {
  getIntegrationProvider(id: $id) {
    id
    name
    enabled
    rateLimit
    dailyQuota
    allowedEndpoints
    createdAt
    updatedAt
    createdBy
  }
}
    `;

export const useGetIntegrationProviderQuery = <
      TData = GetIntegrationProviderQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetIntegrationProviderQueryVariables,
      options?: Omit<UseQueryOptions<GetIntegrationProviderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetIntegrationProviderQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetIntegrationProviderQuery, TError, TData>(
      {
    queryKey: ['GetIntegrationProvider', variables],
    queryFn: fetcher<GetIntegrationProviderQuery, GetIntegrationProviderQueryVariables>(client, GetIntegrationProviderDocument, variables, headers),
    ...options
  }
    )};

useGetIntegrationProviderQuery.document = GetIntegrationProviderDocument;

useGetIntegrationProviderQuery.getKey = (variables: GetIntegrationProviderQueryVariables) => ['GetIntegrationProvider', variables];


useGetIntegrationProviderQuery.fetcher = (client: GraphQLClient, variables: GetIntegrationProviderQueryVariables, headers?: RequestInit['headers']) => fetcher<GetIntegrationProviderQuery, GetIntegrationProviderQueryVariables>(client, GetIntegrationProviderDocument, variables, headers);

export const CreateIntegrationProviderDocument = `
    mutation CreateIntegrationProvider($input: CreateIntegrationProviderInput!) {
  createIntegrationProvider(input: $input) {
    provider {
      id
      name
      enabled
      rateLimit
      dailyQuota
      allowedEndpoints
      createdAt
      updatedAt
      createdBy
    }
    clientId
    clientSecret
  }
}
    `;

export const useCreateIntegrationProviderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateIntegrationProviderMutation, TError, CreateIntegrationProviderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateIntegrationProviderMutation, TError, CreateIntegrationProviderMutationVariables, TContext>(
      {
    mutationKey: ['CreateIntegrationProvider'],
    mutationFn: (variables?: CreateIntegrationProviderMutationVariables) => fetcher<CreateIntegrationProviderMutation, CreateIntegrationProviderMutationVariables>(client, CreateIntegrationProviderDocument, variables, headers)(),
    ...options
  }
    )};

useCreateIntegrationProviderMutation.getKey = () => ['CreateIntegrationProvider'];


useCreateIntegrationProviderMutation.fetcher = (client: GraphQLClient, variables: CreateIntegrationProviderMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateIntegrationProviderMutation, CreateIntegrationProviderMutationVariables>(client, CreateIntegrationProviderDocument, variables, headers);

export const UpdateIntegrationProviderDocument = `
    mutation UpdateIntegrationProvider($input: UpdateIntegrationProviderInput!) {
  updateIntegrationProvider(input: $input) {
    id
    name
    enabled
    rateLimit
    dailyQuota
    allowedEndpoints
    updatedAt
  }
}
    `;

export const useUpdateIntegrationProviderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateIntegrationProviderMutation, TError, UpdateIntegrationProviderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateIntegrationProviderMutation, TError, UpdateIntegrationProviderMutationVariables, TContext>(
      {
    mutationKey: ['UpdateIntegrationProvider'],
    mutationFn: (variables?: UpdateIntegrationProviderMutationVariables) => fetcher<UpdateIntegrationProviderMutation, UpdateIntegrationProviderMutationVariables>(client, UpdateIntegrationProviderDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateIntegrationProviderMutation.getKey = () => ['UpdateIntegrationProvider'];


useUpdateIntegrationProviderMutation.fetcher = (client: GraphQLClient, variables: UpdateIntegrationProviderMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateIntegrationProviderMutation, UpdateIntegrationProviderMutationVariables>(client, UpdateIntegrationProviderDocument, variables, headers);

export const DeleteIntegrationProviderDocument = `
    mutation DeleteIntegrationProvider($id: ID!) {
  deleteIntegrationProvider(id: $id)
}
    `;

export const useDeleteIntegrationProviderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteIntegrationProviderMutation, TError, DeleteIntegrationProviderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteIntegrationProviderMutation, TError, DeleteIntegrationProviderMutationVariables, TContext>(
      {
    mutationKey: ['DeleteIntegrationProvider'],
    mutationFn: (variables?: DeleteIntegrationProviderMutationVariables) => fetcher<DeleteIntegrationProviderMutation, DeleteIntegrationProviderMutationVariables>(client, DeleteIntegrationProviderDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteIntegrationProviderMutation.getKey = () => ['DeleteIntegrationProvider'];


useDeleteIntegrationProviderMutation.fetcher = (client: GraphQLClient, variables: DeleteIntegrationProviderMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteIntegrationProviderMutation, DeleteIntegrationProviderMutationVariables>(client, DeleteIntegrationProviderDocument, variables, headers);

export const RegenerateIntegrationApiKeyDocument = `
    mutation RegenerateIntegrationApiKey($id: ID!) {
  regenerateIntegrationApiKey(id: $id) {
    provider {
      id
      name
      updatedAt
    }
    clientId
    clientSecret
  }
}
    `;

export const useRegenerateIntegrationApiKeyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RegenerateIntegrationApiKeyMutation, TError, RegenerateIntegrationApiKeyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<RegenerateIntegrationApiKeyMutation, TError, RegenerateIntegrationApiKeyMutationVariables, TContext>(
      {
    mutationKey: ['RegenerateIntegrationApiKey'],
    mutationFn: (variables?: RegenerateIntegrationApiKeyMutationVariables) => fetcher<RegenerateIntegrationApiKeyMutation, RegenerateIntegrationApiKeyMutationVariables>(client, RegenerateIntegrationApiKeyDocument, variables, headers)(),
    ...options
  }
    )};

useRegenerateIntegrationApiKeyMutation.getKey = () => ['RegenerateIntegrationApiKey'];


useRegenerateIntegrationApiKeyMutation.fetcher = (client: GraphQLClient, variables: RegenerateIntegrationApiKeyMutationVariables, headers?: RequestInit['headers']) => fetcher<RegenerateIntegrationApiKeyMutation, RegenerateIntegrationApiKeyMutationVariables>(client, RegenerateIntegrationApiKeyDocument, variables, headers);

export const GetWarehousesDocument = `
    query GetWarehouses {
  getWarehouses {
    allowedGroups
    name
    location
    id
  }
}
    `;

export const useGetWarehousesQuery = <
      TData = GetWarehousesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetWarehousesQueryVariables,
      options?: Omit<UseQueryOptions<GetWarehousesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetWarehousesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetWarehousesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetWarehouses'] : ['GetWarehouses', variables],
    queryFn: fetcher<GetWarehousesQuery, GetWarehousesQueryVariables>(client, GetWarehousesDocument, variables, headers),
    ...options
  }
    )};

useGetWarehousesQuery.document = GetWarehousesDocument;

useGetWarehousesQuery.getKey = (variables?: GetWarehousesQueryVariables) => variables === undefined ? ['GetWarehouses'] : ['GetWarehouses', variables];


useGetWarehousesQuery.fetcher = (client: GraphQLClient, variables?: GetWarehousesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetWarehousesQuery, GetWarehousesQueryVariables>(client, GetWarehousesDocument, variables, headers);

export const GetWarehouseByIdDocument = `
    query GetWarehouseById($id: ID!) {
  getWarehouseById(id: $id) {
    allowedGroups
    name
    location
    id
  }
}
    `;

export const useGetWarehouseByIdQuery = <
      TData = GetWarehouseByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetWarehouseByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetWarehouseByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetWarehouseByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetWarehouseByIdQuery, TError, TData>(
      {
    queryKey: ['GetWarehouseById', variables],
    queryFn: fetcher<GetWarehouseByIdQuery, GetWarehouseByIdQueryVariables>(client, GetWarehouseByIdDocument, variables, headers),
    ...options
  }
    )};

useGetWarehouseByIdQuery.document = GetWarehouseByIdDocument;

useGetWarehouseByIdQuery.getKey = (variables: GetWarehouseByIdQueryVariables) => ['GetWarehouseById', variables];


useGetWarehouseByIdQuery.fetcher = (client: GraphQLClient, variables: GetWarehouseByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetWarehouseByIdQuery, GetWarehouseByIdQueryVariables>(client, GetWarehouseByIdDocument, variables, headers);

export const GetWarehouseItemsDocument = `
    query GetWarehouseItems($warehouseId: ID!) {
  getWarehouseItems(warehouseId: $warehouseId) {
    items {
      id
      name
      quantity
      updatedAt
      warehouseId
    }
  }
}
    `;

export const useGetWarehouseItemsQuery = <
      TData = GetWarehouseItemsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetWarehouseItemsQueryVariables,
      options?: Omit<UseQueryOptions<GetWarehouseItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetWarehouseItemsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetWarehouseItemsQuery, TError, TData>(
      {
    queryKey: ['GetWarehouseItems', variables],
    queryFn: fetcher<GetWarehouseItemsQuery, GetWarehouseItemsQueryVariables>(client, GetWarehouseItemsDocument, variables, headers),
    ...options
  }
    )};

useGetWarehouseItemsQuery.document = GetWarehouseItemsDocument;

useGetWarehouseItemsQuery.getKey = (variables: GetWarehouseItemsQueryVariables) => ['GetWarehouseItems', variables];


useGetWarehouseItemsQuery.fetcher = (client: GraphQLClient, variables: GetWarehouseItemsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetWarehouseItemsQuery, GetWarehouseItemsQueryVariables>(client, GetWarehouseItemsDocument, variables, headers);

export const GetWarehouseItemByIdDocument = `
    query GetWarehouseItemById($warehouseId: ID!, $id: ID!) {
  getWarehouseItemById(warehouseId: $warehouseId, id: $id) {
    id
    name
    quantity
    updatedAt
    warehouseId
  }
}
    `;

export const useGetWarehouseItemByIdQuery = <
      TData = GetWarehouseItemByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetWarehouseItemByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetWarehouseItemByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetWarehouseItemByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetWarehouseItemByIdQuery, TError, TData>(
      {
    queryKey: ['GetWarehouseItemById', variables],
    queryFn: fetcher<GetWarehouseItemByIdQuery, GetWarehouseItemByIdQueryVariables>(client, GetWarehouseItemByIdDocument, variables, headers),
    ...options
  }
    )};

useGetWarehouseItemByIdQuery.document = GetWarehouseItemByIdDocument;

useGetWarehouseItemByIdQuery.getKey = (variables: GetWarehouseItemByIdQueryVariables) => ['GetWarehouseItemById', variables];


useGetWarehouseItemByIdQuery.fetcher = (client: GraphQLClient, variables: GetWarehouseItemByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetWarehouseItemByIdQuery, GetWarehouseItemByIdQueryVariables>(client, GetWarehouseItemByIdDocument, variables, headers);

export const CreateWarehouseDocument = `
    mutation CreateWarehouse($input: CreateWarehouseInput!) {
  createWarehouse(input: $input) {
    id
    name
    location
    allowedGroups
  }
}
    `;

export const useCreateWarehouseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateWarehouseMutation, TError, CreateWarehouseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateWarehouseMutation, TError, CreateWarehouseMutationVariables, TContext>(
      {
    mutationKey: ['CreateWarehouse'],
    mutationFn: (variables?: CreateWarehouseMutationVariables) => fetcher<CreateWarehouseMutation, CreateWarehouseMutationVariables>(client, CreateWarehouseDocument, variables, headers)(),
    ...options
  }
    )};

useCreateWarehouseMutation.getKey = () => ['CreateWarehouse'];


useCreateWarehouseMutation.fetcher = (client: GraphQLClient, variables: CreateWarehouseMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateWarehouseMutation, CreateWarehouseMutationVariables>(client, CreateWarehouseDocument, variables, headers);

export const UpdateWarehouseDocument = `
    mutation UpdateWarehouse($input: UpdateWarehouseInput!) {
  updateWarehouse(input: $input) {
    id
    name
    location
    allowedGroups
  }
}
    `;

export const useUpdateWarehouseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateWarehouseMutation, TError, UpdateWarehouseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateWarehouseMutation, TError, UpdateWarehouseMutationVariables, TContext>(
      {
    mutationKey: ['UpdateWarehouse'],
    mutationFn: (variables?: UpdateWarehouseMutationVariables) => fetcher<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>(client, UpdateWarehouseDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateWarehouseMutation.getKey = () => ['UpdateWarehouse'];


useUpdateWarehouseMutation.fetcher = (client: GraphQLClient, variables: UpdateWarehouseMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>(client, UpdateWarehouseDocument, variables, headers);

export const DeleteWarehouseDocument = `
    mutation DeleteWarehouse($id: ID!) {
  deleteWarehouse(id: $id) {
    id
    name
    location
    allowedGroups
  }
}
    `;

export const useDeleteWarehouseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteWarehouseMutation, TError, DeleteWarehouseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteWarehouseMutation, TError, DeleteWarehouseMutationVariables, TContext>(
      {
    mutationKey: ['DeleteWarehouse'],
    mutationFn: (variables?: DeleteWarehouseMutationVariables) => fetcher<DeleteWarehouseMutation, DeleteWarehouseMutationVariables>(client, DeleteWarehouseDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteWarehouseMutation.getKey = () => ['DeleteWarehouse'];


useDeleteWarehouseMutation.fetcher = (client: GraphQLClient, variables: DeleteWarehouseMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteWarehouseMutation, DeleteWarehouseMutationVariables>(client, DeleteWarehouseDocument, variables, headers);

export const CreateWarehouseItemDocument = `
    mutation CreateWarehouseItem($input: CreateWarehouseItemInput!) {
  createWarehouseItem(input: $input) {
    id
    name
    quantity
    warehouseId
  }
}
    `;

export const useCreateWarehouseItemMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateWarehouseItemMutation, TError, CreateWarehouseItemMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateWarehouseItemMutation, TError, CreateWarehouseItemMutationVariables, TContext>(
      {
    mutationKey: ['CreateWarehouseItem'],
    mutationFn: (variables?: CreateWarehouseItemMutationVariables) => fetcher<CreateWarehouseItemMutation, CreateWarehouseItemMutationVariables>(client, CreateWarehouseItemDocument, variables, headers)(),
    ...options
  }
    )};

useCreateWarehouseItemMutation.getKey = () => ['CreateWarehouseItem'];


useCreateWarehouseItemMutation.fetcher = (client: GraphQLClient, variables: CreateWarehouseItemMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateWarehouseItemMutation, CreateWarehouseItemMutationVariables>(client, CreateWarehouseItemDocument, variables, headers);

export const UpdateWarehouseItemDocument = `
    mutation UpdateWarehouseItem($input: UpdateWarehouseItemInput!) {
  updateWarehouseItem(input: $input) {
    id
    name
    quantity
    warehouseId
  }
}
    `;

export const useUpdateWarehouseItemMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateWarehouseItemMutation, TError, UpdateWarehouseItemMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateWarehouseItemMutation, TError, UpdateWarehouseItemMutationVariables, TContext>(
      {
    mutationKey: ['UpdateWarehouseItem'],
    mutationFn: (variables?: UpdateWarehouseItemMutationVariables) => fetcher<UpdateWarehouseItemMutation, UpdateWarehouseItemMutationVariables>(client, UpdateWarehouseItemDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateWarehouseItemMutation.getKey = () => ['UpdateWarehouseItem'];


useUpdateWarehouseItemMutation.fetcher = (client: GraphQLClient, variables: UpdateWarehouseItemMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateWarehouseItemMutation, UpdateWarehouseItemMutationVariables>(client, UpdateWarehouseItemDocument, variables, headers);

export const DeleteWarehouseItemDocument = `
    mutation DeleteWarehouseItem($warehouseId: ID!, $id: ID!) {
  deleteWarehouseItem(warehouseId: $warehouseId, id: $id) {
    id
    name
    quantity
    warehouseId
  }
}
    `;

export const useDeleteWarehouseItemMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteWarehouseItemMutation, TError, DeleteWarehouseItemMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteWarehouseItemMutation, TError, DeleteWarehouseItemMutationVariables, TContext>(
      {
    mutationKey: ['DeleteWarehouseItem'],
    mutationFn: (variables?: DeleteWarehouseItemMutationVariables) => fetcher<DeleteWarehouseItemMutation, DeleteWarehouseItemMutationVariables>(client, DeleteWarehouseItemDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteWarehouseItemMutation.getKey = () => ['DeleteWarehouseItem'];


useDeleteWarehouseItemMutation.fetcher = (client: GraphQLClient, variables: DeleteWarehouseItemMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteWarehouseItemMutation, DeleteWarehouseItemMutationVariables>(client, DeleteWarehouseItemDocument, variables, headers);

export const AddWarehouseItemQuantityDocument = `
    mutation AddWarehouseItemQuantity($input: ChangeQuantityInput!) {
  addWarehouseItemQuantity(input: $input) {
    id
    name
    quantity
    warehouseId
  }
}
    `;

export const useAddWarehouseItemQuantityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddWarehouseItemQuantityMutation, TError, AddWarehouseItemQuantityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<AddWarehouseItemQuantityMutation, TError, AddWarehouseItemQuantityMutationVariables, TContext>(
      {
    mutationKey: ['AddWarehouseItemQuantity'],
    mutationFn: (variables?: AddWarehouseItemQuantityMutationVariables) => fetcher<AddWarehouseItemQuantityMutation, AddWarehouseItemQuantityMutationVariables>(client, AddWarehouseItemQuantityDocument, variables, headers)(),
    ...options
  }
    )};

useAddWarehouseItemQuantityMutation.getKey = () => ['AddWarehouseItemQuantity'];


useAddWarehouseItemQuantityMutation.fetcher = (client: GraphQLClient, variables: AddWarehouseItemQuantityMutationVariables, headers?: RequestInit['headers']) => fetcher<AddWarehouseItemQuantityMutation, AddWarehouseItemQuantityMutationVariables>(client, AddWarehouseItemQuantityDocument, variables, headers);

export const SubtractWarehouseItemQuantityDocument = `
    mutation SubtractWarehouseItemQuantity($input: ChangeQuantityInput!) {
  subtractWarehouseItemQuantity(input: $input) {
    id
    name
    quantity
    warehouseId
  }
}
    `;

export const useSubtractWarehouseItemQuantityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SubtractWarehouseItemQuantityMutation, TError, SubtractWarehouseItemQuantityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SubtractWarehouseItemQuantityMutation, TError, SubtractWarehouseItemQuantityMutationVariables, TContext>(
      {
    mutationKey: ['SubtractWarehouseItemQuantity'],
    mutationFn: (variables?: SubtractWarehouseItemQuantityMutationVariables) => fetcher<SubtractWarehouseItemQuantityMutation, SubtractWarehouseItemQuantityMutationVariables>(client, SubtractWarehouseItemQuantityDocument, variables, headers)(),
    ...options
  }
    )};

useSubtractWarehouseItemQuantityMutation.getKey = () => ['SubtractWarehouseItemQuantity'];


useSubtractWarehouseItemQuantityMutation.fetcher = (client: GraphQLClient, variables: SubtractWarehouseItemQuantityMutationVariables, headers?: RequestInit['headers']) => fetcher<SubtractWarehouseItemQuantityMutation, SubtractWarehouseItemQuantityMutationVariables>(client, SubtractWarehouseItemQuantityDocument, variables, headers);

export const TransferWarehouseItemDocument = `
    mutation TransferWarehouseItem($input: TransferWarehouseItemInput!) {
  transferWarehouseItem(input: $input) {
    sourceItem {
      id
      name
      quantity
      warehouseId
    }
    targetItem {
      id
      name
      quantity
      warehouseId
    }
  }
}
    `;

export const useTransferWarehouseItemMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TransferWarehouseItemMutation, TError, TransferWarehouseItemMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<TransferWarehouseItemMutation, TError, TransferWarehouseItemMutationVariables, TContext>(
      {
    mutationKey: ['TransferWarehouseItem'],
    mutationFn: (variables?: TransferWarehouseItemMutationVariables) => fetcher<TransferWarehouseItemMutation, TransferWarehouseItemMutationVariables>(client, TransferWarehouseItemDocument, variables, headers)(),
    ...options
  }
    )};

useTransferWarehouseItemMutation.getKey = () => ['TransferWarehouseItem'];


useTransferWarehouseItemMutation.fetcher = (client: GraphQLClient, variables: TransferWarehouseItemMutationVariables, headers?: RequestInit['headers']) => fetcher<TransferWarehouseItemMutation, TransferWarehouseItemMutationVariables>(client, TransferWarehouseItemDocument, variables, headers);

export const GetMedicationNamesDocument = `
    query GetMedicationNames {
  getMedicationNames {
    id
    name
  }
}
    `;

export const useGetMedicationNamesQuery = <
      TData = GetMedicationNamesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMedicationNamesQueryVariables,
      options?: Omit<UseQueryOptions<GetMedicationNamesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMedicationNamesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMedicationNamesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetMedicationNames'] : ['GetMedicationNames', variables],
    queryFn: fetcher<GetMedicationNamesQuery, GetMedicationNamesQueryVariables>(client, GetMedicationNamesDocument, variables, headers),
    ...options
  }
    )};

useGetMedicationNamesQuery.document = GetMedicationNamesDocument;

useGetMedicationNamesQuery.getKey = (variables?: GetMedicationNamesQueryVariables) => variables === undefined ? ['GetMedicationNames'] : ['GetMedicationNames', variables];


useGetMedicationNamesQuery.fetcher = (client: GraphQLClient, variables?: GetMedicationNamesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMedicationNamesQuery, GetMedicationNamesQueryVariables>(client, GetMedicationNamesDocument, variables, headers);

export const FindMedicinalProductsDocument = `
    query FindMedicinalProducts($name: String!) {
  findMatchingMedicinalProductNames(name: $name) {
    productId
    productName
    commonName
    strength
  }
}
    `;

export const useFindMedicinalProductsQuery = <
      TData = FindMedicinalProductsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FindMedicinalProductsQueryVariables,
      options?: Omit<UseQueryOptions<FindMedicinalProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FindMedicinalProductsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<FindMedicinalProductsQuery, TError, TData>(
      {
    queryKey: ['FindMedicinalProducts', variables],
    queryFn: fetcher<FindMedicinalProductsQuery, FindMedicinalProductsQueryVariables>(client, FindMedicinalProductsDocument, variables, headers),
    ...options
  }
    )};

useFindMedicinalProductsQuery.document = FindMedicinalProductsDocument;

useFindMedicinalProductsQuery.getKey = (variables: FindMedicinalProductsQueryVariables) => ['FindMedicinalProducts', variables];


useFindMedicinalProductsQuery.fetcher = (client: GraphQLClient, variables: FindMedicinalProductsQueryVariables, headers?: RequestInit['headers']) => fetcher<FindMedicinalProductsQuery, FindMedicinalProductsQueryVariables>(client, FindMedicinalProductsDocument, variables, headers);

export const GetMedicinalProductDocument = `
    query GetMedicinalProduct($productId: ID!) {
  getMedicinalProduct(productId: $productId) {
    productId
    productName
    commonName
    preparationType
    animalUseBan
    previousProductName
    routeOfAdministration
    strength
    pharmaceuticalForm
    procedureType
    authorizationNumber
    authorizationValidity
    atcCode
    marketingAuthorizationHolder
    packaging
    activeSubstance
    manufacturerName
    manufacturerCountry
    importerName
    importerCountry
    manufacturerOrImporterName
    manufacturerOrImporterCountry
    exportCountryAuthorizationHolder
    exportCountry
    legalBasis
    leafletUrl
    characteristicsUrl
    labelLeaflet
    parallelImportLeaflet
    parallelImportLabelLeaflet
    parallelImportPackagingMarkings
    educationalToolsForHealthcareProfessionals
    educationalToolsForPatients
  }
}
    `;

export const useGetMedicinalProductQuery = <
      TData = GetMedicinalProductQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMedicinalProductQueryVariables,
      options?: Omit<UseQueryOptions<GetMedicinalProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMedicinalProductQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMedicinalProductQuery, TError, TData>(
      {
    queryKey: ['GetMedicinalProduct', variables],
    queryFn: fetcher<GetMedicinalProductQuery, GetMedicinalProductQueryVariables>(client, GetMedicinalProductDocument, variables, headers),
    ...options
  }
    )};

useGetMedicinalProductQuery.document = GetMedicinalProductDocument;

useGetMedicinalProductQuery.getKey = (variables: GetMedicinalProductQueryVariables) => ['GetMedicinalProduct', variables];


useGetMedicinalProductQuery.fetcher = (client: GraphQLClient, variables: GetMedicinalProductQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMedicinalProductQuery, GetMedicinalProductQueryVariables>(client, GetMedicinalProductDocument, variables, headers);

export const GetResidentMedicationByIdDocument = `
    query GetResidentMedicationById($id: ID!) {
  getResidentMedicationById(id: $id) {
    ...ResidentMedicationFragment
  }
}
    ${ResidentMedicationFragmentFragmentDoc}`;

export const useGetResidentMedicationByIdQuery = <
      TData = GetResidentMedicationByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetResidentMedicationByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetResidentMedicationByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetResidentMedicationByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetResidentMedicationByIdQuery, TError, TData>(
      {
    queryKey: ['GetResidentMedicationById', variables],
    queryFn: fetcher<GetResidentMedicationByIdQuery, GetResidentMedicationByIdQueryVariables>(client, GetResidentMedicationByIdDocument, variables, headers),
    ...options
  }
    )};

useGetResidentMedicationByIdQuery.document = GetResidentMedicationByIdDocument;

useGetResidentMedicationByIdQuery.getKey = (variables: GetResidentMedicationByIdQueryVariables) => ['GetResidentMedicationById', variables];


useGetResidentMedicationByIdQuery.fetcher = (client: GraphQLClient, variables: GetResidentMedicationByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetResidentMedicationByIdQuery, GetResidentMedicationByIdQueryVariables>(client, GetResidentMedicationByIdDocument, variables, headers);

export const GetResidentCurrentMedicationsDocument = `
    query GetResidentCurrentMedications($input: CurrentMedicationQueryInput) {
  getResidentCurrentMedications(input: $input) {
    ...ResidentMedicationFragment
  }
}
    ${ResidentMedicationFragmentFragmentDoc}`;

export const useGetResidentCurrentMedicationsQuery = <
      TData = GetResidentCurrentMedicationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetResidentCurrentMedicationsQueryVariables,
      options?: Omit<UseQueryOptions<GetResidentCurrentMedicationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetResidentCurrentMedicationsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetResidentCurrentMedicationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetResidentCurrentMedications'] : ['GetResidentCurrentMedications', variables],
    queryFn: fetcher<GetResidentCurrentMedicationsQuery, GetResidentCurrentMedicationsQueryVariables>(client, GetResidentCurrentMedicationsDocument, variables, headers),
    ...options
  }
    )};

useGetResidentCurrentMedicationsQuery.document = GetResidentCurrentMedicationsDocument;

useGetResidentCurrentMedicationsQuery.getKey = (variables?: GetResidentCurrentMedicationsQueryVariables) => variables === undefined ? ['GetResidentCurrentMedications'] : ['GetResidentCurrentMedications', variables];


useGetResidentCurrentMedicationsQuery.fetcher = (client: GraphQLClient, variables?: GetResidentCurrentMedicationsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetResidentCurrentMedicationsQuery, GetResidentCurrentMedicationsQueryVariables>(client, GetResidentCurrentMedicationsDocument, variables, headers);

export const GetResidentAllMedicationsDocument = `
    query GetResidentAllMedications($input: AllMedicationQueryInput) {
  getResidentAllMedications(input: $input) {
    ...ResidentMedicationFragment
  }
}
    ${ResidentMedicationFragmentFragmentDoc}`;

export const useGetResidentAllMedicationsQuery = <
      TData = GetResidentAllMedicationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetResidentAllMedicationsQueryVariables,
      options?: Omit<UseQueryOptions<GetResidentAllMedicationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetResidentAllMedicationsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetResidentAllMedicationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetResidentAllMedications'] : ['GetResidentAllMedications', variables],
    queryFn: fetcher<GetResidentAllMedicationsQuery, GetResidentAllMedicationsQueryVariables>(client, GetResidentAllMedicationsDocument, variables, headers),
    ...options
  }
    )};

useGetResidentAllMedicationsQuery.document = GetResidentAllMedicationsDocument;

useGetResidentAllMedicationsQuery.getKey = (variables?: GetResidentAllMedicationsQueryVariables) => variables === undefined ? ['GetResidentAllMedications'] : ['GetResidentAllMedications', variables];


useGetResidentAllMedicationsQuery.fetcher = (client: GraphQLClient, variables?: GetResidentAllMedicationsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetResidentAllMedicationsQuery, GetResidentAllMedicationsQueryVariables>(client, GetResidentAllMedicationsDocument, variables, headers);

export const GetAllResidentMedicationsForRangeDocument = `
    query GetAllResidentMedicationsForRange($input: GetAllResidentMedicationsInRangeInput!) {
  getAllResidentMedicationsForRange(input: $input) {
    ...ResidentMedicationFragment
  }
}
    ${ResidentMedicationFragmentFragmentDoc}`;

export const useGetAllResidentMedicationsForRangeQuery = <
      TData = GetAllResidentMedicationsForRangeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllResidentMedicationsForRangeQueryVariables,
      options?: Omit<UseQueryOptions<GetAllResidentMedicationsForRangeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllResidentMedicationsForRangeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllResidentMedicationsForRangeQuery, TError, TData>(
      {
    queryKey: ['GetAllResidentMedicationsForRange', variables],
    queryFn: fetcher<GetAllResidentMedicationsForRangeQuery, GetAllResidentMedicationsForRangeQueryVariables>(client, GetAllResidentMedicationsForRangeDocument, variables, headers),
    ...options
  }
    )};

useGetAllResidentMedicationsForRangeQuery.document = GetAllResidentMedicationsForRangeDocument;

useGetAllResidentMedicationsForRangeQuery.getKey = (variables: GetAllResidentMedicationsForRangeQueryVariables) => ['GetAllResidentMedicationsForRange', variables];


useGetAllResidentMedicationsForRangeQuery.fetcher = (client: GraphQLClient, variables: GetAllResidentMedicationsForRangeQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllResidentMedicationsForRangeQuery, GetAllResidentMedicationsForRangeQueryVariables>(client, GetAllResidentMedicationsForRangeDocument, variables, headers);

export const CreateMedicationNameDocument = `
    mutation CreateMedicationName($name: String!) {
  createMedicationName(name: $name) {
    id
    name
  }
}
    `;

export const useCreateMedicationNameMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateMedicationNameMutation, TError, CreateMedicationNameMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateMedicationNameMutation, TError, CreateMedicationNameMutationVariables, TContext>(
      {
    mutationKey: ['CreateMedicationName'],
    mutationFn: (variables?: CreateMedicationNameMutationVariables) => fetcher<CreateMedicationNameMutation, CreateMedicationNameMutationVariables>(client, CreateMedicationNameDocument, variables, headers)(),
    ...options
  }
    )};

useCreateMedicationNameMutation.getKey = () => ['CreateMedicationName'];


useCreateMedicationNameMutation.fetcher = (client: GraphQLClient, variables: CreateMedicationNameMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateMedicationNameMutation, CreateMedicationNameMutationVariables>(client, CreateMedicationNameDocument, variables, headers);

export const DeleteMedicationNameDocument = `
    mutation DeleteMedicationName($id: ID!) {
  deleteMedicationName(id: $id) {
    id
  }
}
    `;

export const useDeleteMedicationNameMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteMedicationNameMutation, TError, DeleteMedicationNameMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteMedicationNameMutation, TError, DeleteMedicationNameMutationVariables, TContext>(
      {
    mutationKey: ['DeleteMedicationName'],
    mutationFn: (variables?: DeleteMedicationNameMutationVariables) => fetcher<DeleteMedicationNameMutation, DeleteMedicationNameMutationVariables>(client, DeleteMedicationNameDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteMedicationNameMutation.getKey = () => ['DeleteMedicationName'];


useDeleteMedicationNameMutation.fetcher = (client: GraphQLClient, variables: DeleteMedicationNameMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteMedicationNameMutation, DeleteMedicationNameMutationVariables>(client, DeleteMedicationNameDocument, variables, headers);

export const CreateResidentMedicationDocument = `
    mutation CreateResidentMedication($input: CreateResidentMedicationInput!) {
  createResidentMedication(input: $input) {
    ...ResidentMedicationFragment
  }
}
    ${ResidentMedicationFragmentFragmentDoc}`;

export const useCreateResidentMedicationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateResidentMedicationMutation, TError, CreateResidentMedicationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateResidentMedicationMutation, TError, CreateResidentMedicationMutationVariables, TContext>(
      {
    mutationKey: ['CreateResidentMedication'],
    mutationFn: (variables?: CreateResidentMedicationMutationVariables) => fetcher<CreateResidentMedicationMutation, CreateResidentMedicationMutationVariables>(client, CreateResidentMedicationDocument, variables, headers)(),
    ...options
  }
    )};

useCreateResidentMedicationMutation.getKey = () => ['CreateResidentMedication'];


useCreateResidentMedicationMutation.fetcher = (client: GraphQLClient, variables: CreateResidentMedicationMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateResidentMedicationMutation, CreateResidentMedicationMutationVariables>(client, CreateResidentMedicationDocument, variables, headers);

export const UpdateResidentMedicationDocument = `
    mutation UpdateResidentMedication($input: UpdateResidentMedicationInput!) {
  updateResidentMedication(input: $input) {
    ...ResidentMedicationFragment
  }
}
    ${ResidentMedicationFragmentFragmentDoc}`;

export const useUpdateResidentMedicationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateResidentMedicationMutation, TError, UpdateResidentMedicationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateResidentMedicationMutation, TError, UpdateResidentMedicationMutationVariables, TContext>(
      {
    mutationKey: ['UpdateResidentMedication'],
    mutationFn: (variables?: UpdateResidentMedicationMutationVariables) => fetcher<UpdateResidentMedicationMutation, UpdateResidentMedicationMutationVariables>(client, UpdateResidentMedicationDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateResidentMedicationMutation.getKey = () => ['UpdateResidentMedication'];


useUpdateResidentMedicationMutation.fetcher = (client: GraphQLClient, variables: UpdateResidentMedicationMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateResidentMedicationMutation, UpdateResidentMedicationMutationVariables>(client, UpdateResidentMedicationDocument, variables, headers);

export const DeleteResidentMedicationDocument = `
    mutation DeleteResidentMedication($id: ID!) {
  deleteResidentMedication(id: $id) {
    ...ResidentMedicationFragment
  }
}
    ${ResidentMedicationFragmentFragmentDoc}`;

export const useDeleteResidentMedicationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteResidentMedicationMutation, TError, DeleteResidentMedicationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteResidentMedicationMutation, TError, DeleteResidentMedicationMutationVariables, TContext>(
      {
    mutationKey: ['DeleteResidentMedication'],
    mutationFn: (variables?: DeleteResidentMedicationMutationVariables) => fetcher<DeleteResidentMedicationMutation, DeleteResidentMedicationMutationVariables>(client, DeleteResidentMedicationDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteResidentMedicationMutation.getKey = () => ['DeleteResidentMedication'];


useDeleteResidentMedicationMutation.fetcher = (client: GraphQLClient, variables: DeleteResidentMedicationMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteResidentMedicationMutation, DeleteResidentMedicationMutationVariables>(client, DeleteResidentMedicationDocument, variables, headers);

export const GetAllNotificationConfigsDocument = `
    query GetAllNotificationConfigs {
  getAllNotificationConfigs {
    notificationType
    emails {
      email
      verified
      subscribedAt
      lastVerificationEmailSent
      language
    }
  }
}
    `;

export const useGetAllNotificationConfigsQuery = <
      TData = GetAllNotificationConfigsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllNotificationConfigsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllNotificationConfigsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllNotificationConfigsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllNotificationConfigsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllNotificationConfigs'] : ['GetAllNotificationConfigs', variables],
    queryFn: fetcher<GetAllNotificationConfigsQuery, GetAllNotificationConfigsQueryVariables>(client, GetAllNotificationConfigsDocument, variables, headers),
    ...options
  }
    )};

useGetAllNotificationConfigsQuery.document = GetAllNotificationConfigsDocument;

useGetAllNotificationConfigsQuery.getKey = (variables?: GetAllNotificationConfigsQueryVariables) => variables === undefined ? ['GetAllNotificationConfigs'] : ['GetAllNotificationConfigs', variables];


useGetAllNotificationConfigsQuery.fetcher = (client: GraphQLClient, variables?: GetAllNotificationConfigsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllNotificationConfigsQuery, GetAllNotificationConfigsQueryVariables>(client, GetAllNotificationConfigsDocument, variables, headers);

export const SubscribeToNotificationDocument = `
    mutation SubscribeToNotification($email: String!, $notificationType: NotificationType!, $language: String!) {
  subscribeToNotification(
    email: $email
    notificationType: $notificationType
    language: $language
  ) {
    email
    verified
    subscribedAt
    lastVerificationEmailSent
  }
}
    `;

export const useSubscribeToNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SubscribeToNotificationMutation, TError, SubscribeToNotificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SubscribeToNotificationMutation, TError, SubscribeToNotificationMutationVariables, TContext>(
      {
    mutationKey: ['SubscribeToNotification'],
    mutationFn: (variables?: SubscribeToNotificationMutationVariables) => fetcher<SubscribeToNotificationMutation, SubscribeToNotificationMutationVariables>(client, SubscribeToNotificationDocument, variables, headers)(),
    ...options
  }
    )};

useSubscribeToNotificationMutation.getKey = () => ['SubscribeToNotification'];


useSubscribeToNotificationMutation.fetcher = (client: GraphQLClient, variables: SubscribeToNotificationMutationVariables, headers?: RequestInit['headers']) => fetcher<SubscribeToNotificationMutation, SubscribeToNotificationMutationVariables>(client, SubscribeToNotificationDocument, variables, headers);

export const UnsubscribeFromNotificationDocument = `
    mutation UnsubscribeFromNotification($email: String!, $notificationType: NotificationType!) {
  unsubscribeFromNotification(email: $email, notificationType: $notificationType)
}
    `;

export const useUnsubscribeFromNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UnsubscribeFromNotificationMutation, TError, UnsubscribeFromNotificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UnsubscribeFromNotificationMutation, TError, UnsubscribeFromNotificationMutationVariables, TContext>(
      {
    mutationKey: ['UnsubscribeFromNotification'],
    mutationFn: (variables?: UnsubscribeFromNotificationMutationVariables) => fetcher<UnsubscribeFromNotificationMutation, UnsubscribeFromNotificationMutationVariables>(client, UnsubscribeFromNotificationDocument, variables, headers)(),
    ...options
  }
    )};

useUnsubscribeFromNotificationMutation.getKey = () => ['UnsubscribeFromNotification'];


useUnsubscribeFromNotificationMutation.fetcher = (client: GraphQLClient, variables: UnsubscribeFromNotificationMutationVariables, headers?: RequestInit['headers']) => fetcher<UnsubscribeFromNotificationMutation, UnsubscribeFromNotificationMutationVariables>(client, UnsubscribeFromNotificationDocument, variables, headers);

export const ResendVerificationEmailDocument = `
    mutation ResendVerificationEmail($email: String!, $notificationType: NotificationType!) {
  resendVerificationEmail(email: $email, notificationType: $notificationType)
}
    `;

export const useResendVerificationEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResendVerificationEmailMutation, TError, ResendVerificationEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ResendVerificationEmailMutation, TError, ResendVerificationEmailMutationVariables, TContext>(
      {
    mutationKey: ['ResendVerificationEmail'],
    mutationFn: (variables?: ResendVerificationEmailMutationVariables) => fetcher<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(client, ResendVerificationEmailDocument, variables, headers)(),
    ...options
  }
    )};

useResendVerificationEmailMutation.getKey = () => ['ResendVerificationEmail'];


useResendVerificationEmailMutation.fetcher = (client: GraphQLClient, variables: ResendVerificationEmailMutationVariables, headers?: RequestInit['headers']) => fetcher<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(client, ResendVerificationEmailDocument, variables, headers);

export const NotifyMedicationDistributionCompletedDocument = `
    mutation NotifyMedicationDistributionCompleted($input: MedicationDistributionSummaryInput!) {
  notifyMedicationDistributionCompleted(input: $input)
}
    `;

export const useNotifyMedicationDistributionCompletedMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<NotifyMedicationDistributionCompletedMutation, TError, NotifyMedicationDistributionCompletedMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<NotifyMedicationDistributionCompletedMutation, TError, NotifyMedicationDistributionCompletedMutationVariables, TContext>(
      {
    mutationKey: ['NotifyMedicationDistributionCompleted'],
    mutationFn: (variables?: NotifyMedicationDistributionCompletedMutationVariables) => fetcher<NotifyMedicationDistributionCompletedMutation, NotifyMedicationDistributionCompletedMutationVariables>(client, NotifyMedicationDistributionCompletedDocument, variables, headers)(),
    ...options
  }
    )};

useNotifyMedicationDistributionCompletedMutation.getKey = () => ['NotifyMedicationDistributionCompleted'];


useNotifyMedicationDistributionCompletedMutation.fetcher = (client: GraphQLClient, variables: NotifyMedicationDistributionCompletedMutationVariables, headers?: RequestInit['headers']) => fetcher<NotifyMedicationDistributionCompletedMutation, NotifyMedicationDistributionCompletedMutationVariables>(client, NotifyMedicationDistributionCompletedDocument, variables, headers);

export const GetAllPairedDevicesDocument = `
    query GetAllPairedDevices {
  getAllPairedDevices {
    items {
      id
      deviceName
      deviceUUID
      userRequested
      deviceType
      createdAt
      updatedAt
      reviewedBy
      approvedIps
      rejectedIps
      pendingIps
    }
  }
}
    `;

export const useGetAllPairedDevicesQuery = <
      TData = GetAllPairedDevicesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllPairedDevicesQueryVariables,
      options?: Omit<UseQueryOptions<GetAllPairedDevicesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllPairedDevicesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllPairedDevicesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllPairedDevices'] : ['GetAllPairedDevices', variables],
    queryFn: fetcher<GetAllPairedDevicesQuery, GetAllPairedDevicesQueryVariables>(client, GetAllPairedDevicesDocument, variables, headers),
    ...options
  }
    )};

useGetAllPairedDevicesQuery.document = GetAllPairedDevicesDocument;

useGetAllPairedDevicesQuery.getKey = (variables?: GetAllPairedDevicesQueryVariables) => variables === undefined ? ['GetAllPairedDevices'] : ['GetAllPairedDevices', variables];


useGetAllPairedDevicesQuery.fetcher = (client: GraphQLClient, variables?: GetAllPairedDevicesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllPairedDevicesQuery, GetAllPairedDevicesQueryVariables>(client, GetAllPairedDevicesDocument, variables, headers);

export const GetPairedDeviceByIdDocument = `
    query GetPairedDeviceById($id: ID!) {
  getPairedDeviceById(id: $id) {
    id
    deviceName
    deviceUUID
    userRequested
    deviceType
    createdAt
    updatedAt
    reviewedBy
    approvedIps
    rejectedIps
    pendingIps
  }
}
    `;

export const useGetPairedDeviceByIdQuery = <
      TData = GetPairedDeviceByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPairedDeviceByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetPairedDeviceByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPairedDeviceByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetPairedDeviceByIdQuery, TError, TData>(
      {
    queryKey: ['GetPairedDeviceById', variables],
    queryFn: fetcher<GetPairedDeviceByIdQuery, GetPairedDeviceByIdQueryVariables>(client, GetPairedDeviceByIdDocument, variables, headers),
    ...options
  }
    )};

useGetPairedDeviceByIdQuery.document = GetPairedDeviceByIdDocument;

useGetPairedDeviceByIdQuery.getKey = (variables: GetPairedDeviceByIdQueryVariables) => ['GetPairedDeviceById', variables];


useGetPairedDeviceByIdQuery.fetcher = (client: GraphQLClient, variables: GetPairedDeviceByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetPairedDeviceByIdQuery, GetPairedDeviceByIdQueryVariables>(client, GetPairedDeviceByIdDocument, variables, headers);

export const ApprovePairedDeviceDocument = `
    mutation ApprovePairedDevice($id: ID!) {
  approveDevice(id: $id) {
    id
    deviceName
    deviceUUID
    userRequested
    deviceType
    createdAt
    updatedAt
    reviewedBy
    approvedIps
    rejectedIps
    pendingIps
  }
}
    `;

export const useApprovePairedDeviceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApprovePairedDeviceMutation, TError, ApprovePairedDeviceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ApprovePairedDeviceMutation, TError, ApprovePairedDeviceMutationVariables, TContext>(
      {
    mutationKey: ['ApprovePairedDevice'],
    mutationFn: (variables?: ApprovePairedDeviceMutationVariables) => fetcher<ApprovePairedDeviceMutation, ApprovePairedDeviceMutationVariables>(client, ApprovePairedDeviceDocument, variables, headers)(),
    ...options
  }
    )};

useApprovePairedDeviceMutation.getKey = () => ['ApprovePairedDevice'];


useApprovePairedDeviceMutation.fetcher = (client: GraphQLClient, variables: ApprovePairedDeviceMutationVariables, headers?: RequestInit['headers']) => fetcher<ApprovePairedDeviceMutation, ApprovePairedDeviceMutationVariables>(client, ApprovePairedDeviceDocument, variables, headers);

export const RejectPairedDeviceDocument = `
    mutation RejectPairedDevice($id: ID!) {
  rejectDevice(id: $id) {
    id
    deviceName
    deviceUUID
    userRequested
    deviceType
    createdAt
    updatedAt
    reviewedBy
    approvedIps
    rejectedIps
    pendingIps
  }
}
    `;

export const useRejectPairedDeviceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RejectPairedDeviceMutation, TError, RejectPairedDeviceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<RejectPairedDeviceMutation, TError, RejectPairedDeviceMutationVariables, TContext>(
      {
    mutationKey: ['RejectPairedDevice'],
    mutationFn: (variables?: RejectPairedDeviceMutationVariables) => fetcher<RejectPairedDeviceMutation, RejectPairedDeviceMutationVariables>(client, RejectPairedDeviceDocument, variables, headers)(),
    ...options
  }
    )};

useRejectPairedDeviceMutation.getKey = () => ['RejectPairedDevice'];


useRejectPairedDeviceMutation.fetcher = (client: GraphQLClient, variables: RejectPairedDeviceMutationVariables, headers?: RequestInit['headers']) => fetcher<RejectPairedDeviceMutation, RejectPairedDeviceMutationVariables>(client, RejectPairedDeviceDocument, variables, headers);

export const ApproveDeviceIpDocument = `
    mutation ApproveDeviceIp($id: ID!, $ip: String!) {
  approveDeviceIp(id: $id, ip: $ip) {
    id
    deviceUUID
    reviewedBy
    updatedAt
    approvedIps
    rejectedIps
    pendingIps
  }
}
    `;

export const useApproveDeviceIpMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApproveDeviceIpMutation, TError, ApproveDeviceIpMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ApproveDeviceIpMutation, TError, ApproveDeviceIpMutationVariables, TContext>(
      {
    mutationKey: ['ApproveDeviceIp'],
    mutationFn: (variables?: ApproveDeviceIpMutationVariables) => fetcher<ApproveDeviceIpMutation, ApproveDeviceIpMutationVariables>(client, ApproveDeviceIpDocument, variables, headers)(),
    ...options
  }
    )};

useApproveDeviceIpMutation.getKey = () => ['ApproveDeviceIp'];


useApproveDeviceIpMutation.fetcher = (client: GraphQLClient, variables: ApproveDeviceIpMutationVariables, headers?: RequestInit['headers']) => fetcher<ApproveDeviceIpMutation, ApproveDeviceIpMutationVariables>(client, ApproveDeviceIpDocument, variables, headers);

export const RejectDeviceIpDocument = `
    mutation RejectDeviceIp($id: ID!, $ip: String!) {
  rejectDeviceIp(id: $id, ip: $ip) {
    id
    deviceUUID
    reviewedBy
    updatedAt
    approvedIps
    rejectedIps
    pendingIps
  }
}
    `;

export const useRejectDeviceIpMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RejectDeviceIpMutation, TError, RejectDeviceIpMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<RejectDeviceIpMutation, TError, RejectDeviceIpMutationVariables, TContext>(
      {
    mutationKey: ['RejectDeviceIp'],
    mutationFn: (variables?: RejectDeviceIpMutationVariables) => fetcher<RejectDeviceIpMutation, RejectDeviceIpMutationVariables>(client, RejectDeviceIpDocument, variables, headers)(),
    ...options
  }
    )};

useRejectDeviceIpMutation.getKey = () => ['RejectDeviceIp'];


useRejectDeviceIpMutation.fetcher = (client: GraphQLClient, variables: RejectDeviceIpMutationVariables, headers?: RequestInit['headers']) => fetcher<RejectDeviceIpMutation, RejectDeviceIpMutationVariables>(client, RejectDeviceIpDocument, variables, headers);

export const DeleteDeviceIpDocument = `
    mutation DeleteDeviceIp($id: ID!, $ip: String!) {
  deleteDeviceIp(id: $id, ip: $ip) {
    id
    deviceUUID
    updatedAt
    approvedIps
    rejectedIps
    pendingIps
  }
}
    `;

export const useDeleteDeviceIpMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteDeviceIpMutation, TError, DeleteDeviceIpMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteDeviceIpMutation, TError, DeleteDeviceIpMutationVariables, TContext>(
      {
    mutationKey: ['DeleteDeviceIp'],
    mutationFn: (variables?: DeleteDeviceIpMutationVariables) => fetcher<DeleteDeviceIpMutation, DeleteDeviceIpMutationVariables>(client, DeleteDeviceIpDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteDeviceIpMutation.getKey = () => ['DeleteDeviceIp'];


useDeleteDeviceIpMutation.fetcher = (client: GraphQLClient, variables: DeleteDeviceIpMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteDeviceIpMutation, DeleteDeviceIpMutationVariables>(client, DeleteDeviceIpDocument, variables, headers);

export const RenamePairedDeviceDocument = `
    mutation RenamePairedDevice($input: RenameDeviceInput!) {
  renameDevice(input: $input) {
    id
    deviceName
    deviceUUID
    userRequested
    deviceType
    createdAt
    updatedAt
    reviewedBy
    approvedIps
    rejectedIps
    pendingIps
  }
}
    `;

export const useRenamePairedDeviceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RenamePairedDeviceMutation, TError, RenamePairedDeviceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<RenamePairedDeviceMutation, TError, RenamePairedDeviceMutationVariables, TContext>(
      {
    mutationKey: ['RenamePairedDevice'],
    mutationFn: (variables?: RenamePairedDeviceMutationVariables) => fetcher<RenamePairedDeviceMutation, RenamePairedDeviceMutationVariables>(client, RenamePairedDeviceDocument, variables, headers)(),
    ...options
  }
    )};

useRenamePairedDeviceMutation.getKey = () => ['RenamePairedDevice'];


useRenamePairedDeviceMutation.fetcher = (client: GraphQLClient, variables: RenamePairedDeviceMutationVariables, headers?: RequestInit['headers']) => fetcher<RenamePairedDeviceMutation, RenamePairedDeviceMutationVariables>(client, RenamePairedDeviceDocument, variables, headers);

export const DeletePairedDeviceDocument = `
    mutation DeletePairedDevice($id: ID!) {
  deleteDevice(id: $id) {
    id
  }
}
    `;

export const useDeletePairedDeviceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePairedDeviceMutation, TError, DeletePairedDeviceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeletePairedDeviceMutation, TError, DeletePairedDeviceMutationVariables, TContext>(
      {
    mutationKey: ['DeletePairedDevice'],
    mutationFn: (variables?: DeletePairedDeviceMutationVariables) => fetcher<DeletePairedDeviceMutation, DeletePairedDeviceMutationVariables>(client, DeletePairedDeviceDocument, variables, headers)(),
    ...options
  }
    )};

useDeletePairedDeviceMutation.getKey = () => ['DeletePairedDevice'];


useDeletePairedDeviceMutation.fetcher = (client: GraphQLClient, variables: DeletePairedDeviceMutationVariables, headers?: RequestInit['headers']) => fetcher<DeletePairedDeviceMutation, DeletePairedDeviceMutationVariables>(client, DeletePairedDeviceDocument, variables, headers);

export const GetRecurringTaskDocument = `
    query GetRecurringTask($id: ID!) {
  getRecurringTask(id: $id) {
    id
    title
    content
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    interval {
      type
      amount
    }
    occurrences
    currentOccurrence
    startTimestamp
    lastOccurrenceTimestamp
    jobRoleIds
  }
}
    `;

export const useGetRecurringTaskQuery = <
      TData = GetRecurringTaskQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRecurringTaskQueryVariables,
      options?: Omit<UseQueryOptions<GetRecurringTaskQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRecurringTaskQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRecurringTaskQuery, TError, TData>(
      {
    queryKey: ['GetRecurringTask', variables],
    queryFn: fetcher<GetRecurringTaskQuery, GetRecurringTaskQueryVariables>(client, GetRecurringTaskDocument, variables, headers),
    ...options
  }
    )};

useGetRecurringTaskQuery.document = GetRecurringTaskDocument;

useGetRecurringTaskQuery.getKey = (variables: GetRecurringTaskQueryVariables) => ['GetRecurringTask', variables];


useGetRecurringTaskQuery.fetcher = (client: GraphQLClient, variables: GetRecurringTaskQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRecurringTaskQuery, GetRecurringTaskQueryVariables>(client, GetRecurringTaskDocument, variables, headers);

export const FindRecurringTaskByIdDocument = `
    query FindRecurringTaskById($id: ID!) {
  findRecurringTaskById(id: $id) {
    id
    title
    content
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    interval {
      type
      amount
    }
    occurrences
    currentOccurrence
    startTimestamp
    lastOccurrenceTimestamp
    jobRoleIds
  }
}
    `;

export const useFindRecurringTaskByIdQuery = <
      TData = FindRecurringTaskByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FindRecurringTaskByIdQueryVariables,
      options?: Omit<UseQueryOptions<FindRecurringTaskByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FindRecurringTaskByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<FindRecurringTaskByIdQuery, TError, TData>(
      {
    queryKey: ['FindRecurringTaskById', variables],
    queryFn: fetcher<FindRecurringTaskByIdQuery, FindRecurringTaskByIdQueryVariables>(client, FindRecurringTaskByIdDocument, variables, headers),
    ...options
  }
    )};

useFindRecurringTaskByIdQuery.document = FindRecurringTaskByIdDocument;

useFindRecurringTaskByIdQuery.getKey = (variables: FindRecurringTaskByIdQueryVariables) => ['FindRecurringTaskById', variables];


useFindRecurringTaskByIdQuery.fetcher = (client: GraphQLClient, variables: FindRecurringTaskByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<FindRecurringTaskByIdQuery, FindRecurringTaskByIdQueryVariables>(client, FindRecurringTaskByIdDocument, variables, headers);

export const GetRecurringTasksDocument = `
    query GetRecurringTasks {
  getRecurringTasks {
    id
    title
    content
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    interval {
      type
      amount
    }
    occurrences
    currentOccurrence
    startTimestamp
    lastOccurrenceTimestamp
    jobRoleIds
  }
}
    `;

export const useGetRecurringTasksQuery = <
      TData = GetRecurringTasksQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetRecurringTasksQueryVariables,
      options?: Omit<UseQueryOptions<GetRecurringTasksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRecurringTasksQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRecurringTasksQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetRecurringTasks'] : ['GetRecurringTasks', variables],
    queryFn: fetcher<GetRecurringTasksQuery, GetRecurringTasksQueryVariables>(client, GetRecurringTasksDocument, variables, headers),
    ...options
  }
    )};

useGetRecurringTasksQuery.document = GetRecurringTasksDocument;

useGetRecurringTasksQuery.getKey = (variables?: GetRecurringTasksQueryVariables) => variables === undefined ? ['GetRecurringTasks'] : ['GetRecurringTasks', variables];


useGetRecurringTasksQuery.fetcher = (client: GraphQLClient, variables?: GetRecurringTasksQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRecurringTasksQuery, GetRecurringTasksQueryVariables>(client, GetRecurringTasksDocument, variables, headers);

export const CreateRecurringTaskDocument = `
    mutation CreateRecurringTask($input: CreateRecurringTaskInput!) {
  createRecurringTask(input: $input) {
    id
    title
    content
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    interval {
      type
      amount
    }
    occurrences
    currentOccurrence
    startTimestamp
    lastOccurrenceTimestamp
    jobRoleIds
  }
}
    `;

export const useCreateRecurringTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateRecurringTaskMutation, TError, CreateRecurringTaskMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateRecurringTaskMutation, TError, CreateRecurringTaskMutationVariables, TContext>(
      {
    mutationKey: ['CreateRecurringTask'],
    mutationFn: (variables?: CreateRecurringTaskMutationVariables) => fetcher<CreateRecurringTaskMutation, CreateRecurringTaskMutationVariables>(client, CreateRecurringTaskDocument, variables, headers)(),
    ...options
  }
    )};

useCreateRecurringTaskMutation.getKey = () => ['CreateRecurringTask'];


useCreateRecurringTaskMutation.fetcher = (client: GraphQLClient, variables: CreateRecurringTaskMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateRecurringTaskMutation, CreateRecurringTaskMutationVariables>(client, CreateRecurringTaskDocument, variables, headers);

export const UpdateRecurringTaskDocument = `
    mutation UpdateRecurringTask($input: UpdateRecurringTaskInput!) {
  updateRecurringTask(input: $input) {
    id
    title
    content
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    interval {
      type
      amount
    }
    occurrences
    currentOccurrence
    startTimestamp
    lastOccurrenceTimestamp
    jobRoleIds
  }
}
    `;

export const useUpdateRecurringTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateRecurringTaskMutation, TError, UpdateRecurringTaskMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateRecurringTaskMutation, TError, UpdateRecurringTaskMutationVariables, TContext>(
      {
    mutationKey: ['UpdateRecurringTask'],
    mutationFn: (variables?: UpdateRecurringTaskMutationVariables) => fetcher<UpdateRecurringTaskMutation, UpdateRecurringTaskMutationVariables>(client, UpdateRecurringTaskDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateRecurringTaskMutation.getKey = () => ['UpdateRecurringTask'];


useUpdateRecurringTaskMutation.fetcher = (client: GraphQLClient, variables: UpdateRecurringTaskMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateRecurringTaskMutation, UpdateRecurringTaskMutationVariables>(client, UpdateRecurringTaskDocument, variables, headers);

export const DeleteRecurringTaskDocument = `
    mutation DeleteRecurringTask($id: ID!) {
  deleteRecurringTask(id: $id) {
    id
    title
    content
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    interval {
      type
      amount
    }
    occurrences
    currentOccurrence
    startTimestamp
    lastOccurrenceTimestamp
    jobRoleIds
  }
}
    `;

export const useDeleteRecurringTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteRecurringTaskMutation, TError, DeleteRecurringTaskMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteRecurringTaskMutation, TError, DeleteRecurringTaskMutationVariables, TContext>(
      {
    mutationKey: ['DeleteRecurringTask'],
    mutationFn: (variables?: DeleteRecurringTaskMutationVariables) => fetcher<DeleteRecurringTaskMutation, DeleteRecurringTaskMutationVariables>(client, DeleteRecurringTaskDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteRecurringTaskMutation.getKey = () => ['DeleteRecurringTask'];


useDeleteRecurringTaskMutation.fetcher = (client: GraphQLClient, variables: DeleteRecurringTaskMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteRecurringTaskMutation, DeleteRecurringTaskMutationVariables>(client, DeleteRecurringTaskDocument, variables, headers);

export const OnCreateRecurringTaskDocument = `
    subscription OnCreateRecurringTask {
  onCreateRecurringTask {
    id
    title
    content
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    interval {
      type
      amount
    }
    occurrences
    currentOccurrence
    startTimestamp
    lastOccurrenceTimestamp
    jobRoleIds
  }
}
    `;
export const OnUpdateRecurringTaskDocument = `
    subscription OnUpdateRecurringTask {
  onUpdateRecurringTask {
    id
    title
    content
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    interval {
      type
      amount
    }
    occurrences
    currentOccurrence
    startTimestamp
    lastOccurrenceTimestamp
    jobRoleIds
  }
}
    `;
export const OnDeleteRecurringTaskDocument = `
    subscription OnDeleteRecurringTask {
  onDeleteRecurringTask {
    id
  }
}
    `;
export const GetRehabPlanByResidentIdDocument = `
    query GetRehabPlanByResidentId($residentId: ID!) {
  getRehabPlanByResidentId(residentId: $residentId) {
    ...RehabPlanFragment
  }
}
    ${RehabPlanFragmentFragmentDoc}`;

export const useGetRehabPlanByResidentIdQuery = <
      TData = GetRehabPlanByResidentIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRehabPlanByResidentIdQueryVariables,
      options?: Omit<UseQueryOptions<GetRehabPlanByResidentIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRehabPlanByResidentIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRehabPlanByResidentIdQuery, TError, TData>(
      {
    queryKey: ['GetRehabPlanByResidentId', variables],
    queryFn: fetcher<GetRehabPlanByResidentIdQuery, GetRehabPlanByResidentIdQueryVariables>(client, GetRehabPlanByResidentIdDocument, variables, headers),
    ...options
  }
    )};

useGetRehabPlanByResidentIdQuery.document = GetRehabPlanByResidentIdDocument;

useGetRehabPlanByResidentIdQuery.getKey = (variables: GetRehabPlanByResidentIdQueryVariables) => ['GetRehabPlanByResidentId', variables];


useGetRehabPlanByResidentIdQuery.fetcher = (client: GraphQLClient, variables: GetRehabPlanByResidentIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRehabPlanByResidentIdQuery, GetRehabPlanByResidentIdQueryVariables>(client, GetRehabPlanByResidentIdDocument, variables, headers);

export const GetRehabSessionsByResidentIdDocument = `
    query GetRehabSessionsByResidentId($residentId: ID!) {
  getRehabSessionsByResidentId(residentId: $residentId) {
    ...RehabSessionFragment
  }
}
    ${RehabSessionFragmentFragmentDoc}`;

export const useGetRehabSessionsByResidentIdQuery = <
      TData = GetRehabSessionsByResidentIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRehabSessionsByResidentIdQueryVariables,
      options?: Omit<UseQueryOptions<GetRehabSessionsByResidentIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRehabSessionsByResidentIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRehabSessionsByResidentIdQuery, TError, TData>(
      {
    queryKey: ['GetRehabSessionsByResidentId', variables],
    queryFn: fetcher<GetRehabSessionsByResidentIdQuery, GetRehabSessionsByResidentIdQueryVariables>(client, GetRehabSessionsByResidentIdDocument, variables, headers),
    ...options
  }
    )};

useGetRehabSessionsByResidentIdQuery.document = GetRehabSessionsByResidentIdDocument;

useGetRehabSessionsByResidentIdQuery.getKey = (variables: GetRehabSessionsByResidentIdQueryVariables) => ['GetRehabSessionsByResidentId', variables];


useGetRehabSessionsByResidentIdQuery.fetcher = (client: GraphQLClient, variables: GetRehabSessionsByResidentIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRehabSessionsByResidentIdQuery, GetRehabSessionsByResidentIdQueryVariables>(client, GetRehabSessionsByResidentIdDocument, variables, headers);

export const CreateRehabPlanDocument = `
    mutation CreateRehabPlan($input: CreateRehabPlanInput!) {
  createRehabPlan(input: $input) {
    ...RehabPlanFragment
  }
}
    ${RehabPlanFragmentFragmentDoc}`;

export const useCreateRehabPlanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateRehabPlanMutation, TError, CreateRehabPlanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateRehabPlanMutation, TError, CreateRehabPlanMutationVariables, TContext>(
      {
    mutationKey: ['CreateRehabPlan'],
    mutationFn: (variables?: CreateRehabPlanMutationVariables) => fetcher<CreateRehabPlanMutation, CreateRehabPlanMutationVariables>(client, CreateRehabPlanDocument, variables, headers)(),
    ...options
  }
    )};

useCreateRehabPlanMutation.getKey = () => ['CreateRehabPlan'];


useCreateRehabPlanMutation.fetcher = (client: GraphQLClient, variables: CreateRehabPlanMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateRehabPlanMutation, CreateRehabPlanMutationVariables>(client, CreateRehabPlanDocument, variables, headers);

export const UpdateRehabPlanDocument = `
    mutation UpdateRehabPlan($input: UpdateRehabPlanInput!) {
  updateRehabPlan(input: $input) {
    ...RehabPlanFragment
  }
}
    ${RehabPlanFragmentFragmentDoc}`;

export const useUpdateRehabPlanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateRehabPlanMutation, TError, UpdateRehabPlanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateRehabPlanMutation, TError, UpdateRehabPlanMutationVariables, TContext>(
      {
    mutationKey: ['UpdateRehabPlan'],
    mutationFn: (variables?: UpdateRehabPlanMutationVariables) => fetcher<UpdateRehabPlanMutation, UpdateRehabPlanMutationVariables>(client, UpdateRehabPlanDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateRehabPlanMutation.getKey = () => ['UpdateRehabPlan'];


useUpdateRehabPlanMutation.fetcher = (client: GraphQLClient, variables: UpdateRehabPlanMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateRehabPlanMutation, UpdateRehabPlanMutationVariables>(client, UpdateRehabPlanDocument, variables, headers);

export const ArchiveRehabPlanDocument = `
    mutation ArchiveRehabPlan($id: ID!) {
  archiveRehabPlan(id: $id) {
    ...RehabPlanFragment
  }
}
    ${RehabPlanFragmentFragmentDoc}`;

export const useArchiveRehabPlanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ArchiveRehabPlanMutation, TError, ArchiveRehabPlanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ArchiveRehabPlanMutation, TError, ArchiveRehabPlanMutationVariables, TContext>(
      {
    mutationKey: ['ArchiveRehabPlan'],
    mutationFn: (variables?: ArchiveRehabPlanMutationVariables) => fetcher<ArchiveRehabPlanMutation, ArchiveRehabPlanMutationVariables>(client, ArchiveRehabPlanDocument, variables, headers)(),
    ...options
  }
    )};

useArchiveRehabPlanMutation.getKey = () => ['ArchiveRehabPlan'];


useArchiveRehabPlanMutation.fetcher = (client: GraphQLClient, variables: ArchiveRehabPlanMutationVariables, headers?: RequestInit['headers']) => fetcher<ArchiveRehabPlanMutation, ArchiveRehabPlanMutationVariables>(client, ArchiveRehabPlanDocument, variables, headers);

export const CreateRehabSessionDocument = `
    mutation CreateRehabSession($input: CreateRehabSessionInput!) {
  createRehabSession(input: $input) {
    ...RehabSessionFragment
  }
}
    ${RehabSessionFragmentFragmentDoc}`;

export const useCreateRehabSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateRehabSessionMutation, TError, CreateRehabSessionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateRehabSessionMutation, TError, CreateRehabSessionMutationVariables, TContext>(
      {
    mutationKey: ['CreateRehabSession'],
    mutationFn: (variables?: CreateRehabSessionMutationVariables) => fetcher<CreateRehabSessionMutation, CreateRehabSessionMutationVariables>(client, CreateRehabSessionDocument, variables, headers)(),
    ...options
  }
    )};

useCreateRehabSessionMutation.getKey = () => ['CreateRehabSession'];


useCreateRehabSessionMutation.fetcher = (client: GraphQLClient, variables: CreateRehabSessionMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateRehabSessionMutation, CreateRehabSessionMutationVariables>(client, CreateRehabSessionDocument, variables, headers);

export const GetAllCurrentResidentsDocument = `
    query GetAllCurrentResidents {
  getAllCurrentResidents {
    ...ResidentFragment
  }
}
    ${ResidentFragmentFragmentDoc}`;

export const useGetAllCurrentResidentsQuery = <
      TData = GetAllCurrentResidentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllCurrentResidentsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllCurrentResidentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllCurrentResidentsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllCurrentResidentsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllCurrentResidents'] : ['GetAllCurrentResidents', variables],
    queryFn: fetcher<GetAllCurrentResidentsQuery, GetAllCurrentResidentsQueryVariables>(client, GetAllCurrentResidentsDocument, variables, headers),
    ...options
  }
    )};

useGetAllCurrentResidentsQuery.document = GetAllCurrentResidentsDocument;

useGetAllCurrentResidentsQuery.getKey = (variables?: GetAllCurrentResidentsQueryVariables) => variables === undefined ? ['GetAllCurrentResidents'] : ['GetAllCurrentResidents', variables];


useGetAllCurrentResidentsQuery.fetcher = (client: GraphQLClient, variables?: GetAllCurrentResidentsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllCurrentResidentsQuery, GetAllCurrentResidentsQueryVariables>(client, GetAllCurrentResidentsDocument, variables, headers);

export const GetAllPendingResidentsDocument = `
    query GetAllPendingResidents {
  getAllPendingResidents {
    ...ResidentFragment
  }
}
    ${ResidentFragmentFragmentDoc}`;

export const useGetAllPendingResidentsQuery = <
      TData = GetAllPendingResidentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllPendingResidentsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllPendingResidentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllPendingResidentsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllPendingResidentsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllPendingResidents'] : ['GetAllPendingResidents', variables],
    queryFn: fetcher<GetAllPendingResidentsQuery, GetAllPendingResidentsQueryVariables>(client, GetAllPendingResidentsDocument, variables, headers),
    ...options
  }
    )};

useGetAllPendingResidentsQuery.document = GetAllPendingResidentsDocument;

useGetAllPendingResidentsQuery.getKey = (variables?: GetAllPendingResidentsQueryVariables) => variables === undefined ? ['GetAllPendingResidents'] : ['GetAllPendingResidents', variables];


useGetAllPendingResidentsQuery.fetcher = (client: GraphQLClient, variables?: GetAllPendingResidentsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllPendingResidentsQuery, GetAllPendingResidentsQueryVariables>(client, GetAllPendingResidentsDocument, variables, headers);

export const GetAllOldResidentsDocument = `
    query GetAllOldResidents {
  getAllOldResidents {
    ...ResidentFragment
  }
}
    ${ResidentFragmentFragmentDoc}`;

export const useGetAllOldResidentsQuery = <
      TData = GetAllOldResidentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllOldResidentsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllOldResidentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllOldResidentsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllOldResidentsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllOldResidents'] : ['GetAllOldResidents', variables],
    queryFn: fetcher<GetAllOldResidentsQuery, GetAllOldResidentsQueryVariables>(client, GetAllOldResidentsDocument, variables, headers),
    ...options
  }
    )};

useGetAllOldResidentsQuery.document = GetAllOldResidentsDocument;

useGetAllOldResidentsQuery.getKey = (variables?: GetAllOldResidentsQueryVariables) => variables === undefined ? ['GetAllOldResidents'] : ['GetAllOldResidents', variables];


useGetAllOldResidentsQuery.fetcher = (client: GraphQLClient, variables?: GetAllOldResidentsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllOldResidentsQuery, GetAllOldResidentsQueryVariables>(client, GetAllOldResidentsDocument, variables, headers);

export const GetAllCurrentResidentsForInputDocument = `
    query GetAllCurrentResidentsForInput {
  getAllCurrentResidents {
    ...ResidentBaseFragment
  }
}
    ${ResidentBaseFragmentFragmentDoc}`;

export const useGetAllCurrentResidentsForInputQuery = <
      TData = GetAllCurrentResidentsForInputQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllCurrentResidentsForInputQueryVariables,
      options?: Omit<UseQueryOptions<GetAllCurrentResidentsForInputQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllCurrentResidentsForInputQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllCurrentResidentsForInputQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllCurrentResidentsForInput'] : ['GetAllCurrentResidentsForInput', variables],
    queryFn: fetcher<GetAllCurrentResidentsForInputQuery, GetAllCurrentResidentsForInputQueryVariables>(client, GetAllCurrentResidentsForInputDocument, variables, headers),
    ...options
  }
    )};

useGetAllCurrentResidentsForInputQuery.document = GetAllCurrentResidentsForInputDocument;

useGetAllCurrentResidentsForInputQuery.getKey = (variables?: GetAllCurrentResidentsForInputQueryVariables) => variables === undefined ? ['GetAllCurrentResidentsForInput'] : ['GetAllCurrentResidentsForInput', variables];


useGetAllCurrentResidentsForInputQuery.fetcher = (client: GraphQLClient, variables?: GetAllCurrentResidentsForInputQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllCurrentResidentsForInputQuery, GetAllCurrentResidentsForInputQueryVariables>(client, GetAllCurrentResidentsForInputDocument, variables, headers);

export const GetAllResidentsForInputDocument = `
    query GetAllResidentsForInput {
  getAllResidents {
    ...ResidentBaseFragment
  }
}
    ${ResidentBaseFragmentFragmentDoc}`;

export const useGetAllResidentsForInputQuery = <
      TData = GetAllResidentsForInputQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllResidentsForInputQueryVariables,
      options?: Omit<UseQueryOptions<GetAllResidentsForInputQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllResidentsForInputQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllResidentsForInputQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllResidentsForInput'] : ['GetAllResidentsForInput', variables],
    queryFn: fetcher<GetAllResidentsForInputQuery, GetAllResidentsForInputQueryVariables>(client, GetAllResidentsForInputDocument, variables, headers),
    ...options
  }
    )};

useGetAllResidentsForInputQuery.document = GetAllResidentsForInputDocument;

useGetAllResidentsForInputQuery.getKey = (variables?: GetAllResidentsForInputQueryVariables) => variables === undefined ? ['GetAllResidentsForInput'] : ['GetAllResidentsForInput', variables];


useGetAllResidentsForInputQuery.fetcher = (client: GraphQLClient, variables?: GetAllResidentsForInputQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllResidentsForInputQuery, GetAllResidentsForInputQueryVariables>(client, GetAllResidentsForInputDocument, variables, headers);

export const GetResidentDocument = `
    query GetResident($id: ID!) {
  getResidentById(id: $id) {
    id
    personalNumber
    createdBy
    createdAt
    updatedAt
    accommodatedSince
    accommodatedUntil
    dateOfBirth
    conditions
    disabilityCertificate
    additionalInformation
    media {
      id
      extension
      fileName
      size
      isSharedToAuthorizedRelative
      uploadedBy
      firstDownloadByAuthorizedRelative {
        downloadedBy
        downloadedAt
        fileId
      }
    }
    contactPersons {
      id
      address {
        city
        country
        street
        zipCode
      }
      name {
        middleName
        lastName
        firstName
      }
      phoneNumber
      email
    }
    name {
      firstName
      lastName
      middleName
    }
    roomId
    avatar
    status
  }
}
    `;

export const useGetResidentQuery = <
      TData = GetResidentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetResidentQueryVariables,
      options?: Omit<UseQueryOptions<GetResidentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetResidentQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetResidentQuery, TError, TData>(
      {
    queryKey: ['GetResident', variables],
    queryFn: fetcher<GetResidentQuery, GetResidentQueryVariables>(client, GetResidentDocument, variables, headers),
    ...options
  }
    )};

useGetResidentQuery.document = GetResidentDocument;

useGetResidentQuery.getKey = (variables: GetResidentQueryVariables) => ['GetResident', variables];


useGetResidentQuery.fetcher = (client: GraphQLClient, variables: GetResidentQueryVariables, headers?: RequestInit['headers']) => fetcher<GetResidentQuery, GetResidentQueryVariables>(client, GetResidentDocument, variables, headers);

export const DownloadResidentMediaDocument = `
    query DownloadResidentMedia($input: DownloadMediaInput!) {
  downloadMedia(input: $input) {
    url
  }
}
    `;

export const useDownloadResidentMediaQuery = <
      TData = DownloadResidentMediaQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: DownloadResidentMediaQueryVariables,
      options?: Omit<UseQueryOptions<DownloadResidentMediaQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadResidentMediaQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<DownloadResidentMediaQuery, TError, TData>(
      {
    queryKey: ['DownloadResidentMedia', variables],
    queryFn: fetcher<DownloadResidentMediaQuery, DownloadResidentMediaQueryVariables>(client, DownloadResidentMediaDocument, variables, headers),
    ...options
  }
    )};

useDownloadResidentMediaQuery.document = DownloadResidentMediaDocument;

useDownloadResidentMediaQuery.getKey = (variables: DownloadResidentMediaQueryVariables) => ['DownloadResidentMedia', variables];


useDownloadResidentMediaQuery.fetcher = (client: GraphQLClient, variables: DownloadResidentMediaQueryVariables, headers?: RequestInit['headers']) => fetcher<DownloadResidentMediaQuery, DownloadResidentMediaQueryVariables>(client, DownloadResidentMediaDocument, variables, headers);

export const GetResidentInfoForAmbulanceDocument = `
    query GetResidentInfoForAmbulance($id: ID!) {
  getResidentInfoForAmbulance(id: $id) {
    id
    personalNumber
    name {
      firstName
      lastName
      middleName
    }
    dateOfBirth
    conditions
    contactPersonPhoneNumber
    contactPersonName {
      firstName
      lastName
      middleName
    }
    careFacilityPhoneNumber
    reportCreatedAt
    residentMedications {
      id
      medicationName
      startDate
      endDate
      notes
      treatmentType
      warnings
      schedule {
        daysOfWeek
        dosageDetails {
          timeType
          time
          timeOfDay
          dosage {
            unit
            quantity
          }
          customInstructions
          relationToFood
        }
      }
    }
    healthLogMeasurements {
      residentId
      updatedAt
      metricId
      values
      recordedAt
    }
    events {
      id
      date
      type
      eventSubType
      content
    }
  }
}
    `;

export const useGetResidentInfoForAmbulanceQuery = <
      TData = GetResidentInfoForAmbulanceQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetResidentInfoForAmbulanceQueryVariables,
      options?: Omit<UseQueryOptions<GetResidentInfoForAmbulanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetResidentInfoForAmbulanceQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetResidentInfoForAmbulanceQuery, TError, TData>(
      {
    queryKey: ['GetResidentInfoForAmbulance', variables],
    queryFn: fetcher<GetResidentInfoForAmbulanceQuery, GetResidentInfoForAmbulanceQueryVariables>(client, GetResidentInfoForAmbulanceDocument, variables, headers),
    ...options
  }
    )};

useGetResidentInfoForAmbulanceQuery.document = GetResidentInfoForAmbulanceDocument;

useGetResidentInfoForAmbulanceQuery.getKey = (variables: GetResidentInfoForAmbulanceQueryVariables) => ['GetResidentInfoForAmbulance', variables];


useGetResidentInfoForAmbulanceQuery.fetcher = (client: GraphQLClient, variables: GetResidentInfoForAmbulanceQueryVariables, headers?: RequestInit['headers']) => fetcher<GetResidentInfoForAmbulanceQuery, GetResidentInfoForAmbulanceQueryVariables>(client, GetResidentInfoForAmbulanceDocument, variables, headers);

export const GetAllMediaDownloadsForFileDocument = `
    query GetAllMediaDownloadsForFile($id: ID!) {
  getAllMediaDownloadsForFile(id: $id) {
    downloadedAt
    fileId
    downloadedBy
    isAuthorizedRelative
    pairingId
  }
}
    `;

export const useGetAllMediaDownloadsForFileQuery = <
      TData = GetAllMediaDownloadsForFileQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllMediaDownloadsForFileQueryVariables,
      options?: Omit<UseQueryOptions<GetAllMediaDownloadsForFileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllMediaDownloadsForFileQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllMediaDownloadsForFileQuery, TError, TData>(
      {
    queryKey: ['GetAllMediaDownloadsForFile', variables],
    queryFn: fetcher<GetAllMediaDownloadsForFileQuery, GetAllMediaDownloadsForFileQueryVariables>(client, GetAllMediaDownloadsForFileDocument, variables, headers),
    ...options
  }
    )};

useGetAllMediaDownloadsForFileQuery.document = GetAllMediaDownloadsForFileDocument;

useGetAllMediaDownloadsForFileQuery.getKey = (variables: GetAllMediaDownloadsForFileQueryVariables) => ['GetAllMediaDownloadsForFile', variables];


useGetAllMediaDownloadsForFileQuery.fetcher = (client: GraphQLClient, variables: GetAllMediaDownloadsForFileQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllMediaDownloadsForFileQuery, GetAllMediaDownloadsForFileQueryVariables>(client, GetAllMediaDownloadsForFileDocument, variables, headers);

export const UpdateResidentDocument = `
    mutation UpdateResident($input: UpdateResidentInput!) {
  updateResident(input: $input) {
    id
  }
}
    `;

export const useUpdateResidentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateResidentMutation, TError, UpdateResidentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateResidentMutation, TError, UpdateResidentMutationVariables, TContext>(
      {
    mutationKey: ['UpdateResident'],
    mutationFn: (variables?: UpdateResidentMutationVariables) => fetcher<UpdateResidentMutation, UpdateResidentMutationVariables>(client, UpdateResidentDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateResidentMutation.getKey = () => ['UpdateResident'];


useUpdateResidentMutation.fetcher = (client: GraphQLClient, variables: UpdateResidentMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateResidentMutation, UpdateResidentMutationVariables>(client, UpdateResidentDocument, variables, headers);

export const DeleteResidentDocument = `
    mutation DeleteResident($id: ID!) {
  deleteResident(id: $id) {
    id
  }
}
    `;

export const useDeleteResidentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteResidentMutation, TError, DeleteResidentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteResidentMutation, TError, DeleteResidentMutationVariables, TContext>(
      {
    mutationKey: ['DeleteResident'],
    mutationFn: (variables?: DeleteResidentMutationVariables) => fetcher<DeleteResidentMutation, DeleteResidentMutationVariables>(client, DeleteResidentDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteResidentMutation.getKey = () => ['DeleteResident'];


useDeleteResidentMutation.fetcher = (client: GraphQLClient, variables: DeleteResidentMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteResidentMutation, DeleteResidentMutationVariables>(client, DeleteResidentDocument, variables, headers);

export const DeactivateResidentDocument = `
    mutation DeactivateResident($id: ID!) {
  deactivateResident(id: $id) {
    id
  }
}
    `;

export const useDeactivateResidentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeactivateResidentMutation, TError, DeactivateResidentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeactivateResidentMutation, TError, DeactivateResidentMutationVariables, TContext>(
      {
    mutationKey: ['DeactivateResident'],
    mutationFn: (variables?: DeactivateResidentMutationVariables) => fetcher<DeactivateResidentMutation, DeactivateResidentMutationVariables>(client, DeactivateResidentDocument, variables, headers)(),
    ...options
  }
    )};

useDeactivateResidentMutation.getKey = () => ['DeactivateResident'];


useDeactivateResidentMutation.fetcher = (client: GraphQLClient, variables: DeactivateResidentMutationVariables, headers?: RequestInit['headers']) => fetcher<DeactivateResidentMutation, DeactivateResidentMutationVariables>(client, DeactivateResidentDocument, variables, headers);

export const AdmitResidentDocument = `
    mutation AdmitResident($input: AdmitResidentInput!) {
  admitResident(input: $input) {
    id
  }
}
    `;

export const useAdmitResidentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AdmitResidentMutation, TError, AdmitResidentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<AdmitResidentMutation, TError, AdmitResidentMutationVariables, TContext>(
      {
    mutationKey: ['AdmitResident'],
    mutationFn: (variables?: AdmitResidentMutationVariables) => fetcher<AdmitResidentMutation, AdmitResidentMutationVariables>(client, AdmitResidentDocument, variables, headers)(),
    ...options
  }
    )};

useAdmitResidentMutation.getKey = () => ['AdmitResident'];


useAdmitResidentMutation.fetcher = (client: GraphQLClient, variables: AdmitResidentMutationVariables, headers?: RequestInit['headers']) => fetcher<AdmitResidentMutation, AdmitResidentMutationVariables>(client, AdmitResidentDocument, variables, headers);

export const ReassignResidentRoomDocument = `
    mutation ReassignResidentRoom($input: ReassignResidentRoomInput!) {
  reassignResidentRoom(input: $input) {
    id
  }
}
    `;

export const useReassignResidentRoomMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReassignResidentRoomMutation, TError, ReassignResidentRoomMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ReassignResidentRoomMutation, TError, ReassignResidentRoomMutationVariables, TContext>(
      {
    mutationKey: ['ReassignResidentRoom'],
    mutationFn: (variables?: ReassignResidentRoomMutationVariables) => fetcher<ReassignResidentRoomMutation, ReassignResidentRoomMutationVariables>(client, ReassignResidentRoomDocument, variables, headers)(),
    ...options
  }
    )};

useReassignResidentRoomMutation.getKey = () => ['ReassignResidentRoom'];


useReassignResidentRoomMutation.fetcher = (client: GraphQLClient, variables: ReassignResidentRoomMutationVariables, headers?: RequestInit['headers']) => fetcher<ReassignResidentRoomMutation, ReassignResidentRoomMutationVariables>(client, ReassignResidentRoomDocument, variables, headers);

export const SaveResidentAvatarDocument = `
    mutation SaveResidentAvatar($input: SaveAvatarInput!) {
  saveResidentAvatar(input: $input) {
    url
  }
}
    `;

export const useSaveResidentAvatarMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SaveResidentAvatarMutation, TError, SaveResidentAvatarMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SaveResidentAvatarMutation, TError, SaveResidentAvatarMutationVariables, TContext>(
      {
    mutationKey: ['SaveResidentAvatar'],
    mutationFn: (variables?: SaveResidentAvatarMutationVariables) => fetcher<SaveResidentAvatarMutation, SaveResidentAvatarMutationVariables>(client, SaveResidentAvatarDocument, variables, headers)(),
    ...options
  }
    )};

useSaveResidentAvatarMutation.getKey = () => ['SaveResidentAvatar'];


useSaveResidentAvatarMutation.fetcher = (client: GraphQLClient, variables: SaveResidentAvatarMutationVariables, headers?: RequestInit['headers']) => fetcher<SaveResidentAvatarMutation, SaveResidentAvatarMutationVariables>(client, SaveResidentAvatarDocument, variables, headers);

export const DeleteResidentAvatarDocument = `
    mutation DeleteResidentAvatar($id: ID!) {
  deleteResidentAvatar(id: $id) {
    id
  }
}
    `;

export const useDeleteResidentAvatarMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteResidentAvatarMutation, TError, DeleteResidentAvatarMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteResidentAvatarMutation, TError, DeleteResidentAvatarMutationVariables, TContext>(
      {
    mutationKey: ['DeleteResidentAvatar'],
    mutationFn: (variables?: DeleteResidentAvatarMutationVariables) => fetcher<DeleteResidentAvatarMutation, DeleteResidentAvatarMutationVariables>(client, DeleteResidentAvatarDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteResidentAvatarMutation.getKey = () => ['DeleteResidentAvatar'];


useDeleteResidentAvatarMutation.fetcher = (client: GraphQLClient, variables: DeleteResidentAvatarMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteResidentAvatarMutation, DeleteResidentAvatarMutationVariables>(client, DeleteResidentAvatarDocument, variables, headers);

export const CreateResidentDocument = `
    mutation CreateResident($input: CreateResidentInput!) {
  createResident(input: $input) {
    id
  }
}
    `;

export const useCreateResidentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateResidentMutation, TError, CreateResidentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateResidentMutation, TError, CreateResidentMutationVariables, TContext>(
      {
    mutationKey: ['CreateResident'],
    mutationFn: (variables?: CreateResidentMutationVariables) => fetcher<CreateResidentMutation, CreateResidentMutationVariables>(client, CreateResidentDocument, variables, headers)(),
    ...options
  }
    )};

useCreateResidentMutation.getKey = () => ['CreateResident'];


useCreateResidentMutation.fetcher = (client: GraphQLClient, variables: CreateResidentMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateResidentMutation, CreateResidentMutationVariables>(client, CreateResidentDocument, variables, headers);

export const MarkResidentAsAbsentDocument = `
    mutation MarkResidentAsAbsent($input: MarkResidentAsAbsentInput!) {
  markResidentAsAbsent(input: $input) {
    id
  }
}
    `;

export const useMarkResidentAsAbsentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MarkResidentAsAbsentMutation, TError, MarkResidentAsAbsentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<MarkResidentAsAbsentMutation, TError, MarkResidentAsAbsentMutationVariables, TContext>(
      {
    mutationKey: ['MarkResidentAsAbsent'],
    mutationFn: (variables?: MarkResidentAsAbsentMutationVariables) => fetcher<MarkResidentAsAbsentMutation, MarkResidentAsAbsentMutationVariables>(client, MarkResidentAsAbsentDocument, variables, headers)(),
    ...options
  }
    )};

useMarkResidentAsAbsentMutation.getKey = () => ['MarkResidentAsAbsent'];


useMarkResidentAsAbsentMutation.fetcher = (client: GraphQLClient, variables: MarkResidentAsAbsentMutationVariables, headers?: RequestInit['headers']) => fetcher<MarkResidentAsAbsentMutation, MarkResidentAsAbsentMutationVariables>(client, MarkResidentAsAbsentDocument, variables, headers);

export const UnmarkResidentAsAbsentDocument = `
    mutation UnmarkResidentAsAbsent($input: MarkResidentAsAbsentInput!) {
  unmarkResidentAsAbsent(input: $input) {
    id
  }
}
    `;

export const useUnmarkResidentAsAbsentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UnmarkResidentAsAbsentMutation, TError, UnmarkResidentAsAbsentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UnmarkResidentAsAbsentMutation, TError, UnmarkResidentAsAbsentMutationVariables, TContext>(
      {
    mutationKey: ['UnmarkResidentAsAbsent'],
    mutationFn: (variables?: UnmarkResidentAsAbsentMutationVariables) => fetcher<UnmarkResidentAsAbsentMutation, UnmarkResidentAsAbsentMutationVariables>(client, UnmarkResidentAsAbsentDocument, variables, headers)(),
    ...options
  }
    )};

useUnmarkResidentAsAbsentMutation.getKey = () => ['UnmarkResidentAsAbsent'];


useUnmarkResidentAsAbsentMutation.fetcher = (client: GraphQLClient, variables: UnmarkResidentAsAbsentMutationVariables, headers?: RequestInit['headers']) => fetcher<UnmarkResidentAsAbsentMutation, UnmarkResidentAsAbsentMutationVariables>(client, UnmarkResidentAsAbsentDocument, variables, headers);

export const SaveResidentMediaDocument = `
    mutation SaveResidentMedia($input: SaveResidentMediaInput!) {
  saveResidentMedia(input: $input) {
    url
  }
}
    `;

export const useSaveResidentMediaMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SaveResidentMediaMutation, TError, SaveResidentMediaMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SaveResidentMediaMutation, TError, SaveResidentMediaMutationVariables, TContext>(
      {
    mutationKey: ['SaveResidentMedia'],
    mutationFn: (variables?: SaveResidentMediaMutationVariables) => fetcher<SaveResidentMediaMutation, SaveResidentMediaMutationVariables>(client, SaveResidentMediaDocument, variables, headers)(),
    ...options
  }
    )};

useSaveResidentMediaMutation.getKey = () => ['SaveResidentMedia'];


useSaveResidentMediaMutation.fetcher = (client: GraphQLClient, variables: SaveResidentMediaMutationVariables, headers?: RequestInit['headers']) => fetcher<SaveResidentMediaMutation, SaveResidentMediaMutationVariables>(client, SaveResidentMediaDocument, variables, headers);

export const DeleteResidentMediaDocument = `
    mutation DeleteResidentMedia($input: DeleteResidentMediaInput!) {
  deleteResidentMedia(input: $input) {
    size
    fileName
    extension
    id
    isSharedToAuthorizedRelative
  }
}
    `;

export const useDeleteResidentMediaMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteResidentMediaMutation, TError, DeleteResidentMediaMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteResidentMediaMutation, TError, DeleteResidentMediaMutationVariables, TContext>(
      {
    mutationKey: ['DeleteResidentMedia'],
    mutationFn: (variables?: DeleteResidentMediaMutationVariables) => fetcher<DeleteResidentMediaMutation, DeleteResidentMediaMutationVariables>(client, DeleteResidentMediaDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteResidentMediaMutation.getKey = () => ['DeleteResidentMedia'];


useDeleteResidentMediaMutation.fetcher = (client: GraphQLClient, variables: DeleteResidentMediaMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteResidentMediaMutation, DeleteResidentMediaMutationVariables>(client, DeleteResidentMediaDocument, variables, headers);

export const ShareResidentMediaWithAuthorizedRelativeDocument = `
    mutation ShareResidentMediaWithAuthorizedRelative($input: ShareResidentMediaWithAuthorizedRelativeInput!) {
  shareResidentMediaWithAuthorizedRelative(input: $input) {
    id
    fileName
    extension
    size
    uploadedBy
    isSharedToAuthorizedRelative
  }
}
    `;

export const useShareResidentMediaWithAuthorizedRelativeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ShareResidentMediaWithAuthorizedRelativeMutation, TError, ShareResidentMediaWithAuthorizedRelativeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ShareResidentMediaWithAuthorizedRelativeMutation, TError, ShareResidentMediaWithAuthorizedRelativeMutationVariables, TContext>(
      {
    mutationKey: ['ShareResidentMediaWithAuthorizedRelative'],
    mutationFn: (variables?: ShareResidentMediaWithAuthorizedRelativeMutationVariables) => fetcher<ShareResidentMediaWithAuthorizedRelativeMutation, ShareResidentMediaWithAuthorizedRelativeMutationVariables>(client, ShareResidentMediaWithAuthorizedRelativeDocument, variables, headers)(),
    ...options
  }
    )};

useShareResidentMediaWithAuthorizedRelativeMutation.getKey = () => ['ShareResidentMediaWithAuthorizedRelative'];


useShareResidentMediaWithAuthorizedRelativeMutation.fetcher = (client: GraphQLClient, variables: ShareResidentMediaWithAuthorizedRelativeMutationVariables, headers?: RequestInit['headers']) => fetcher<ShareResidentMediaWithAuthorizedRelativeMutation, ShareResidentMediaWithAuthorizedRelativeMutationVariables>(client, ShareResidentMediaWithAuthorizedRelativeDocument, variables, headers);

export const GetRoomsDocument = `
    query GetRooms {
  getRooms {
    id
    roomNumber
    residents
    floor
    capacity
    building
    createdBy
  }
}
    `;

export const useGetRoomsQuery = <
      TData = GetRoomsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetRoomsQueryVariables,
      options?: Omit<UseQueryOptions<GetRoomsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRoomsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRoomsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetRooms'] : ['GetRooms', variables],
    queryFn: fetcher<GetRoomsQuery, GetRoomsQueryVariables>(client, GetRoomsDocument, variables, headers),
    ...options
  }
    )};

useGetRoomsQuery.document = GetRoomsDocument;

useGetRoomsQuery.getKey = (variables?: GetRoomsQueryVariables) => variables === undefined ? ['GetRooms'] : ['GetRooms', variables];


useGetRoomsQuery.fetcher = (client: GraphQLClient, variables?: GetRoomsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRoomsQuery, GetRoomsQueryVariables>(client, GetRoomsDocument, variables, headers);

export const GetRoomByIdDocument = `
    query GetRoomById($id: ID!) {
  getRoomById(id: $id) {
    id
    roomNumber
    building
    capacity
    floor
    residents
  }
}
    `;

export const useGetRoomByIdQuery = <
      TData = GetRoomByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRoomByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetRoomByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRoomByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRoomByIdQuery, TError, TData>(
      {
    queryKey: ['GetRoomById', variables],
    queryFn: fetcher<GetRoomByIdQuery, GetRoomByIdQueryVariables>(client, GetRoomByIdDocument, variables, headers),
    ...options
  }
    )};

useGetRoomByIdQuery.document = GetRoomByIdDocument;

useGetRoomByIdQuery.getKey = (variables: GetRoomByIdQueryVariables) => ['GetRoomById', variables];


useGetRoomByIdQuery.fetcher = (client: GraphQLClient, variables: GetRoomByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRoomByIdQuery, GetRoomByIdQueryVariables>(client, GetRoomByIdDocument, variables, headers);

export const CreateRoomDocument = `
    mutation CreateRoom($input: CreateRoomInput!) {
  createRoom(input: $input) {
    roomNumber
    id
  }
}
    `;

export const useCreateRoomMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateRoomMutation, TError, CreateRoomMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateRoomMutation, TError, CreateRoomMutationVariables, TContext>(
      {
    mutationKey: ['CreateRoom'],
    mutationFn: (variables?: CreateRoomMutationVariables) => fetcher<CreateRoomMutation, CreateRoomMutationVariables>(client, CreateRoomDocument, variables, headers)(),
    ...options
  }
    )};

useCreateRoomMutation.getKey = () => ['CreateRoom'];


useCreateRoomMutation.fetcher = (client: GraphQLClient, variables: CreateRoomMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateRoomMutation, CreateRoomMutationVariables>(client, CreateRoomDocument, variables, headers);

export const UpdateRoomDocument = `
    mutation UpdateRoom($input: UpdateRoomInput!) {
  updateRoom(input: $input) {
    roomNumber
    id
  }
}
    `;

export const useUpdateRoomMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateRoomMutation, TError, UpdateRoomMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateRoomMutation, TError, UpdateRoomMutationVariables, TContext>(
      {
    mutationKey: ['UpdateRoom'],
    mutationFn: (variables?: UpdateRoomMutationVariables) => fetcher<UpdateRoomMutation, UpdateRoomMutationVariables>(client, UpdateRoomDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateRoomMutation.getKey = () => ['UpdateRoom'];


useUpdateRoomMutation.fetcher = (client: GraphQLClient, variables: UpdateRoomMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateRoomMutation, UpdateRoomMutationVariables>(client, UpdateRoomDocument, variables, headers);

export const DeleteRoomDocument = `
    mutation DeleteRoom($id: ID!) {
  deleteRoom(id: $id) {
    roomNumber
    id
  }
}
    `;

export const useDeleteRoomMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteRoomMutation, TError, DeleteRoomMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteRoomMutation, TError, DeleteRoomMutationVariables, TContext>(
      {
    mutationKey: ['DeleteRoom'],
    mutationFn: (variables?: DeleteRoomMutationVariables) => fetcher<DeleteRoomMutation, DeleteRoomMutationVariables>(client, DeleteRoomDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteRoomMutation.getKey = () => ['DeleteRoom'];


useDeleteRoomMutation.fetcher = (client: GraphQLClient, variables: DeleteRoomMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteRoomMutation, DeleteRoomMutationVariables>(client, DeleteRoomDocument, variables, headers);

export const GetTasksWithDateRangeDocument = `
    query GetTasksWithDateRange($input: GetTasksWithDateRangeInput) {
  getTasksWithDateRange(input: $input) {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
  }
}
    `;

export const useGetTasksWithDateRangeQuery = <
      TData = GetTasksWithDateRangeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetTasksWithDateRangeQueryVariables,
      options?: Omit<UseQueryOptions<GetTasksWithDateRangeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTasksWithDateRangeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetTasksWithDateRangeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetTasksWithDateRange'] : ['GetTasksWithDateRange', variables],
    queryFn: fetcher<GetTasksWithDateRangeQuery, GetTasksWithDateRangeQueryVariables>(client, GetTasksWithDateRangeDocument, variables, headers),
    ...options
  }
    )};

useGetTasksWithDateRangeQuery.document = GetTasksWithDateRangeDocument;

useGetTasksWithDateRangeQuery.getKey = (variables?: GetTasksWithDateRangeQueryVariables) => variables === undefined ? ['GetTasksWithDateRange'] : ['GetTasksWithDateRange', variables];


useGetTasksWithDateRangeQuery.fetcher = (client: GraphQLClient, variables?: GetTasksWithDateRangeQueryVariables, headers?: RequestInit['headers']) => fetcher<GetTasksWithDateRangeQuery, GetTasksWithDateRangeQueryVariables>(client, GetTasksWithDateRangeDocument, variables, headers);

export const GetTaskDocument = `
    query GetTask($id: ID!) {
  getTask(id: $id) {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
  }
}
    `;

export const useGetTaskQuery = <
      TData = GetTaskQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTaskQueryVariables,
      options?: Omit<UseQueryOptions<GetTaskQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTaskQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetTaskQuery, TError, TData>(
      {
    queryKey: ['GetTask', variables],
    queryFn: fetcher<GetTaskQuery, GetTaskQueryVariables>(client, GetTaskDocument, variables, headers),
    ...options
  }
    )};

useGetTaskQuery.document = GetTaskDocument;

useGetTaskQuery.getKey = (variables: GetTaskQueryVariables) => ['GetTask', variables];


useGetTaskQuery.fetcher = (client: GraphQLClient, variables: GetTaskQueryVariables, headers?: RequestInit['headers']) => fetcher<GetTaskQuery, GetTaskQueryVariables>(client, GetTaskDocument, variables, headers);

export const GetTasksForWorkingDayDocument = `
    query GetTasksForWorkingDay {
  getTasksForWorkingDay {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
  }
}
    `;

export const useGetTasksForWorkingDayQuery = <
      TData = GetTasksForWorkingDayQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetTasksForWorkingDayQueryVariables,
      options?: Omit<UseQueryOptions<GetTasksForWorkingDayQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTasksForWorkingDayQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetTasksForWorkingDayQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetTasksForWorkingDay'] : ['GetTasksForWorkingDay', variables],
    queryFn: fetcher<GetTasksForWorkingDayQuery, GetTasksForWorkingDayQueryVariables>(client, GetTasksForWorkingDayDocument, variables, headers),
    ...options
  }
    )};

useGetTasksForWorkingDayQuery.document = GetTasksForWorkingDayDocument;

useGetTasksForWorkingDayQuery.getKey = (variables?: GetTasksForWorkingDayQueryVariables) => variables === undefined ? ['GetTasksForWorkingDay'] : ['GetTasksForWorkingDay', variables];


useGetTasksForWorkingDayQuery.fetcher = (client: GraphQLClient, variables?: GetTasksForWorkingDayQueryVariables, headers?: RequestInit['headers']) => fetcher<GetTasksForWorkingDayQuery, GetTasksForWorkingDayQueryVariables>(client, GetTasksForWorkingDayDocument, variables, headers);

export const CreateTaskDocument = `
    mutation CreateTask($input: CreateTaskInput!) {
  createTask(input: $input) {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
    isLimitedToJobRoles
  }
}
    `;

export const useCreateTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateTaskMutation, TError, CreateTaskMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateTaskMutation, TError, CreateTaskMutationVariables, TContext>(
      {
    mutationKey: ['CreateTask'],
    mutationFn: (variables?: CreateTaskMutationVariables) => fetcher<CreateTaskMutation, CreateTaskMutationVariables>(client, CreateTaskDocument, variables, headers)(),
    ...options
  }
    )};

useCreateTaskMutation.getKey = () => ['CreateTask'];


useCreateTaskMutation.fetcher = (client: GraphQLClient, variables: CreateTaskMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateTaskMutation, CreateTaskMutationVariables>(client, CreateTaskDocument, variables, headers);

export const UpdateTaskDocument = `
    mutation UpdateTask($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
    isLimitedToJobRoles
  }
}
    `;

export const useUpdateTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateTaskMutation, TError, UpdateTaskMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateTaskMutation, TError, UpdateTaskMutationVariables, TContext>(
      {
    mutationKey: ['UpdateTask'],
    mutationFn: (variables?: UpdateTaskMutationVariables) => fetcher<UpdateTaskMutation, UpdateTaskMutationVariables>(client, UpdateTaskDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateTaskMutation.getKey = () => ['UpdateTask'];


useUpdateTaskMutation.fetcher = (client: GraphQLClient, variables: UpdateTaskMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateTaskMutation, UpdateTaskMutationVariables>(client, UpdateTaskDocument, variables, headers);

export const CompleteTaskDocument = `
    mutation CompleteTask($input: CompleteTaskInput!) {
  completeTask(input: $input) {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
    isLimitedToJobRoles
  }
}
    `;

export const useCompleteTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CompleteTaskMutation, TError, CompleteTaskMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CompleteTaskMutation, TError, CompleteTaskMutationVariables, TContext>(
      {
    mutationKey: ['CompleteTask'],
    mutationFn: (variables?: CompleteTaskMutationVariables) => fetcher<CompleteTaskMutation, CompleteTaskMutationVariables>(client, CompleteTaskDocument, variables, headers)(),
    ...options
  }
    )};

useCompleteTaskMutation.getKey = () => ['CompleteTask'];


useCompleteTaskMutation.fetcher = (client: GraphQLClient, variables: CompleteTaskMutationVariables, headers?: RequestInit['headers']) => fetcher<CompleteTaskMutation, CompleteTaskMutationVariables>(client, CompleteTaskDocument, variables, headers);

export const UncompleteTaskDocument = `
    mutation UncompleteTask($id: ID!) {
  uncompleteTask(id: $id) {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
    isLimitedToJobRoles
  }
}
    `;

export const useUncompleteTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UncompleteTaskMutation, TError, UncompleteTaskMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UncompleteTaskMutation, TError, UncompleteTaskMutationVariables, TContext>(
      {
    mutationKey: ['UncompleteTask'],
    mutationFn: (variables?: UncompleteTaskMutationVariables) => fetcher<UncompleteTaskMutation, UncompleteTaskMutationVariables>(client, UncompleteTaskDocument, variables, headers)(),
    ...options
  }
    )};

useUncompleteTaskMutation.getKey = () => ['UncompleteTask'];


useUncompleteTaskMutation.fetcher = (client: GraphQLClient, variables: UncompleteTaskMutationVariables, headers?: RequestInit['headers']) => fetcher<UncompleteTaskMutation, UncompleteTaskMutationVariables>(client, UncompleteTaskDocument, variables, headers);

export const RejectTaskDocument = `
    mutation RejectTask($input: RejectTaskInput!) {
  rejectTask(input: $input) {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
    isLimitedToJobRoles
  }
}
    `;

export const useRejectTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RejectTaskMutation, TError, RejectTaskMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<RejectTaskMutation, TError, RejectTaskMutationVariables, TContext>(
      {
    mutationKey: ['RejectTask'],
    mutationFn: (variables?: RejectTaskMutationVariables) => fetcher<RejectTaskMutation, RejectTaskMutationVariables>(client, RejectTaskDocument, variables, headers)(),
    ...options
  }
    )};

useRejectTaskMutation.getKey = () => ['RejectTask'];


useRejectTaskMutation.fetcher = (client: GraphQLClient, variables: RejectTaskMutationVariables, headers?: RequestInit['headers']) => fetcher<RejectTaskMutation, RejectTaskMutationVariables>(client, RejectTaskDocument, variables, headers);

export const DeleteTaskDocument = `
    mutation DeleteTask($id: ID!) {
  deleteTask(id: $id) {
    id
    jobRoleIds
    isLimitedToJobRoles
  }
}
    `;

export const useDeleteTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteTaskMutation, TError, DeleteTaskMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteTaskMutation, TError, DeleteTaskMutationVariables, TContext>(
      {
    mutationKey: ['DeleteTask'],
    mutationFn: (variables?: DeleteTaskMutationVariables) => fetcher<DeleteTaskMutation, DeleteTaskMutationVariables>(client, DeleteTaskDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteTaskMutation.getKey = () => ['DeleteTask'];


useDeleteTaskMutation.fetcher = (client: GraphQLClient, variables: DeleteTaskMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteTaskMutation, DeleteTaskMutationVariables>(client, DeleteTaskDocument, variables, headers);

export const DownloadResidentTaskArchiveDocument = `
    query DownloadResidentTaskArchive($input: DownloadResidentTaskArchiveInput!) {
  downloadResidentTaskArchive(input: $input) {
    url
    fileName
    numberOfMonths
  }
}
    `;

export const useDownloadResidentTaskArchiveQuery = <
      TData = DownloadResidentTaskArchiveQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: DownloadResidentTaskArchiveQueryVariables,
      options?: Omit<UseQueryOptions<DownloadResidentTaskArchiveQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadResidentTaskArchiveQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<DownloadResidentTaskArchiveQuery, TError, TData>(
      {
    queryKey: ['DownloadResidentTaskArchive', variables],
    queryFn: fetcher<DownloadResidentTaskArchiveQuery, DownloadResidentTaskArchiveQueryVariables>(client, DownloadResidentTaskArchiveDocument, variables, headers),
    ...options
  }
    )};

useDownloadResidentTaskArchiveQuery.document = DownloadResidentTaskArchiveDocument;

useDownloadResidentTaskArchiveQuery.getKey = (variables: DownloadResidentTaskArchiveQueryVariables) => ['DownloadResidentTaskArchive', variables];


useDownloadResidentTaskArchiveQuery.fetcher = (client: GraphQLClient, variables: DownloadResidentTaskArchiveQueryVariables, headers?: RequestInit['headers']) => fetcher<DownloadResidentTaskArchiveQuery, DownloadResidentTaskArchiveQueryVariables>(client, DownloadResidentTaskArchiveDocument, variables, headers);

export const OnCreateTaskDocument = `
    subscription OnCreateTask {
  onCreateTask {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
  }
}
    `;
export const OnCreateTasksDocument = `
    subscription OnCreateTasks {
  onCreateTasks {
    jobRoleIds
    tasks {
      id
      title
      content
      date
      createdAt
      completedAt
      completedBy
      completeUntil {
        time
        partOfTheDay
      }
      assignedToEmployee
      assignedToResident
      parentRecurringTaskId
      rejectionNote
      comment
      jobRoleIds
    }
  }
}
    `;
export const OnUpdateTaskDocument = `
    subscription OnUpdateTask {
  onUpdateTask {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
  }
}
    `;
export const OnCompleteTaskDocument = `
    subscription OnCompleteTask {
  onCompleteTask {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
  }
}
    `;
export const OnUnCompleteTaskDocument = `
    subscription OnUnCompleteTask {
  onUncompleteTask {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
  }
}
    `;
export const OnRejectTaskDocument = `
    subscription OnRejectTask {
  onRejectTask {
    id
    title
    content
    date
    createdAt
    completedAt
    completedBy
    completeUntil {
      time
      partOfTheDay
    }
    assignedToEmployee
    assignedToResident
    parentRecurringTaskId
    rejectionNote
    comment
    jobRoleIds
  }
}
    `;
export const OnDeleteTaskDocument = `
    subscription OnDeleteTask {
  onDeleteTask {
    id
    jobRoleIds
  }
}
    `;
export const GetMyUserInfoDocument = `
    query GetMyUserInfo {
  getMyUserInfo {
    id
    userName
    name {
      firstName
      middleName
      lastName
    }
    personalNumber
    group
    avatar
    approvedConditions {
      termsAndConditions {
        approvedAt
      }
      globalTermsAndConditions {
        approvedAt
      }
      globalPrivacyPolicy {
        approvedAt
      }
    }
  }
}
    `;

export const useGetMyUserInfoQuery = <
      TData = GetMyUserInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMyUserInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetMyUserInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMyUserInfoQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMyUserInfoQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetMyUserInfo'] : ['GetMyUserInfo', variables],
    queryFn: fetcher<GetMyUserInfoQuery, GetMyUserInfoQueryVariables>(client, GetMyUserInfoDocument, variables, headers),
    ...options
  }
    )};

useGetMyUserInfoQuery.document = GetMyUserInfoDocument;

useGetMyUserInfoQuery.getKey = (variables?: GetMyUserInfoQueryVariables) => variables === undefined ? ['GetMyUserInfo'] : ['GetMyUserInfo', variables];


useGetMyUserInfoQuery.fetcher = (client: GraphQLClient, variables?: GetMyUserInfoQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMyUserInfoQuery, GetMyUserInfoQueryVariables>(client, GetMyUserInfoDocument, variables, headers);

export const GetAllUsersForInputDocument = `
    query GetAllUsersForInput {
  getAllUsers {
    id
    userName
    name {
      firstName
      middleName
      lastName
    }
    personalNumber
    group
    avatar
  }
}
    `;

export const useGetAllUsersForInputQuery = <
      TData = GetAllUsersForInputQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllUsersForInputQueryVariables,
      options?: Omit<UseQueryOptions<GetAllUsersForInputQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllUsersForInputQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllUsersForInputQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllUsersForInput'] : ['GetAllUsersForInput', variables],
    queryFn: fetcher<GetAllUsersForInputQuery, GetAllUsersForInputQueryVariables>(client, GetAllUsersForInputDocument, variables, headers),
    ...options
  }
    )};

useGetAllUsersForInputQuery.document = GetAllUsersForInputDocument;

useGetAllUsersForInputQuery.getKey = (variables?: GetAllUsersForInputQueryVariables) => variables === undefined ? ['GetAllUsersForInput'] : ['GetAllUsersForInput', variables];


useGetAllUsersForInputQuery.fetcher = (client: GraphQLClient, variables?: GetAllUsersForInputQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllUsersForInputQuery, GetAllUsersForInputQueryVariables>(client, GetAllUsersForInputDocument, variables, headers);

export const GetAllUsersDocument = `
    query GetAllUsers {
  getAllUsers {
    id
    userName
    name {
      firstName
      middleName
      lastName
    }
    personalNumber
    group
    avatar
    jobRoleId
  }
}
    `;

export const useGetAllUsersQuery = <
      TData = GetAllUsersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllUsersQueryVariables,
      options?: Omit<UseQueryOptions<GetAllUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllUsersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllUsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllUsers'] : ['GetAllUsers', variables],
    queryFn: fetcher<GetAllUsersQuery, GetAllUsersQueryVariables>(client, GetAllUsersDocument, variables, headers),
    ...options
  }
    )};

useGetAllUsersQuery.document = GetAllUsersDocument;

useGetAllUsersQuery.getKey = (variables?: GetAllUsersQueryVariables) => variables === undefined ? ['GetAllUsers'] : ['GetAllUsers', variables];


useGetAllUsersQuery.fetcher = (client: GraphQLClient, variables?: GetAllUsersQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllUsersQuery, GetAllUsersQueryVariables>(client, GetAllUsersDocument, variables, headers);

export const GetUserByUserNameDocument = `
    query GetUserByUserName($userName: String!) {
  getUserByUserName(userName: $userName) {
    id
    userName
    name {
      firstName
      middleName
      lastName
    }
    personalNumber
    group
    avatar
    jobRoleId
  }
}
    `;

export const useGetUserByUserNameQuery = <
      TData = GetUserByUserNameQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserByUserNameQueryVariables,
      options?: Omit<UseQueryOptions<GetUserByUserNameQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserByUserNameQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserByUserNameQuery, TError, TData>(
      {
    queryKey: ['GetUserByUserName', variables],
    queryFn: fetcher<GetUserByUserNameQuery, GetUserByUserNameQueryVariables>(client, GetUserByUserNameDocument, variables, headers),
    ...options
  }
    )};

useGetUserByUserNameQuery.document = GetUserByUserNameDocument;

useGetUserByUserNameQuery.getKey = (variables: GetUserByUserNameQueryVariables) => ['GetUserByUserName', variables];


useGetUserByUserNameQuery.fetcher = (client: GraphQLClient, variables: GetUserByUserNameQueryVariables, headers?: RequestInit['headers']) => fetcher<GetUserByUserNameQuery, GetUserByUserNameQueryVariables>(client, GetUserByUserNameDocument, variables, headers);

export const CreateUserDocument = `
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
    userName
  }
}
    `;

export const useCreateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateUserMutation, TError, CreateUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateUserMutation, TError, CreateUserMutationVariables, TContext>(
      {
    mutationKey: ['CreateUser'],
    mutationFn: (variables?: CreateUserMutationVariables) => fetcher<CreateUserMutation, CreateUserMutationVariables>(client, CreateUserDocument, variables, headers)(),
    ...options
  }
    )};

useCreateUserMutation.getKey = () => ['CreateUser'];


useCreateUserMutation.fetcher = (client: GraphQLClient, variables: CreateUserMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateUserMutation, CreateUserMutationVariables>(client, CreateUserDocument, variables, headers);

export const UpdateUserDocument = `
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    userName
  }
}
    `;

export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUser'],
    mutationFn: (variables?: UpdateUserMutationVariables) => fetcher<UpdateUserMutation, UpdateUserMutationVariables>(client, UpdateUserDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateUserMutation.getKey = () => ['UpdateUser'];


useUpdateUserMutation.fetcher = (client: GraphQLClient, variables: UpdateUserMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateUserMutation, UpdateUserMutationVariables>(client, UpdateUserDocument, variables, headers);

export const UserApproveConditionsDocument = `
    mutation UserApproveConditions($input: UserApproveConditionsInput) {
  userApproveConditions(input: $input) {
    id
    userName
    approvedConditions {
      termsAndConditions {
        approvedAt
      }
      globalTermsAndConditions {
        approvedAt
      }
      globalPrivacyPolicy {
        approvedAt
      }
    }
  }
}
    `;

export const useUserApproveConditionsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UserApproveConditionsMutation, TError, UserApproveConditionsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UserApproveConditionsMutation, TError, UserApproveConditionsMutationVariables, TContext>(
      {
    mutationKey: ['UserApproveConditions'],
    mutationFn: (variables?: UserApproveConditionsMutationVariables) => fetcher<UserApproveConditionsMutation, UserApproveConditionsMutationVariables>(client, UserApproveConditionsDocument, variables, headers)(),
    ...options
  }
    )};

useUserApproveConditionsMutation.getKey = () => ['UserApproveConditions'];


useUserApproveConditionsMutation.fetcher = (client: GraphQLClient, variables?: UserApproveConditionsMutationVariables, headers?: RequestInit['headers']) => fetcher<UserApproveConditionsMutation, UserApproveConditionsMutationVariables>(client, UserApproveConditionsDocument, variables, headers);

export const ApproveGlobalPrivacyPolicyDocument = `
    mutation ApproveGlobalPrivacyPolicy {
  approveGlobalPrivacyPolicy
}
    `;

export const useApproveGlobalPrivacyPolicyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApproveGlobalPrivacyPolicyMutation, TError, ApproveGlobalPrivacyPolicyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ApproveGlobalPrivacyPolicyMutation, TError, ApproveGlobalPrivacyPolicyMutationVariables, TContext>(
      {
    mutationKey: ['ApproveGlobalPrivacyPolicy'],
    mutationFn: (variables?: ApproveGlobalPrivacyPolicyMutationVariables) => fetcher<ApproveGlobalPrivacyPolicyMutation, ApproveGlobalPrivacyPolicyMutationVariables>(client, ApproveGlobalPrivacyPolicyDocument, variables, headers)(),
    ...options
  }
    )};

useApproveGlobalPrivacyPolicyMutation.getKey = () => ['ApproveGlobalPrivacyPolicy'];


useApproveGlobalPrivacyPolicyMutation.fetcher = (client: GraphQLClient, variables?: ApproveGlobalPrivacyPolicyMutationVariables, headers?: RequestInit['headers']) => fetcher<ApproveGlobalPrivacyPolicyMutation, ApproveGlobalPrivacyPolicyMutationVariables>(client, ApproveGlobalPrivacyPolicyDocument, variables, headers);

export const ApproveGlobalTermsAndConditionsDocument = `
    mutation ApproveGlobalTermsAndConditions {
  approveGlobalTermsAndConditions
}
    `;

export const useApproveGlobalTermsAndConditionsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApproveGlobalTermsAndConditionsMutation, TError, ApproveGlobalTermsAndConditionsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ApproveGlobalTermsAndConditionsMutation, TError, ApproveGlobalTermsAndConditionsMutationVariables, TContext>(
      {
    mutationKey: ['ApproveGlobalTermsAndConditions'],
    mutationFn: (variables?: ApproveGlobalTermsAndConditionsMutationVariables) => fetcher<ApproveGlobalTermsAndConditionsMutation, ApproveGlobalTermsAndConditionsMutationVariables>(client, ApproveGlobalTermsAndConditionsDocument, variables, headers)(),
    ...options
  }
    )};

useApproveGlobalTermsAndConditionsMutation.getKey = () => ['ApproveGlobalTermsAndConditions'];


useApproveGlobalTermsAndConditionsMutation.fetcher = (client: GraphQLClient, variables?: ApproveGlobalTermsAndConditionsMutationVariables, headers?: RequestInit['headers']) => fetcher<ApproveGlobalTermsAndConditionsMutation, ApproveGlobalTermsAndConditionsMutationVariables>(client, ApproveGlobalTermsAndConditionsDocument, variables, headers);

export const GetGlobalApprovalStatusDocument = `
    query GetGlobalApprovalStatus {
  getGlobalApprovalStatus {
    globalTermsAndConditions
    globalPrivacyPolicy
  }
}
    `;

export const useGetGlobalApprovalStatusQuery = <
      TData = GetGlobalApprovalStatusQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetGlobalApprovalStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetGlobalApprovalStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGlobalApprovalStatusQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetGlobalApprovalStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetGlobalApprovalStatus'] : ['GetGlobalApprovalStatus', variables],
    queryFn: fetcher<GetGlobalApprovalStatusQuery, GetGlobalApprovalStatusQueryVariables>(client, GetGlobalApprovalStatusDocument, variables, headers),
    ...options
  }
    )};

useGetGlobalApprovalStatusQuery.document = GetGlobalApprovalStatusDocument;

useGetGlobalApprovalStatusQuery.getKey = (variables?: GetGlobalApprovalStatusQueryVariables) => variables === undefined ? ['GetGlobalApprovalStatus'] : ['GetGlobalApprovalStatus', variables];


useGetGlobalApprovalStatusQuery.fetcher = (client: GraphQLClient, variables?: GetGlobalApprovalStatusQueryVariables, headers?: RequestInit['headers']) => fetcher<GetGlobalApprovalStatusQuery, GetGlobalApprovalStatusQueryVariables>(client, GetGlobalApprovalStatusDocument, variables, headers);

export const GenerateIdentityTokenDocument = `
    mutation GenerateIdentityToken($userName: String!) {
  generateIdentityToken(userName: $userName) {
    token
  }
}
    `;

export const useGenerateIdentityTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GenerateIdentityTokenMutation, TError, GenerateIdentityTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<GenerateIdentityTokenMutation, TError, GenerateIdentityTokenMutationVariables, TContext>(
      {
    mutationKey: ['GenerateIdentityToken'],
    mutationFn: (variables?: GenerateIdentityTokenMutationVariables) => fetcher<GenerateIdentityTokenMutation, GenerateIdentityTokenMutationVariables>(client, GenerateIdentityTokenDocument, variables, headers)(),
    ...options
  }
    )};

useGenerateIdentityTokenMutation.getKey = () => ['GenerateIdentityToken'];


useGenerateIdentityTokenMutation.fetcher = (client: GraphQLClient, variables: GenerateIdentityTokenMutationVariables, headers?: RequestInit['headers']) => fetcher<GenerateIdentityTokenMutation, GenerateIdentityTokenMutationVariables>(client, GenerateIdentityTokenDocument, variables, headers);

export const GenerateTemporaryPasswordDocument = `
    mutation GenerateTemporaryPassword($userName: String!) {
  generateTemporaryPassword(userName: $userName) {
    tempPassword
  }
}
    `;

export const useGenerateTemporaryPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GenerateTemporaryPasswordMutation, TError, GenerateTemporaryPasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<GenerateTemporaryPasswordMutation, TError, GenerateTemporaryPasswordMutationVariables, TContext>(
      {
    mutationKey: ['GenerateTemporaryPassword'],
    mutationFn: (variables?: GenerateTemporaryPasswordMutationVariables) => fetcher<GenerateTemporaryPasswordMutation, GenerateTemporaryPasswordMutationVariables>(client, GenerateTemporaryPasswordDocument, variables, headers)(),
    ...options
  }
    )};

useGenerateTemporaryPasswordMutation.getKey = () => ['GenerateTemporaryPassword'];


useGenerateTemporaryPasswordMutation.fetcher = (client: GraphQLClient, variables: GenerateTemporaryPasswordMutationVariables, headers?: RequestInit['headers']) => fetcher<GenerateTemporaryPasswordMutation, GenerateTemporaryPasswordMutationVariables>(client, GenerateTemporaryPasswordDocument, variables, headers);

export const DeleteUserDocument = `
    mutation DeleteUser($userName: String!) {
  deleteUser(userName: $userName) {
    id
    userName
  }
}
    `;

export const useDeleteUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>(
      {
    mutationKey: ['DeleteUser'],
    mutationFn: (variables?: DeleteUserMutationVariables) => fetcher<DeleteUserMutation, DeleteUserMutationVariables>(client, DeleteUserDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteUserMutation.getKey = () => ['DeleteUser'];


useDeleteUserMutation.fetcher = (client: GraphQLClient, variables: DeleteUserMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteUserMutation, DeleteUserMutationVariables>(client, DeleteUserDocument, variables, headers);

export const SaveUserAvatarDocument = `
    mutation SaveUserAvatar($input: SaveAvatarInput!) {
  saveUserAvatar(input: $input) {
    url
  }
}
    `;

export const useSaveUserAvatarMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SaveUserAvatarMutation, TError, SaveUserAvatarMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SaveUserAvatarMutation, TError, SaveUserAvatarMutationVariables, TContext>(
      {
    mutationKey: ['SaveUserAvatar'],
    mutationFn: (variables?: SaveUserAvatarMutationVariables) => fetcher<SaveUserAvatarMutation, SaveUserAvatarMutationVariables>(client, SaveUserAvatarDocument, variables, headers)(),
    ...options
  }
    )};

useSaveUserAvatarMutation.getKey = () => ['SaveUserAvatar'];


useSaveUserAvatarMutation.fetcher = (client: GraphQLClient, variables: SaveUserAvatarMutationVariables, headers?: RequestInit['headers']) => fetcher<SaveUserAvatarMutation, SaveUserAvatarMutationVariables>(client, SaveUserAvatarDocument, variables, headers);

export const GetJobRolesDocument = `
    query GetJobRoles {
  getJobRoles {
    id
    name
    color
    createdAt
    updatedAt
  }
}
    `;

export const useGetJobRolesQuery = <
      TData = GetJobRolesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetJobRolesQueryVariables,
      options?: Omit<UseQueryOptions<GetJobRolesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetJobRolesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetJobRolesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetJobRoles'] : ['GetJobRoles', variables],
    queryFn: fetcher<GetJobRolesQuery, GetJobRolesQueryVariables>(client, GetJobRolesDocument, variables, headers),
    ...options
  }
    )};

useGetJobRolesQuery.document = GetJobRolesDocument;

useGetJobRolesQuery.getKey = (variables?: GetJobRolesQueryVariables) => variables === undefined ? ['GetJobRoles'] : ['GetJobRoles', variables];


useGetJobRolesQuery.fetcher = (client: GraphQLClient, variables?: GetJobRolesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetJobRolesQuery, GetJobRolesQueryVariables>(client, GetJobRolesDocument, variables, headers);

export const GetJobRoleByIdDocument = `
    query GetJobRoleById($id: ID!) {
  getJobRoleById(id: $id) {
    id
    name
    color
    createdAt
    updatedAt
  }
}
    `;

export const useGetJobRoleByIdQuery = <
      TData = GetJobRoleByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetJobRoleByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetJobRoleByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetJobRoleByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetJobRoleByIdQuery, TError, TData>(
      {
    queryKey: ['GetJobRoleById', variables],
    queryFn: fetcher<GetJobRoleByIdQuery, GetJobRoleByIdQueryVariables>(client, GetJobRoleByIdDocument, variables, headers),
    ...options
  }
    )};

useGetJobRoleByIdQuery.document = GetJobRoleByIdDocument;

useGetJobRoleByIdQuery.getKey = (variables: GetJobRoleByIdQueryVariables) => ['GetJobRoleById', variables];


useGetJobRoleByIdQuery.fetcher = (client: GraphQLClient, variables: GetJobRoleByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetJobRoleByIdQuery, GetJobRoleByIdQueryVariables>(client, GetJobRoleByIdDocument, variables, headers);

export const CreateJobRoleDocument = `
    mutation CreateJobRole($input: CreateJobRoleInput!) {
  createJobRole(input: $input) {
    id
    name
    color
    createdAt
    updatedAt
  }
}
    `;

export const useCreateJobRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateJobRoleMutation, TError, CreateJobRoleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateJobRoleMutation, TError, CreateJobRoleMutationVariables, TContext>(
      {
    mutationKey: ['CreateJobRole'],
    mutationFn: (variables?: CreateJobRoleMutationVariables) => fetcher<CreateJobRoleMutation, CreateJobRoleMutationVariables>(client, CreateJobRoleDocument, variables, headers)(),
    ...options
  }
    )};

useCreateJobRoleMutation.getKey = () => ['CreateJobRole'];


useCreateJobRoleMutation.fetcher = (client: GraphQLClient, variables: CreateJobRoleMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateJobRoleMutation, CreateJobRoleMutationVariables>(client, CreateJobRoleDocument, variables, headers);

export const UpdateJobRoleDocument = `
    mutation UpdateJobRole($input: UpdateJobRoleInput!) {
  updateJobRole(input: $input) {
    id
    name
    color
    createdAt
    updatedAt
  }
}
    `;

export const useUpdateJobRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateJobRoleMutation, TError, UpdateJobRoleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateJobRoleMutation, TError, UpdateJobRoleMutationVariables, TContext>(
      {
    mutationKey: ['UpdateJobRole'],
    mutationFn: (variables?: UpdateJobRoleMutationVariables) => fetcher<UpdateJobRoleMutation, UpdateJobRoleMutationVariables>(client, UpdateJobRoleDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateJobRoleMutation.getKey = () => ['UpdateJobRole'];


useUpdateJobRoleMutation.fetcher = (client: GraphQLClient, variables: UpdateJobRoleMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateJobRoleMutation, UpdateJobRoleMutationVariables>(client, UpdateJobRoleDocument, variables, headers);

export const DeleteJobRoleDocument = `
    mutation DeleteJobRole($id: ID!) {
  deleteJobRole(id: $id) {
    id
  }
}
    `;

export const useDeleteJobRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteJobRoleMutation, TError, DeleteJobRoleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteJobRoleMutation, TError, DeleteJobRoleMutationVariables, TContext>(
      {
    mutationKey: ['DeleteJobRole'],
    mutationFn: (variables?: DeleteJobRoleMutationVariables) => fetcher<DeleteJobRoleMutation, DeleteJobRoleMutationVariables>(client, DeleteJobRoleDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteJobRoleMutation.getKey = () => ['DeleteJobRole'];


useDeleteJobRoleMutation.fetcher = (client: GraphQLClient, variables: DeleteJobRoleMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteJobRoleMutation, DeleteJobRoleMutationVariables>(client, DeleteJobRoleDocument, variables, headers);

export const GetWorkScheduleWeekDocument = `
    query GetWorkScheduleWeek($weekStart: AWSDate!) {
  getWorkScheduleWeek(weekStart: $weekStart) {
    ...WorkScheduleWeekFragment
  }
}
    ${WorkScheduleWeekFragmentFragmentDoc}`;

export const useGetWorkScheduleWeekQuery = <
      TData = GetWorkScheduleWeekQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetWorkScheduleWeekQueryVariables,
      options?: Omit<UseQueryOptions<GetWorkScheduleWeekQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetWorkScheduleWeekQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetWorkScheduleWeekQuery, TError, TData>(
      {
    queryKey: ['GetWorkScheduleWeek', variables],
    queryFn: fetcher<GetWorkScheduleWeekQuery, GetWorkScheduleWeekQueryVariables>(client, GetWorkScheduleWeekDocument, variables, headers),
    ...options
  }
    )};

useGetWorkScheduleWeekQuery.document = GetWorkScheduleWeekDocument;

useGetWorkScheduleWeekQuery.getKey = (variables: GetWorkScheduleWeekQueryVariables) => ['GetWorkScheduleWeek', variables];


useGetWorkScheduleWeekQuery.fetcher = (client: GraphQLClient, variables: GetWorkScheduleWeekQueryVariables, headers?: RequestInit['headers']) => fetcher<GetWorkScheduleWeekQuery, GetWorkScheduleWeekQueryVariables>(client, GetWorkScheduleWeekDocument, variables, headers);

export const GetWorkScheduleMonthDocument = `
    query GetWorkScheduleMonth($monthStart: AWSDate!) {
  getWorkScheduleMonth(monthStart: $monthStart) {
    ...PlannedShiftFragment
  }
}
    ${PlannedShiftFragmentFragmentDoc}`;

export const useGetWorkScheduleMonthQuery = <
      TData = GetWorkScheduleMonthQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetWorkScheduleMonthQueryVariables,
      options?: Omit<UseQueryOptions<GetWorkScheduleMonthQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetWorkScheduleMonthQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetWorkScheduleMonthQuery, TError, TData>(
      {
    queryKey: ['GetWorkScheduleMonth', variables],
    queryFn: fetcher<GetWorkScheduleMonthQuery, GetWorkScheduleMonthQueryVariables>(client, GetWorkScheduleMonthDocument, variables, headers),
    ...options
  }
    )};

useGetWorkScheduleMonthQuery.document = GetWorkScheduleMonthDocument;

useGetWorkScheduleMonthQuery.getKey = (variables: GetWorkScheduleMonthQueryVariables) => ['GetWorkScheduleMonth', variables];


useGetWorkScheduleMonthQuery.fetcher = (client: GraphQLClient, variables: GetWorkScheduleMonthQueryVariables, headers?: RequestInit['headers']) => fetcher<GetWorkScheduleMonthQuery, GetWorkScheduleMonthQueryVariables>(client, GetWorkScheduleMonthDocument, variables, headers);

export const SavePlannedShiftDocument = `
    mutation SavePlannedShift($input: PlannedShiftInput!) {
  savePlannedShift(input: $input) {
    ...WorkScheduleWeekFragment
  }
}
    ${WorkScheduleWeekFragmentFragmentDoc}`;

export const useSavePlannedShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SavePlannedShiftMutation, TError, SavePlannedShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SavePlannedShiftMutation, TError, SavePlannedShiftMutationVariables, TContext>(
      {
    mutationKey: ['SavePlannedShift'],
    mutationFn: (variables?: SavePlannedShiftMutationVariables) => fetcher<SavePlannedShiftMutation, SavePlannedShiftMutationVariables>(client, SavePlannedShiftDocument, variables, headers)(),
    ...options
  }
    )};

useSavePlannedShiftMutation.getKey = () => ['SavePlannedShift'];


useSavePlannedShiftMutation.fetcher = (client: GraphQLClient, variables: SavePlannedShiftMutationVariables, headers?: RequestInit['headers']) => fetcher<SavePlannedShiftMutation, SavePlannedShiftMutationVariables>(client, SavePlannedShiftDocument, variables, headers);

export const DeletePlannedShiftDocument = `
    mutation DeletePlannedShift($id: ID!, $weekStart: AWSDate!) {
  deletePlannedShift(id: $id, weekStart: $weekStart) {
    id
  }
}
    `;

export const useDeletePlannedShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePlannedShiftMutation, TError, DeletePlannedShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeletePlannedShiftMutation, TError, DeletePlannedShiftMutationVariables, TContext>(
      {
    mutationKey: ['DeletePlannedShift'],
    mutationFn: (variables?: DeletePlannedShiftMutationVariables) => fetcher<DeletePlannedShiftMutation, DeletePlannedShiftMutationVariables>(client, DeletePlannedShiftDocument, variables, headers)(),
    ...options
  }
    )};

useDeletePlannedShiftMutation.getKey = () => ['DeletePlannedShift'];


useDeletePlannedShiftMutation.fetcher = (client: GraphQLClient, variables: DeletePlannedShiftMutationVariables, headers?: RequestInit['headers']) => fetcher<DeletePlannedShiftMutation, DeletePlannedShiftMutationVariables>(client, DeletePlannedShiftDocument, variables, headers);

export const PublishWorkScheduleWeekDocument = `
    mutation PublishWorkScheduleWeek($weekStart: AWSDate!) {
  publishWorkScheduleWeek(weekStart: $weekStart) {
    ...WorkScheduleWeekFragment
  }
}
    ${WorkScheduleWeekFragmentFragmentDoc}`;

export const usePublishWorkScheduleWeekMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PublishWorkScheduleWeekMutation, TError, PublishWorkScheduleWeekMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<PublishWorkScheduleWeekMutation, TError, PublishWorkScheduleWeekMutationVariables, TContext>(
      {
    mutationKey: ['PublishWorkScheduleWeek'],
    mutationFn: (variables?: PublishWorkScheduleWeekMutationVariables) => fetcher<PublishWorkScheduleWeekMutation, PublishWorkScheduleWeekMutationVariables>(client, PublishWorkScheduleWeekDocument, variables, headers)(),
    ...options
  }
    )};

usePublishWorkScheduleWeekMutation.getKey = () => ['PublishWorkScheduleWeek'];


usePublishWorkScheduleWeekMutation.fetcher = (client: GraphQLClient, variables: PublishWorkScheduleWeekMutationVariables, headers?: RequestInit['headers']) => fetcher<PublishWorkScheduleWeekMutation, PublishWorkScheduleWeekMutationVariables>(client, PublishWorkScheduleWeekDocument, variables, headers);

export const DiscardWorkScheduleWeekChangesDocument = `
    mutation DiscardWorkScheduleWeekChanges($weekStart: AWSDate!) {
  discardWorkScheduleWeekChanges(weekStart: $weekStart) {
    ...WorkScheduleWeekFragment
  }
}
    ${WorkScheduleWeekFragmentFragmentDoc}`;

export const useDiscardWorkScheduleWeekChangesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DiscardWorkScheduleWeekChangesMutation, TError, DiscardWorkScheduleWeekChangesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DiscardWorkScheduleWeekChangesMutation, TError, DiscardWorkScheduleWeekChangesMutationVariables, TContext>(
      {
    mutationKey: ['DiscardWorkScheduleWeekChanges'],
    mutationFn: (variables?: DiscardWorkScheduleWeekChangesMutationVariables) => fetcher<DiscardWorkScheduleWeekChangesMutation, DiscardWorkScheduleWeekChangesMutationVariables>(client, DiscardWorkScheduleWeekChangesDocument, variables, headers)(),
    ...options
  }
    )};

useDiscardWorkScheduleWeekChangesMutation.getKey = () => ['DiscardWorkScheduleWeekChanges'];


useDiscardWorkScheduleWeekChangesMutation.fetcher = (client: GraphQLClient, variables: DiscardWorkScheduleWeekChangesMutationVariables, headers?: RequestInit['headers']) => fetcher<DiscardWorkScheduleWeekChangesMutation, DiscardWorkScheduleWeekChangesMutationVariables>(client, DiscardWorkScheduleWeekChangesDocument, variables, headers);

export const AddPlannedShiftsDocument = `
    mutation AddPlannedShifts($weekStart: AWSDate!, $shifts: [NewPlannedShiftInput!]!) {
  addPlannedShifts(weekStart: $weekStart, shifts: $shifts) {
    ...WorkScheduleWeekFragment
  }
}
    ${WorkScheduleWeekFragmentFragmentDoc}`;

export const useAddPlannedShiftsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddPlannedShiftsMutation, TError, AddPlannedShiftsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<AddPlannedShiftsMutation, TError, AddPlannedShiftsMutationVariables, TContext>(
      {
    mutationKey: ['AddPlannedShifts'],
    mutationFn: (variables?: AddPlannedShiftsMutationVariables) => fetcher<AddPlannedShiftsMutation, AddPlannedShiftsMutationVariables>(client, AddPlannedShiftsDocument, variables, headers)(),
    ...options
  }
    )};

useAddPlannedShiftsMutation.getKey = () => ['AddPlannedShifts'];


useAddPlannedShiftsMutation.fetcher = (client: GraphQLClient, variables: AddPlannedShiftsMutationVariables, headers?: RequestInit['headers']) => fetcher<AddPlannedShiftsMutation, AddPlannedShiftsMutationVariables>(client, AddPlannedShiftsDocument, variables, headers);

export const ReplacePlannedShiftsDocument = `
    mutation ReplacePlannedShifts($weekStart: AWSDate!, $shifts: [NewPlannedShiftInput!]!, $requirements: [StaffingRequirementInput!]) {
  replacePlannedShifts(
    weekStart: $weekStart
    shifts: $shifts
    requirements: $requirements
  ) {
    ...WorkScheduleWeekFragment
  }
}
    ${WorkScheduleWeekFragmentFragmentDoc}`;

export const useReplacePlannedShiftsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReplacePlannedShiftsMutation, TError, ReplacePlannedShiftsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ReplacePlannedShiftsMutation, TError, ReplacePlannedShiftsMutationVariables, TContext>(
      {
    mutationKey: ['ReplacePlannedShifts'],
    mutationFn: (variables?: ReplacePlannedShiftsMutationVariables) => fetcher<ReplacePlannedShiftsMutation, ReplacePlannedShiftsMutationVariables>(client, ReplacePlannedShiftsDocument, variables, headers)(),
    ...options
  }
    )};

useReplacePlannedShiftsMutation.getKey = () => ['ReplacePlannedShifts'];


useReplacePlannedShiftsMutation.fetcher = (client: GraphQLClient, variables: ReplacePlannedShiftsMutationVariables, headers?: RequestInit['headers']) => fetcher<ReplacePlannedShiftsMutation, ReplacePlannedShiftsMutationVariables>(client, ReplacePlannedShiftsDocument, variables, headers);

export const GetMyWorkTimeStatusDocument = `
    query GetMyWorkTimeStatus {
  getMyWorkTimeStatus {
    state
    activeSession {
      id
      startedAt
    }
  }
}
    `;

export const useGetMyWorkTimeStatusQuery = <
      TData = GetMyWorkTimeStatusQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMyWorkTimeStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetMyWorkTimeStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMyWorkTimeStatusQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMyWorkTimeStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetMyWorkTimeStatus'] : ['GetMyWorkTimeStatus', variables],
    queryFn: fetcher<GetMyWorkTimeStatusQuery, GetMyWorkTimeStatusQueryVariables>(client, GetMyWorkTimeStatusDocument, variables, headers),
    ...options
  }
    )};

useGetMyWorkTimeStatusQuery.document = GetMyWorkTimeStatusDocument;

useGetMyWorkTimeStatusQuery.getKey = (variables?: GetMyWorkTimeStatusQueryVariables) => variables === undefined ? ['GetMyWorkTimeStatus'] : ['GetMyWorkTimeStatus', variables];


useGetMyWorkTimeStatusQuery.fetcher = (client: GraphQLClient, variables?: GetMyWorkTimeStatusQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMyWorkTimeStatusQuery, GetMyWorkTimeStatusQueryVariables>(client, GetMyWorkTimeStatusDocument, variables, headers);

export const StartMyWorkTimeShiftDocument = `
    mutation StartMyWorkTimeShift {
  startMyWorkTimeShift {
    id
    userId
    startedAt
  }
}
    `;

export const useStartMyWorkTimeShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<StartMyWorkTimeShiftMutation, TError, StartMyWorkTimeShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<StartMyWorkTimeShiftMutation, TError, StartMyWorkTimeShiftMutationVariables, TContext>(
      {
    mutationKey: ['StartMyWorkTimeShift'],
    mutationFn: (variables?: StartMyWorkTimeShiftMutationVariables) => fetcher<StartMyWorkTimeShiftMutation, StartMyWorkTimeShiftMutationVariables>(client, StartMyWorkTimeShiftDocument, variables, headers)(),
    ...options
  }
    )};

useStartMyWorkTimeShiftMutation.getKey = () => ['StartMyWorkTimeShift'];


useStartMyWorkTimeShiftMutation.fetcher = (client: GraphQLClient, variables?: StartMyWorkTimeShiftMutationVariables, headers?: RequestInit['headers']) => fetcher<StartMyWorkTimeShiftMutation, StartMyWorkTimeShiftMutationVariables>(client, StartMyWorkTimeShiftDocument, variables, headers);

export const FinishMyWorkTimeShiftDocument = `
    mutation FinishMyWorkTimeShift {
  finishMyWorkTimeShift {
    id
    userId
    startedAt
    endedAt
    totalMinutes
  }
}
    `;

export const useFinishMyWorkTimeShiftMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FinishMyWorkTimeShiftMutation, TError, FinishMyWorkTimeShiftMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FinishMyWorkTimeShiftMutation, TError, FinishMyWorkTimeShiftMutationVariables, TContext>(
      {
    mutationKey: ['FinishMyWorkTimeShift'],
    mutationFn: (variables?: FinishMyWorkTimeShiftMutationVariables) => fetcher<FinishMyWorkTimeShiftMutation, FinishMyWorkTimeShiftMutationVariables>(client, FinishMyWorkTimeShiftDocument, variables, headers)(),
    ...options
  }
    )};

useFinishMyWorkTimeShiftMutation.getKey = () => ['FinishMyWorkTimeShift'];


useFinishMyWorkTimeShiftMutation.fetcher = (client: GraphQLClient, variables?: FinishMyWorkTimeShiftMutationVariables, headers?: RequestInit['headers']) => fetcher<FinishMyWorkTimeShiftMutation, FinishMyWorkTimeShiftMutationVariables>(client, FinishMyWorkTimeShiftDocument, variables, headers);

export const GetMyWorkTimeEntriesByDateRangeDocument = `
    query GetMyWorkTimeEntriesByDateRange($input: GetMyWorkTimeEntriesInput) {
  getMyWorkTimeEntriesByDateRange(input: $input) {
    id
    userId
    startedAt
    endedAt
    totalMinutes
    status
    note
    createdAt
    updatedAt
  }
}
    `;

export const useGetMyWorkTimeEntriesByDateRangeQuery = <
      TData = GetMyWorkTimeEntriesByDateRangeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMyWorkTimeEntriesByDateRangeQueryVariables,
      options?: Omit<UseQueryOptions<GetMyWorkTimeEntriesByDateRangeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMyWorkTimeEntriesByDateRangeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMyWorkTimeEntriesByDateRangeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetMyWorkTimeEntriesByDateRange'] : ['GetMyWorkTimeEntriesByDateRange', variables],
    queryFn: fetcher<GetMyWorkTimeEntriesByDateRangeQuery, GetMyWorkTimeEntriesByDateRangeQueryVariables>(client, GetMyWorkTimeEntriesByDateRangeDocument, variables, headers),
    ...options
  }
    )};

useGetMyWorkTimeEntriesByDateRangeQuery.document = GetMyWorkTimeEntriesByDateRangeDocument;

useGetMyWorkTimeEntriesByDateRangeQuery.getKey = (variables?: GetMyWorkTimeEntriesByDateRangeQueryVariables) => variables === undefined ? ['GetMyWorkTimeEntriesByDateRange'] : ['GetMyWorkTimeEntriesByDateRange', variables];


useGetMyWorkTimeEntriesByDateRangeQuery.fetcher = (client: GraphQLClient, variables?: GetMyWorkTimeEntriesByDateRangeQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMyWorkTimeEntriesByDateRangeQuery, GetMyWorkTimeEntriesByDateRangeQueryVariables>(client, GetMyWorkTimeEntriesByDateRangeDocument, variables, headers);

export const GetWorkTimeEntriesByDateRangeDocument = `
    query GetWorkTimeEntriesByDateRange($input: GetWorkTimeEntriesInput) {
  getWorkTimeEntriesByDateRange(input: $input) {
    id
    userId
    startedAt
    endedAt
    totalMinutes
    status
    note
    createdAt
    updatedAt
  }
}
    `;

export const useGetWorkTimeEntriesByDateRangeQuery = <
      TData = GetWorkTimeEntriesByDateRangeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetWorkTimeEntriesByDateRangeQueryVariables,
      options?: Omit<UseQueryOptions<GetWorkTimeEntriesByDateRangeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetWorkTimeEntriesByDateRangeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetWorkTimeEntriesByDateRangeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetWorkTimeEntriesByDateRange'] : ['GetWorkTimeEntriesByDateRange', variables],
    queryFn: fetcher<GetWorkTimeEntriesByDateRangeQuery, GetWorkTimeEntriesByDateRangeQueryVariables>(client, GetWorkTimeEntriesByDateRangeDocument, variables, headers),
    ...options
  }
    )};

useGetWorkTimeEntriesByDateRangeQuery.document = GetWorkTimeEntriesByDateRangeDocument;

useGetWorkTimeEntriesByDateRangeQuery.getKey = (variables?: GetWorkTimeEntriesByDateRangeQueryVariables) => variables === undefined ? ['GetWorkTimeEntriesByDateRange'] : ['GetWorkTimeEntriesByDateRange', variables];


useGetWorkTimeEntriesByDateRangeQuery.fetcher = (client: GraphQLClient, variables?: GetWorkTimeEntriesByDateRangeQueryVariables, headers?: RequestInit['headers']) => fetcher<GetWorkTimeEntriesByDateRangeQuery, GetWorkTimeEntriesByDateRangeQueryVariables>(client, GetWorkTimeEntriesByDateRangeDocument, variables, headers);

export const GetWorkTimeEntryDocument = `
    query GetWorkTimeEntry($id: ID!) {
  getWorkTimeEntry(id: $id) {
    id
    userId
    startedAt
    endedAt
    totalMinutes
    status
    note
    createdAt
    updatedAt
  }
}
    `;

export const useGetWorkTimeEntryQuery = <
      TData = GetWorkTimeEntryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetWorkTimeEntryQueryVariables,
      options?: Omit<UseQueryOptions<GetWorkTimeEntryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetWorkTimeEntryQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetWorkTimeEntryQuery, TError, TData>(
      {
    queryKey: ['GetWorkTimeEntry', variables],
    queryFn: fetcher<GetWorkTimeEntryQuery, GetWorkTimeEntryQueryVariables>(client, GetWorkTimeEntryDocument, variables, headers),
    ...options
  }
    )};

useGetWorkTimeEntryQuery.document = GetWorkTimeEntryDocument;

useGetWorkTimeEntryQuery.getKey = (variables: GetWorkTimeEntryQueryVariables) => ['GetWorkTimeEntry', variables];


useGetWorkTimeEntryQuery.fetcher = (client: GraphQLClient, variables: GetWorkTimeEntryQueryVariables, headers?: RequestInit['headers']) => fetcher<GetWorkTimeEntryQuery, GetWorkTimeEntryQueryVariables>(client, GetWorkTimeEntryDocument, variables, headers);

export const ApproveWorkTimeEntryDocument = `
    mutation ApproveWorkTimeEntry($id: ID!) {
  approveWorkTimeEntry(id: $id) {
    id
    userId
    startedAt
    endedAt
    totalMinutes
    status
    note
    createdAt
    updatedAt
  }
}
    `;

export const useApproveWorkTimeEntryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApproveWorkTimeEntryMutation, TError, ApproveWorkTimeEntryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ApproveWorkTimeEntryMutation, TError, ApproveWorkTimeEntryMutationVariables, TContext>(
      {
    mutationKey: ['ApproveWorkTimeEntry'],
    mutationFn: (variables?: ApproveWorkTimeEntryMutationVariables) => fetcher<ApproveWorkTimeEntryMutation, ApproveWorkTimeEntryMutationVariables>(client, ApproveWorkTimeEntryDocument, variables, headers)(),
    ...options
  }
    )};

useApproveWorkTimeEntryMutation.getKey = () => ['ApproveWorkTimeEntry'];


useApproveWorkTimeEntryMutation.fetcher = (client: GraphQLClient, variables: ApproveWorkTimeEntryMutationVariables, headers?: RequestInit['headers']) => fetcher<ApproveWorkTimeEntryMutation, ApproveWorkTimeEntryMutationVariables>(client, ApproveWorkTimeEntryDocument, variables, headers);

export const RejectWorkTimeEntryDocument = `
    mutation RejectWorkTimeEntry($input: RejectWorkTimeEntryInput!) {
  rejectWorkTimeEntry(input: $input) {
    id
    userId
    startedAt
    endedAt
    totalMinutes
    status
    note
    createdAt
    updatedAt
  }
}
    `;

export const useRejectWorkTimeEntryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RejectWorkTimeEntryMutation, TError, RejectWorkTimeEntryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<RejectWorkTimeEntryMutation, TError, RejectWorkTimeEntryMutationVariables, TContext>(
      {
    mutationKey: ['RejectWorkTimeEntry'],
    mutationFn: (variables?: RejectWorkTimeEntryMutationVariables) => fetcher<RejectWorkTimeEntryMutation, RejectWorkTimeEntryMutationVariables>(client, RejectWorkTimeEntryDocument, variables, headers)(),
    ...options
  }
    )};

useRejectWorkTimeEntryMutation.getKey = () => ['RejectWorkTimeEntry'];


useRejectWorkTimeEntryMutation.fetcher = (client: GraphQLClient, variables: RejectWorkTimeEntryMutationVariables, headers?: RequestInit['headers']) => fetcher<RejectWorkTimeEntryMutation, RejectWorkTimeEntryMutationVariables>(client, RejectWorkTimeEntryDocument, variables, headers);

export const CreateWorkTimeEntryDocument = `
    mutation CreateWorkTimeEntry($input: CreateWorkTimeEntryInput!) {
  createWorkTimeEntry(input: $input) {
    id
    userId
    startedAt
    endedAt
    totalMinutes
    status
    note
    createdAt
    updatedAt
  }
}
    `;

export const useCreateWorkTimeEntryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateWorkTimeEntryMutation, TError, CreateWorkTimeEntryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateWorkTimeEntryMutation, TError, CreateWorkTimeEntryMutationVariables, TContext>(
      {
    mutationKey: ['CreateWorkTimeEntry'],
    mutationFn: (variables?: CreateWorkTimeEntryMutationVariables) => fetcher<CreateWorkTimeEntryMutation, CreateWorkTimeEntryMutationVariables>(client, CreateWorkTimeEntryDocument, variables, headers)(),
    ...options
  }
    )};

useCreateWorkTimeEntryMutation.getKey = () => ['CreateWorkTimeEntry'];


useCreateWorkTimeEntryMutation.fetcher = (client: GraphQLClient, variables: CreateWorkTimeEntryMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateWorkTimeEntryMutation, CreateWorkTimeEntryMutationVariables>(client, CreateWorkTimeEntryDocument, variables, headers);

export const UpdateWorkTimeEntryDocument = `
    mutation UpdateWorkTimeEntry($input: UpdateWorkTimeEntryInput!) {
  updateWorkTimeEntry(input: $input) {
    id
    userId
    startedAt
    endedAt
    totalMinutes
    status
    note
    createdAt
    updatedAt
  }
}
    `;

export const useUpdateWorkTimeEntryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateWorkTimeEntryMutation, TError, UpdateWorkTimeEntryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateWorkTimeEntryMutation, TError, UpdateWorkTimeEntryMutationVariables, TContext>(
      {
    mutationKey: ['UpdateWorkTimeEntry'],
    mutationFn: (variables?: UpdateWorkTimeEntryMutationVariables) => fetcher<UpdateWorkTimeEntryMutation, UpdateWorkTimeEntryMutationVariables>(client, UpdateWorkTimeEntryDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateWorkTimeEntryMutation.getKey = () => ['UpdateWorkTimeEntry'];


useUpdateWorkTimeEntryMutation.fetcher = (client: GraphQLClient, variables: UpdateWorkTimeEntryMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateWorkTimeEntryMutation, UpdateWorkTimeEntryMutationVariables>(client, UpdateWorkTimeEntryDocument, variables, headers);

export const DeleteWorkTimeEntryDocument = `
    mutation DeleteWorkTimeEntry($id: ID!) {
  deleteWorkTimeEntry(id: $id) {
    id
  }
}
    `;

export const useDeleteWorkTimeEntryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteWorkTimeEntryMutation, TError, DeleteWorkTimeEntryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteWorkTimeEntryMutation, TError, DeleteWorkTimeEntryMutationVariables, TContext>(
      {
    mutationKey: ['DeleteWorkTimeEntry'],
    mutationFn: (variables?: DeleteWorkTimeEntryMutationVariables) => fetcher<DeleteWorkTimeEntryMutation, DeleteWorkTimeEntryMutationVariables>(client, DeleteWorkTimeEntryDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteWorkTimeEntryMutation.getKey = () => ['DeleteWorkTimeEntry'];


useDeleteWorkTimeEntryMutation.fetcher = (client: GraphQLClient, variables: DeleteWorkTimeEntryMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteWorkTimeEntryMutation, DeleteWorkTimeEntryMutationVariables>(client, DeleteWorkTimeEntryDocument, variables, headers);
